import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { ApplicationState } from "../store/index";
import * as OxyStore from "../store/OxyStore";
import { NavMenu } from "./NavMenu";
import { Footer } from "./Footer";
import { isMobileOnly } from "react-device-detect";
import Typewriter from "typewriter-effect";

type InfraTrainerProps = OxyStore.OxyState &
  typeof OxyStore.actionCreators &
  RouteComponentProps<{}>;

const typewriterTexts = [
  "hozzájárul a gyors testsúly-csökkenéshez",
  "segít elérni a megfelelő testsúlyt és kondíciót",
  "támogatja a szervezet méregtelenítő folyamatait",
  "rendkívül eredményes a narancsbőr kezelésében",
  "aktiválja a nyirok- és vérkeringést",
  "erősíti az immunrendszert",
  "mérsékli a mozgásszervi panaszokat",
  "fontos szerepet játszik a szív-, érrendszeri és egyéb betegségek megelőzésében",
  "regenerálja a sérült szöveteket",
  "bőrszépítő hatása van",
  "hozzásegít egy általános jobb közérzet kialakításához és megtartásához",
  "fokozza a fizikai teljesítő- és állóképességet",
];

const infratrainerCss = `
html {
    font-family: sans-serif;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
}

body {
    margin: 0;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
    display: block;
}

audio, canvas, progress, video {
    display: inline-block;
    vertical-align: baseline;
}

    audio:not([controls]) {
        display: none;
        height: 0;
    }

[hidden], template {
    display: none;
}

a {
    background: transparent;
}

    a:active, a:hover {
        outline: 0;
    }

abbr[title] {
    border-bottom: 1px dotted;
}

b, strong {
    font-weight: bold;
}

dfn {
    font-style: italic;
}

h1 {
    font-size: 2em;
    margin: 0.67em 0;
}

mark {
    background: #ff0;
    color: #000;
}

small {
    font-size: 80%;
}

sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
}

sup {
    top: -0.5em;
}

sub {
    bottom: -0.25em;
}

img {
    border: 0;
}

svg:not(:root) {
    overflow: hidden;
}

figure {
    margin: 1em 40px;
}

hr {
    -moz-box-sizing: content-box;
    box-sizing: content-box;
    height: 0;
}

pre {
    overflow: auto;
}

code, kbd, pre, samp {
    font-family: monospace, monospace;
    font-size: 1em;
}

button, input, optgroup, select, textarea {
    color: inherit;
    font: inherit;
    margin: 0;
}

button {
    overflow: visible;
}

button, select {
    text-transform: none;
}

button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
    -webkit-appearance: button;
    cursor: pointer;
}

    button[disabled], html input[disabled] {
        cursor: default;
    }

    button::-moz-focus-inner, input::-moz-focus-inner {
        border: 0;
        padding: 0;
    }

input {
    line-height: normal;
}

    input[type="checkbox"], input[type="radio"] {
        box-sizing: border-box;
        padding: 0;
    }

    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        height: auto;
    }

    input[type="search"] {
        -webkit-appearance: textfield;
        -moz-box-sizing: content-box;
        -webkit-box-sizing: content-box;
        box-sizing: content-box;
    }

        input[type="search"]::-webkit-search-cancel-button,
        input[type="search"]::-webkit-search-decoration {
            -webkit-appearance: none;
        }

fieldset {
    border: 1px solid #c0c0c0;
    margin: 0 2px;
    padding: 0.35em 0.625em 0.75em;
}

legend {
    border: 0;
    padding: 0;
}

textarea {
    overflow: auto;
}

optgroup {
    font-weight: bold;
}

table {
    border-collapse: collapse;
    border-spacing: 0;
}

td, th {
    padding: 0;
}

div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, form, p, blockquote, th, td {
    margin: 0;
    padding: 0;
}

h1, h2, h3, h4, h5, h6 {
    -webkit-font-variant-ligatures: common-ligatures;
    -moz-font-variant-ligatures: common-ligatures;
    font-variant-ligatures: common-ligatures;
    text-rendering: optimizeLegibility;
}

em, i {
    font-style: italic;
    line-height: inherit;
}

strong, b {
    font-weight: bold;
    line-height: inherit;
}

small {
    font-size: 60%;
    line-height: inherit;
}

ol, ul {
    list-style: none;
}

li {
    display: block;
}

/**
 * links
 * -
 */

a {
    text-decoration: none;
    line-height: inherit;
}

    a img {
        border: none;
    }

/**
 * inputs
 * -
 */

fieldset {
    margin: 0;
    padding: 0;
}

input[type="email"],
input[type="number"],
input[type="search"],
input[type="text"],
input[type="tel"],
input[type="url"],
input[type="password"],
textarea {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    -o-appearance: none;
    appearance: none;
}

/** 
 * ===================================================================
 * grid
 *
 * ------------------------------------------------------------------- 
 */

.row {
    width: 94%;
    max-width: 1140px;
    margin: 0 auto;
}

    .row:before, .row:after {
        content: "";
        display: table;
    }

    .row:after {
        clear: both;
    }

    .row .row {
        width: auto;
        max-width: none;
        margin-left: -20px;
        margin-right: -20px;
    }

[class*="col-"], .bgrid {
    float: left;
}

    [class*="col-"] + [class*="col-"]:last-child {
        float: right;
    }

[class*="col-"] {
    padding: 0 20px;
}

.col-one {
    width: 8.33333%;
}

.col-two, .col-1-6 {
    width: 16.66667%;
}

.col-three, .col-1-4 {
    width: 25%;
}

.col-four, .col-1-3 {
    width: 33.33333%;
}

.col-five {
    width: 41.66667%;
}

.col-six, .col-1-2 {
    width: 50%;
}

.col-seven {
    width: 58.33333%;
}

.col-eight, .col-2-3 {
    width: 66.66667%;
}

.col-nine, .col-3-4 {
    width: 75%;
}

.col-ten, .col-5-6 {
    width: 83.33333%;
}

.col-eleven {
    width: 91.66667%;
}

.col-twelve, .col-full {
    width: 100%;
}

/**
 * small screens
 * --------------------------------------------------------------- 
 */

@media screen and (max-width:1024px) {
    .row .row {
        margin-left: -18px;
        margin-right: -18px;
    }

    [class*="col-"] {
        padding: 0 18px;
    }
}

/**
 * tablets
 * --------------------------------------------------------------- 
 */

@media screen and (max-width:768px) {
    .row {
        width: auto;
        padding-left: 30px;
        padding-right: 30px;
    }

        .row .row {
            padding-left: 0;
            padding-right: 0;
            margin-left: -15px;
            margin-right: -15px;
        }

    [class*="col-"] {
        padding: 0 15px;
    }

    .tab-1-4 {
        width: 25%;
    }

    .tab-1-3 {
        width: 33.33333%;
    }

    .tab-1-2 {
        width: 50%;
    }

    .tab-2-3 {
        width: 66.66667%;
    }

    .tab-3-4 {
        width: 75%;
    }

    .tab-full {
        width: 100%;
    }
}

/**
 * large mobile devices
 * --------------------------------------------------------------- 
 */

@media screen and (max-width:600px) {
    .row {
        padding-left: 25px;
        padding-right: 25px;
    }

        .row .row {
            margin-left: -10px;
            margin-right: -10px;
        }

    [class*="col-"] {
        padding: 0 10px;
    }

    .mob-1-4 {
        width: 25%;
    }

    .mob-1-2 {
        width: 50%;
    }

    .mob-3-4 {
        width: 75%;
    }

    .mob-full {
        width: 100%;
    }
}

/**
 * small mobile devices
 * --------------------------------------------------------------- 
 */

@media screen and (max-width:400px) {
    .row {
        padding-left: 30px;
        padding-right: 30px;
    }

        .row .row {
            padding-left: 0;
            padding-right: 0;
            margin-left: 0;
            margin-right: 0;
        }

    [class*="col-"] {
        width: 100% !important;
        float: none !important;
        clear: both !important;
        margin-left: 0;
        margin-right: 0;
        padding: 0;
    }

        [class*="col-"] + [class*="col-"]:last-child {
            float: none;
        }
}

/** 
 * ===================================================================
 * block grids 
 *
 * ------------------------------------------------------------------- 
 */

.block-1-6 .bgrid {
    width: 16.66667%;
}

.block-1-4 .bgrid {
    width: 25%;
}

.block-1-3 .bgrid {
    width: 33.33333%;
}

.block-1-2 .bgrid {
    width: 50%;
}

    /**
 * Clearing for block grid columns. Allow columns with 
 * different heights to align properly.
 */

    .block-1-6 .bgrid:nth-child(6n+1),
    .block-1-4 .bgrid:nth-child(4n+1),
    .block-1-3 .bgrid:nth-child(3n+1),
    .block-1-2 .bgrid:nth-child(2n+1) {
        clear: both;
    }

/**
 * small screens
 * --------------------------------------------------------------- 
 */
@media screen and (max-width:1024px) {
    .block-s-1-6 .bgrid {
        width: 16.66667%;
    }

    .block-s-1-4 .bgrid {
        width: 25%;
    }

    .block-s-1-3 .bgrid {
        width: 33.33333%;
    }

    .block-s-1-2 .bgrid {
        width: 50%;
    }

    .block-s-full .bgrid {
        width: 100%;
        clear: both;
    }

    [class*="block-s-"] .bgrid:nth-child(n) {
        clear: none;
    }

    .block-s-1-6 .bgrid:nth-child(6n+1),
    .block-s-1-4 .bgrid:nth-child(4n+1),
    .block-s-1-3 .bgrid:nth-child(3n+1),
    .block-s-1-2 .bgrid:nth-child(2n+1) {
        clear: both;
    }
}

/**
 * tablets
 * --------------------------------------------------------------- 
 */
@media screen and (max-width:768px) {
    .block-tab-1-6 .bgrid {
        width: 16.66667%;
    }

    .block-tab-1-4 .bgrid {
        width: 25%;
    }

    .block-tab-1-3 .bgrid {
        width: 33.33333%;
    }

    .block-tab-1-2 .bgrid {
        width: 50%;
    }

    .block-tab-full .bgrid {
        width: 100%;
        clear: both;
    }

    [class*="tab-bgrid-"] .bgrid:nth-child(n) {
        clear: none;
    }

    .block-tab-1-6 .bgrid:nth-child(6n+1),
    .block-tab-1-4 .bgrid:nth-child(4n+1),
    .block-tab-1-3 .bgrid:nth-child(3n+1),
    .block-tab-1-2 .bgrid:nth-child(2n+1) {
        clear: both;
    }
}

/**
 * mobile devices
 * --------------------------------------------------------------- 
 */
@media screen and (max-width:600px) {
    .block-mob-1-6 .bgrid {
        width: 16.66667%;
    }

    .block-mob-1-4 .bgrid {
        width: 25%;
    }

    .block-mob-1-3 .bgrid {
        width: 33.33333%;
    }

    .block-mob-1-2 .bgrid {
        width: 50%;
    }

    .block-mob-full .bgrid {
        width: 100%;
        clear: both;
    }

    [class*="mob-bgrid-"] .bgrid:nth-child(n) {
        clear: none;
    }

    .block-mob-1-6 .bgrid:nth-child(6n+1),
    .block-mob-1-4 .bgrid:nth-child(4n+1),
    .block-mob-1-3 .bgrid:nth-child(3n+1),
    .block-mob-1-2 .bgrid:nth-child(2n+1) {
        clear: both;
    }
}

/**
 * stack on small mobile devices
 * --------------------------------------------------------------- 
 */

@media screen and (max-width:400px) {
    .stack .bgrid {
        width: 100% !important;
        float: none !important;
        clear: both !important;
        margin-left: 0;
        margin-right: 0;
    }
}

/** 
 * ===================================================================
 * MISC 
 *
 * ------------------------------------------------------------------- 
 */

/**
 * Clearing - (http://nicolasgallagher.com/micro-clearfix-hack/
 * -
 */

.group:before, .group:after {
    content: "";
    display: table;
}

.group:after {
    clear: both;
}

/**
 * Misc Helper Styles 
 * -
 */

.hide {
    display: none;
}

.invisible {
    visibility: hidden;
}

.antialiased {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.remove-bottom {
    margin-bottom: 0;
}

.half-bottom {
    margin-bottom: 1.5rem !important;
}

.add-bottom {
    margin-bottom: 3rem !important;
}

.no-border {
    border: none;
}

.full-width {
    width: 100%;
}

.text-center {
    text-align: center;
}

.text-left {
    text-align: left;
}

.text-right {
    text-align: right;
}

.pull-left {
    float: left;
}

.pull-right {
    float: right;
}

.align-center {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
}

/** 
 * ===================================================================
 * base style overrides
 *
 * ------------------------------------------------------------------- 
 */

html {
    font-size: 10px;
}

@media only screen and (max-width:1024px) {
    html {
        font-size: 9.375px;
    }
}

@media only screen and (max-width:768px) {
    html {
        font-size: 10px;
    }
}

@media only screen and (max-width:400px) {
    html {
        font-size: 9.375px;
    }
}

html, body {
    height: 100%;
}

h1, h2, h3, h4, h5, h6, .h01, .h02, .h03, .h04, .h05, .h06 {
    font-family: "raleway-bold", sans-serif;
    color: #252525;
    font-style: normal;
    text-rendering: optimizeLegibility;
    margin-bottom: 2.1rem;
}

h3, .h03, h4, .h04 {
    margin-bottom: 1.8rem;
}

h5, .h05, h6, .h06 {
    font-family: "raleway-heavy";
    margin-bottom: 1.2rem;
}

h1, .h01 {
    font-size: 3.1rem;
    line-height: 1.35;
    letter-spacing: -.1rem;
}

@media only screen and (max-width:600px) {
    h1, .h01 {
        font-size: 2.6rem;
        letter-spacing: -.07rem;
    }
}

h2, .h02 {
    font-size: 2.4rem;
    line-height: 1.25;
}

h3, .h03 {
    font-size: 2rem;
    line-height: 1.5;
}

h4, .h04 {
    font-size: 1.7rem;
    line-height: 1.76;
}

h5, .h05 {
    font-size: 1.4rem;
    line-height: 1.7;
    text-transform: uppercase;
    letter-spacing: .15rem;
}

h6, .h06 {
    font-size: 1.3rem;
    line-height: 1.85;
    text-transform: uppercase;
    letter-spacing: .15rem;
}

p img {
    margin: 0;
}

p.lead {
    font-family: "merriweather-light", serif;
    font-size: 1.8rem;
    line-height: 1.8;
    color: #737373;
}

@media only screen and (max-width:768px) {
    p.lead {
        font-size: 1.7rem;
    }
}

em, i, strong, b {
    font-size: 1.6rem;
    line-height: 3rem;
    font-style: normal;
    font-weight: normal;
}

em, i {
    font-family: "merriweather-italic", serif;
}

strong, b {
    font-family: "merriweather-bold", serif;
}

small {
    font-size: 1.1rem;
    line-height: inherit;
}

blockquote {
    margin: 3rem 0;
    padding-left: 4rem;
    position: relative;
}

    blockquote:before {
        content: "\\201C";
        font-size: 8rem;
        line-height: 0px;
        margin: 0;
        color: #333;
        font-family: arial, sans-serif;
        position: absolute;
        top: 3rem;
        left: 0;
    }

    blockquote p {
        font-family: georgia, serif;
        font-style: italic;
        padding: 0;
        font-size: 1.9rem;
        line-height: 1.75;
    }

    blockquote cite {
        display: block;
        font-size: 1.2rem;
        font-style: normal;
        line-height: 1.65;
    }

        blockquote cite:before {
            content: "\\2014 \\0020";
        }

        blockquote cite a, blockquote cite a:visited {
            color: #8d8d8d;
            border: none;
        }

abbr {
    font-family: "merriweather-bold", serif;
    font-variant: small-caps;
    text-transform: lowercase;
    letter-spacing: .05rem;
    color: #8d8d8d;
}

var, kbd, samp, code, pre {
    font-family: Consolas, "Andale Mono", Courier, "Courier New", monospace;
}

pre {
    padding: 2.4rem 3rem 3rem;
    background: #F1F1F1;
}

code {
    font-size: 1.4rem;
    margin: 0 .2rem;
    padding: .3rem .6rem;
    white-space: nowrap;
    background: #F1F1F1;
    border: 1px solid #E1E1E1;
    border-radius: 3px;
}

pre > code {
    display: block;
    white-space: pre;
    line-height: 2;
    padding: 0;
    margin: 0;
}

pre.prettyprint > code {
    border: none;
}

del {
    text-decoration: line-through;
}

abbr[title], dfn[title] {
    border-bottom: 1px dotted;
    cursor: help;
}

mark {
    background: #FFF49B;
    color: #000;
}

hr {
    border: solid #cfcfd5;
    border-width: 1px 0 0;
    clear: both;
    margin: 2.4rem 0 1.5rem;
    height: 0;
}

/**
 * Lists  
 * -
 */

ol {
    list-style: decimal;
}

ul {
    list-style: disc;
}

li {
    display: list-item;
}

ol, ul {
    margin-left: 1.7rem;
}

    ul li {
        padding-left: .4rem;
    }

    ul ul, ul ol, ol ol, ol ul {
        margin: .6rem 0 .6rem 1.7rem;
    }

    ul.disc li {
        display: list-item;
        list-style: none;
        padding: 0 0 0 .8rem;
        position: relative;
    }

        ul.disc li::before {
            content: "";
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: rgb(177, 139, 94);
            position: absolute;
            left: -17px;
            top: 11px;
            vertical-align: middle;
        }

dt {
    margin: 0;
    color: rgb(177, 139, 94);
}

dd {
    margin: 0 0 0 2rem;
}

/**
 * tables  
 * -
 */

table {
    border-width: 0;
    width: 100%;
    max-width: 100%;
    font-family: "raleway-regular", sans-serif;
}

th, td {
    padding: 1.5rem 3rem;
    text-align: left;
    border-bottom: 1px solid #E8E8E8;
}

th {
    color: #252525;
    font-family: "raleway-bold", sans-serif;
}

td {
    line-height: 1.5;
}

    th:first-child, td:first-child {
        padding-left: 0;
    }

    th:last-child, td:last-child {
        padding-right: 0;
    }

.table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

/**
 * Spacing  
 * -
 */

button, .button {
    margin-bottom: 1.2;
}

fieldset {
    margin-bottom: 1.5rem;
}

input,
textarea,
select,
pre,
blockquote,
figure,
table,
p,
ul,
ol,
dl,
form,
.fluid-video-wrapper,
.iw-custom-select {
    margin-bottom: 3rem;
}

/**
 * floated image  
 * -
 */

img.pull-right {
    margin: 1.5rem 0 0 3rem;
}

img.pull-left {
    margin: 1.5rem 3rem 0 0;
}

/**
 * block grids paddings 
 * -
 */

.bgrid {
    padding: 0 20px;
}

@media only screen and (max-width:1024px) {
    .bgrid {
        padding: 0 18px;
    }
}

@media only screen and (max-width:768px) {
    .bgrid {
        padding: 0 15px;
    }
}

@media only screen and (max-width:600px) {
    .bgrid {
        padding: 0 10px;
    }
}

@media only screen and (max-width:400px) {
    .bgrid {
        padding: 0;
    }
}


/** 
 * ===================================================================
 * preloader
 *
 * ------------------------------------------------------------------- 
 */

#preloader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #00d9ec;
    z-index: 9999999;
    height: 100%;
    width: 100%;
}

.no-js #preloader, .oldie #preloader {
    display: none;
}

#loader {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 60px;
    height: 60px;
    margin-left: -30px;
    margin-top: -30px;
    padding: 0;
    background-color: white;
    border-radius: 100%;
    -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
    animation: sk-scaleout 1.0s infinite ease-in-out;
}

@-webkit-keyframes sk-scaleout {
    0% {
        -webkit-transform: scale(0);
    }

    100% {
        -webkit-transform: scale(1);
        opacity: 0;
    }
}

@keyframes sk-scaleout {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0);
    }

    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
        opacity: 0;
    }
}


/** 
 * ===================================================================
 * forms
 *
 * ------------------------------------------------------------------- 
 */

fieldset {
    border: none;
}

input[type="email"],
input[type="number"],
input[type="search"],
input[type="text"],
input[type="tel"],
input[type="url"],
input[type="password"],
textarea,
select {
    display: block;
    height: 6rem;
    padding: 1.5rem 2rem;
    border: 0;
    outline: none;
    vertical-align: middle;
    color: #737373;
    font-family: "merriweather-regular", sans-serif;
    font-size: 1.5rem;
    line-height: 3rem;
    border-radius: 3px;
    background: #FFFFFF;
    max-width: 100%;
    border: 1px solid #d5d5d5;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

.ss-custom-select {
    position: relative;
    padding: 0;
    display: inline-block;
}

    .ss-custom-select select {
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        -o-appearance: none;
        appearance: none;
        text-indent: 0.01px;
        text-overflow: '';
        margin: 0;
        line-height: 3rem;
        vertical-align: middle;
        padding-right: 4rem;
    }

        .ss-custom-select select option {
            padding-left: 2rem;
            padding-right: 2rem;
        }

        .ss-custom-select select::-ms-expand {
            display: none;
        }

    .ss-custom-select::after {
        content: '\\f123';
        font-family: 'Ionicons';
        position: absolute;
        top: 50%;
        right: 18px;
        margin-top: -10px;
        bottom: auto;
        width: 20px;
        height: 20px;
        line-height: 20px;
        font-size: 15px;
        text-align: center;
        pointer-events: none;
        color: #252525;
    }

textarea {
    min-height: 25rem;
}

    input[type="email"]:focus,
    input[type="number"]:focus,
    input[type="search"]:focus,
    input[type="text"]:focus,
    input[type="tel"]:focus,
    input[type="url"]:focus,
    input[type="password"]:focus,
    textarea:focus,
    select:focus {
        color: #000000;
        background: #f4fffe;
        border: 1px solid #d2fef9;
    }

label, legend {
    font-family: "merriweather-bold", sans-serif;
    font-size: 1.4rem;
    margin-bottom: .6rem;
    color: #404040;
    display: block;
}

    label span, legend span {
        color: rgb(177, 139, 94);
    }

input[type="checkbox"], input[type="radio"] {
    display: inline;
}

/**
 * Style Placeholder Text  
 * -
 */

::-webkit-input-placeholder {
    color: #a1a1a1;
}

:-moz-placeholder {
    /* Firefox 18- */
    color: #a1a1a1;
}

::-moz-placeholder {
    /* Firefox 19+ */
    color: #a1a1a1;
}

:-ms-input-placeholder {
    color: #a1a1a1;
}

.placeholder {
    color: #a1a1a1 !important;
}


/** 
 * ===================================================================
 * buttons
 *
 * ------------------------------------------------------------------- 
 */

.button,
button,
input[type="submit"],
input[type="reset"],
input[type="button"] {
    display: inline-block;
    font-family: "raleway-bold", sans-serif;
    font-size: 1.6rem;
    height: 5rem;
    line-height: 5rem;
    padding: 0 3rem;
    margin: 0 .3rem 1rem 0;
    background: #d8d8d8;
    color: #252525;
    text-decoration: none;
    cursor: pointer;
    text-align: center;
    white-space: nowrap;
    border: none;
    border-radius: 1000px;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

    .button:hover,
    button:hover,
    input[type="submit"]:hover,
    input[type="reset"]:hover,
    input[type="button"]:hover,
    .button:focus,
    button:focus,
    input[type="submit"]:focus,
    input[type="reset"]:focus,
    input[type="button"]:focus {
        background: #bebebe;
        color: #FFFFFF;
        outline: 0;
    }

    .button.button-primary,
    button.button-primary,
    input[type="submit"].button-primary,
    input[type="reset"].button-primary,
    input[type="button"].button-primary {
        background: rgb(177, 139, 94);
        color: #FFFFFF;
    }

        .button.button-primary:hover,
        button.button-primary:hover,
        input[type="submit"].button-primary:hover,
        input[type="reset"].button-primary:hover,
        input[type="button"].button-primary:hover,
        .button.button-primary:focus,
        button.button-primary:focus,
        input[type="submit"].button-primary:focus,
        input[type="reset"].button-primary:focus,
        input[type="button"].button-primary:focus {
            background: #04998a;
        }

    button.full-width, .button.full-width {
        width: 100%;
        margin-right: 0;
    }

    button.medium, .button.medium {
        height: 5.5rem !important;
        line-height: 5.5rem !important;
        padding: 0 1.8rem !important;
    }

    button.large, .button.large {
        height: 6rem !important;
        line-height: 6rem !important;
        padding: 0rem 3rem !important;
    }

    button.round, .button.round {
        padding-left: 3rem !important;
        padding-right: 3rem !important;
        border-radius: 1000px;
    }

    button.stroke, .button.stroke {
        background: transparent !important;
        border: 3px solid transparent;
        line-height: 4.4rem;
    }

    button::-moz-focus-inner, input::-moz-focus-inner {
        border: 0;
        padding: 0;
    }

/** 
 * ===================================================================
 * common styles 
 *
 * ------------------------------------------------------------------- 
 */

.section-intro {
    max-width: 700px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 5.2rem;
    position: relative;
}

    .section-intro h1 {
        font-family: "merriweather-bold", serif;
        font-size: 4.8rem;
        color: #252525;
        line-height: 1.25;
        margin-bottom: 1.2rem;
    }

    .section-intro h5 {
        color: rgba(56, 66, 78, 0.5);
        font-size: 1.6rem;
        line-height: 1.875;
        margin-bottom: 0.3rem;
        letter-spacing: .4rem;
    }

    .section-intro .lead {
        color: rgba(0, 0, 0, 0.45);
    }

    .section-intro .with-bottom-line {
        position: relative;
        overflow: hidden;
    }

        .section-intro .with-bottom-line::after {
            display: block;
            background-color: rgb(177, 139, 94);
            width: 120px;
            height: 3px;
            content: '\\0020';
            position: absolute;
            left: 50%;
            bottom: 0;
            margin-left: -60px;
        }

@media only screen and (max-width:600px) {
    section .h01 {
        font-size: 2.5rem;
    }
}

/**
 * responsive:
 * common styles
 * - 
 */

@media only screen and (max-width:768px) {
    .section-intro {
        max-width: 650px;
    }

        .section-intro h1 {
            font-size: 4.2rem;
        }
}

@media only screen and (max-width:600px) {
    .section-intro h1 {
        font-size: 3.8rem;
    }

    .section-intro h5 {
        font-size: 1.5rem;
        letter-spacing: .3rem;
    }
}

@media only screen and (max-width:400px) {
    .section-intro h1 {
        font-size: 3.6rem;
    }
}


@media screen and (min-width: 320px) and (max-width: 499px) {
    #intro {
        background: #14181E url(/wp-content/uploads/new/bg-small-small.png) no-repeat center;
    }
}

@media screen and (min-width: 500px) and (max-width: 727px) {
    #intro {
        background: #14181E url(/wp-content/uploads/new/bg-small.png) no-repeat center;
    }
}

@media screen and (min-width: 728px) and (max-width: 889px) {
    #intro {
        background: #14181E url(/wp-content/uploads/new/bg.png) no-repeat right;
    }
}

@media (min-width:890px) {
    #intro {
        background: #14181E url(/wp-content/uploads/new/bg-desktop.png) no-repeat center;
    }
}

#intro {
    -webkit-background-size: cover;
    -moz-background-size: cover;
    background-size: cover;
    width: 100%;
    height: 100%;
    min-height: 720px;
    display: table;
    position: relative;
}

.shadow-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0.25) 25%, transparent 56%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0.25) 25%, transparent 56%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0.25) 25%, transparent 56%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#73000000', endColorstr='#00000000', GradientType=0); /* IE6-9 */
}

.intro-content {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    -webkit-transform: translateY(-1.2rem);
    -ms-transform: translateY(-1.2rem);
    transform: translateY(-1.2rem);
}

    .intro-content h1 {
        color: #FFFFFF;
        font-family: "merriweather-bold", serif;
        font-size: 5.4rem;
        line-height: 1.334;
        max-width: 800px;
        margin-left: auto;
        margin-right: auto;
    }

    .intro-content h5 {
        color: rgba(255, 255, 255, 0.6);
        font-family: "raleway-heavy", sans-serif;
        font-size: 1.8rem;
        line-height: 1.667;
        margin-bottom: 0.6rem;
        text-transform: uppercase;
        letter-spacing: .25rem;
    }

    .intro-content .video-link a {
        display: inline-block;
        width: 90px;
        height: 90px;
        margin-bottom: 4.2rem;
        outline: none;
    }

    .intro-content .button {
        border-color: #FFFFFF;
        color: #FFFFFF;
        height: 6.6rem;
        line-height: 6rem;
        padding: 0 3rem !important;
        margin-top: 1.8rem;
        font-family: "raleway-heavy", sans-serif;
        font-size: 1.4rem;
        text-transform: uppercase;
        letter-spacing: .4rem;
    }

        .intro-content .button:hover, .intro-content .button:focus {
            color: rgb(177, 139, 94);
            border-color: rgb(177, 139, 94);
        }

/**
 * responsive:
 * intro
 * -
 */

@media only screen and (max-width:1024px) {
    .intro-content {
        -webkit-transform: translateY(0);
        -ms-transform: translateY(0);
        transform: translateY(0);
    }

        .intro-content h1 {
            font-size: 4.8rem;
            max-width: 700px;
        }

        .intro-content h5 {
            font-size: 1.6rem;
        }

        .intro-content .video-link a {
            width: 72px;
            height: 72px;
            margin-bottom: 3rem;
        }
}

@media only screen and (max-width:768px) {
    #intro {
        min-height: 660px;
    }

    .intro-content h1 {
        font-size: 4.2rem;
        max-width: 550px;
    }

    .intro-content h5 {
        font-size: 1.5rem;
        letter-spacing: .15rem;
    }
}

@media only screen and (max-width:600px) {
    #intro {
        min-height: 600px;
    }

    .intro-content h1 {
        font-size: 3.8rem;
        margin-bottom: .9rem;
    }

    .intro-content h5 {
        font-size: 1.4rem;
        letter-spacing: .15rem;
    }

    .intro-content .video-link a {
        width: 66px;
        height: 66px;
        margin-bottom: 1.5rem;
    }
}

@media only screen and (max-width:400px) {
    #intro {
        min-height: 550px;
    }

    .intro-content h1 {
        font-size: 3.4rem;
    }

    .intro-content h5 {
        font-size: 1.4rem;
        letter-spacing: .15rem;
    }

    .intro-content .video-link a {
        width: 60px;
        height: 60px;
    }
}

/**
 * video popup modal
 * - 
 */

.popup-modal {
    max-width: 800px;
    background: #FFFFFF;
    position: relative;
    margin: 0 auto; /* close */
}

    .popup-modal .close-popup {
        position: absolute;
        right: 0;
        top: -42px;
        cursor: pointer;
        display: block;
        width: 30px;
        height: 30px;
        color: rgba(255, 255, 255, 0.5);
        text-align: center;
        font: 0/0 a;
        text-shadow: none;
        color: transparent;
    }

        .popup-modal .close-popup::before {
            display: block;
            width: 30px;
            height: 30px;
            line-height: 30px;
            font-family: "Ionicons";
            content: "\\f2d7";
            font-size: 21px;
            color: rgba(255, 255, 255, 0.5);
        }

/**
 * responsive:
 * video popup modal
 * - 
 */

@media only screen and (max-width:900px) {
    .popup-modal {
        max-width: 700px;
    }
}

@media only screen and (max-width:768px) {
    .popup-modal {
        width: auto;
        margin: 0 20px;
    }
}

/**
 * transition effect for modal popup
 * - 
 */

/* overlay at start */
.mfp-fade.mfp-bg {
    opacity: 0;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

    /* overlay animate in */
    .mfp-fade.mfp-bg.mfp-ready {
        opacity: 0.8;
    }

    /* overlay animate out */
    .mfp-fade.mfp-bg.mfp-removing {
        opacity: 0;
    }

/* content at start */
.mfp-fade.mfp-wrap .mfp-content {
    opacity: 0;
    -webkit-transform: translateY(-100%);
    -ms-transform: translateY(-100%);
    transform: translateY(-100%);
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

/* content animate in */
.mfp-fade.mfp-wrap.mfp-ready .mfp-content {
    opacity: 1;
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
}

/* content animate out */
.mfp-fade.mfp-wrap.mfp-removing .mfp-content {
    opacity: 0;
    -webkit-transform: translateY(-100%);
    -ms-transform: translateY(-100%);
    transform: translateY(-100%);
}


/** 
 * ===================================================================
 * process section
 *
 * ------------------------------------------------------------------- 
 */

#vipcard {
    background: black url(/wp-content/uploads/new/process-bg.jpg) repeat right;
    padding-top: 12rem;
    padding-bottom: 15rem;
    overflow: hidden;
}

.process-content {
    position: relative;
    text-align: center;
}

    .process-content .right-side,
    .process-content .left-side,
    .process-content .image-part {
        width: 33.33333%;
        font-size: 15px;
        line-height: 27px;
    }

    .process-content .right-side, .process-content .left-side {
        padding: 0 6% 24px;
        position: absolute;
        top: 0;
    }

    .process-content .right-side {
        right: 0;
    }

    .process-content .left-side {
        left: 0;
    }

    .process-content .image-part {
        margin: 0 auto;
        height: 660px;
        background-repeat: no-repeat;
        background-position: center;
        -webkit-background-size: contain;
        -moz-background-size: contain;
        background-size: contain;
    }

    .process-content .item[data-item]::before {
        background: #38424e;
        color: #FFFFFF;
        border-radius: 100%;
        font-family: "montserrat-bold", sans-serif;
        content: attr(data-item);
        display: inline-block;
        font-size: 18px;
        height: 42px;
        width: 42px;
        line-height: 42px;
        text-align: center;
        vertical-align: middle;
        margin-bottom: 1.5rem;
    }

    .process-content h5 {
        color: rgb(177, 139, 94);
        font-size: 1.6rem;
        line-height: 1.875;
        letter-spacing: .2rem;
        margin-bottom: .3rem;
    }

/**
 * responsive:
 * process
 * -
 */

@media only screen and (max-width:1024px) {
    .process-content .right-side, .process-content .left-side {
        padding: 0 3% 24px;
        width: 35%;
    }

    .process-content .image-part {
        height: 600px;
        width: 30%;
    }
}

@media only screen and (max-width:768px) {
    #process {
        padding-bottom: 27rem;
    }

    .process-content .right-side, .process-content .left-side {
        position: static;
        width: 100%;
        max-width: 480px;
        font-size: 1.6rem;
        line-height: 3rem;
        margin-left: auto;
        margin-right: auto;
        padding-bottom: 0;
    }

    .process-content .image-part {
        width: 300px;
        position: absolute;
        bottom: -630px;
        left: 50%;
        margin-left: -150px;
    }
}

@media only screen and (max-width:400px) {
    #process {
        padding-bottom: 21rem;
    }

    .process-content .image-part {
        width: 230px;
        bottom: -540px;
        margin-left: -115px;
    }
}


/** 
 * ===================================================================
 * features section
 *
 * ------------------------------------------------------------------- 
 */

#infraslimx {
    background: #090909 url(/wp-content/uploads/new/features-bg.jpg) repeat center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    background-size: cover;
    padding-top: 12rem;
    padding-bottom: 12rem;
    color: white;
}

    #infraslimx .section-intro h1 {
        color: white;
    }

    #infraslimx .section-intro h5 {
        color: rgba(255, 255, 255, 0.5);
    }

    #infraslimx .section-intro p {
        color: rgba(255, 255, 255, 0.7);
    }

.features-content {
    max-width: 1200px;
}

.features-list {
    margin-top: 1.2rem;
    text-align: center;
}

    .features-list .feature {
        margin-bottom: 1.2rem;
        padding: 0 32px;
    }

    .features-list .icon {
        display: inline-block;
        margin-bottom: 2.1rem;
    }

        .features-list .icon i {
            font-size: 4.8rem;
        }

    .features-list .h05 {
        font-size: 1.7rem;
        line-height: 1.765;
        color: rgb(177, 139, 94);
        margin-bottom: 1.8rem;
    }

/**
 * responsive:
 * features
 * -
 */

@media only screen and (max-width:768px) {
    .features-content {
        max-width: 600px;
    }

    .features-list .feature {
        padding: 0 15px;
    }
}

@media only screen and (max-width:600px) {
    .features-list .feature {
        padding: 0 10px;
    }
}

@media only screen and (max-width:400px) {
    .features-list .feature {
        padding: 0;
    }
}


/** 
 * ===================================================================
 * pricing section
 *
 * ------------------------------------------------------------------- 
 */

#pricing {
    background: #EAEAED;
    padding-top: 12rem;
    padding-bottom: 9.6rem;
}

.pricing-content {
    margin-top: 6.6rem;
    max-width: 1280px;
}

    .pricing-content .bgrid {
        margin-bottom: 3.6rem;
    }

    .pricing-content .price-block {
        background-color: #FFFFFF;
        border-radius: 5px;
        overflow: hidden;
        text-align: center;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    }

        .pricing-content .price-block .top-part,
        .pricing-content .price-block .bottom-part {
            padding: 3.9rem 1.5rem;
        }

        .pricing-content .price-block .top-part {
            background: rgb(177, 139, 94);
            color: #FFFFFF;
            padding-bottom: 2.4rem;
            position: relative;
        }

        .pricing-content .price-block .bottom-part {
            padding-top: 2.4rem;
            padding-left: 3rem;
            padding-right: 3rem;
        }

        .pricing-content .price-block .plan-title {
            color: #FFFFFF;
            padding-bottom: 2.4rem;
            margin-bottom: 1.2rem;
            font-size: 2.4rem;
            position: relative;
        }

            .pricing-content .price-block .plan-title::after {
                display: block;
                background-color: rgba(255, 255, 255, 0.3);
                width: 80px;
                height: 1px;
                content: '\\0020';
                position: absolute;
                left: 50%;
                bottom: 0;
                margin-left: -40px;
            }

        .pricing-content .price-block .plan-price {
            font-family: "raleway-bold", sans-serif;
            font-size: 5rem;
            line-height: 1;
            margin-bottom: .6rem;
        }

            .pricing-content .price-block .plan-price sup {
                font-size: 2.4rem;
                top: -1.5rem;
                margin-right: 3px;
            }

        .pricing-content .price-block .price-month {
            margin-bottom: 1.2rem;
            font-family: "raleway-bold", sans-serif;
            font-size: 1.6rem;
        }

        .pricing-content .price-block .price-meta {
            color: rgba(255, 255, 255, 0.5);
            line-height: 1.8rem;
        }

        .pricing-content .price-block .button {
            color: #353F49;
            padding: 0 5rem;
            margin-left: auto;
            margin-right: auto;
        }

            .pricing-content .price-block .button:hover,
            .pricing-content .price-block .button:focus {
                background: #58687b;
                color: #FFFFFF;
            }

        .pricing-content .price-block .features {
            list-style: none;
            font-family: "raleway-bold", sans-serif;
            font-size: 1.5rem;
            color: rgba(0, 0, 0, 0.4);
            margin: .6rem 0 1.8rem 0;
        }

            .pricing-content .price-block .features li {
                padding: .6rem 0;
                border-bottom: 1px solid #EAEAED;
            }

                .pricing-content .price-block .features li strong {
                    color: #353F49;
                    font-family: "raleway-bold", serif;
                    margin-right: 5px;
                }

                .pricing-content .price-block .features li:last-child {
                    border: none;
                }

    .pricing-content .primary .top-part {
        background: rgb(177, 139, 94);
    }

        .pricing-content .primary .top-part::before {
            content: attr(data-info);
            display: block;
            min-height: 48px;
            line-height: 48px;
            width: 75%;
            text-align: center;
            color: #FFFFFF;
            background: #38424e;
            font-family: "raleway-heavy", sans-serif;
            font-size: 1.2rem;
            text-transform: uppercase;
            letter-spacing: .15rem;
            position: absolute;
            bottom: -18px;
            left: 50%;
            -webkit-transform: translateX(-50%);
            -ms-transform: translateX(-50%);
            transform: translateX(-50%);
            z-index: 500;
            border-radius: 5px;
        }

/**
 * responsive:
 * pricing
 * -
 */

@media only screen and (max-width:1140px) {
    .pricing-content {
        max-width: 800px;
    }

        .pricing-content .bgrid {
            width: 50%;
            clear: none;
        }

            .pricing-content .bgrid:nth-child(2n+1) {
                clear: both;
            }
}

@media only screen and (max-width:600px) {
    .pricing-content {
        max-width: 420px;
    }

        .pricing-content .bgrid {
            width: 100% !important;
            float: none !important;
            clear: both !important;
            margin-left: 0;
            margin-right: 0;
        }
}


/** 
 * ===================================================================
 * testimonials section
 *
 * ------------------------------------------------------------------- 
 */

#testimonials {
    background: #FFFFFF;
    padding-top: 10.2rem;
    padding-bottom: 12rem;
    position: relative;
    min-height: 20.4rem;
    width: 100%;
    overflow: hidden;
    text-align: center;
}

    #testimonials .h01 {
        padding-bottom: 2.1rem;
        margin-bottom: 3.6rem;
        position: relative;
        color: #252525;
    }

        #testimonials .h01::after {
            display: block;
            background-color: rgb(177, 139, 94);
            width: 120px;
            height: 3px;
            content: '\\0020';
            position: absolute;
            left: 50%;
            bottom: 0;
            margin-left: -60px;
        }

    #testimonials .flex-container {
        width: 80%;
        max-width: 800px;
        margin: 0 auto;
    }

#testimonial-slider {
    margin: 0 0 3rem 0;
    position: relative;
}

    #testimonial-slider p {
        font-family: "raleway-medium", sans-serif;
        font-size: 2.5rem;
        line-height: 1.8;
        color: #8d8d8d;
    }

        #testimonial-slider p::before, #testimonial-slider p::after {
            display: inline;
            font-family: Arial, sans-serif;
            color: #c7c7c7;
            font-size: 6rem;
            line-height: 0;
            vertical-align: bottom;
            position: relative;
            top: -1.2rem;
        }

        #testimonial-slider p::before {
            margin-right: .5rem;
            content: '\\201C';
        }

        #testimonial-slider p::after {
            margin-left: .5rem;
            content: '\\201D';
        }

    #testimonial-slider .testimonial-author img {
        width: 8.2rem;
        height: 8.2rem;
        margin: 0 auto 1.2rem auto;
        display: block;
        border-radius: 50%;
        vertical-align: middle;
        border: 9px solid #EAEAED;
    }

    #testimonial-slider .testimonial-author .author-info {
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        font-family: "raleway-heavy", sans-serif;
        font-size: 1.5rem;
        letter-spacing: 2px;
        text-transform: uppercase;
        margin-bottom: 3rem;
        color: #252525;
    }

        #testimonial-slider .testimonial-author .author-info span {
            display: block;
            font-family: "raleway-semibold", sans-serif;
            font-size: 1.4rem;
            line-height: 2.1rem;
            letter-spacing: 0;
            text-transform: none;
            color: rgba(0, 0, 0, 0.4);
        }

/* control nav */
#testimonials .flex-control-nav {
    width: 100%;
    text-align: center;
    display: block;
    position: absolute;
    bottom: -42px;
}

    #testimonials .flex-control-nav li {
        margin: 0 6px;
        display: inline-block;
        zoom: 1;
    }

#testimonials .flex-control-paging li a {
    width: 15px;
    height: 15px;
    display: block;
    border: 4px solid #8d8d8d;
    cursor: pointer;
    border-radius: 50%;
    font: 0/0 a;
    text-shadow: none;
    color: transparent;
}

    #testimonials .flex-control-paging li a:hover {
        border: 4px solid rgb(177, 139, 94);
    }

    #testimonials .flex-control-paging li a.flex-active {
        background: rgb(177, 139, 94);
        border-color: rgb(177, 139, 94);
        cursor: default;
    }

/* direction nav */
#testimonials .flex-direction-nav li {
    padding: 0;
    z-index: 500;
    position: absolute;
    bottom: 0;
    margin-bottom: -57px;
}

    #testimonials .flex-direction-nav li a {
        display: block;
        opacity: .8;
        font: 0/0 a;
        text-shadow: none;
        color: transparent;
    }

        #testimonials .flex-direction-nav li a.flex-prev::before,
        #testimonials .flex-direction-nav li a.flex-next::after {
            display: block;
            background: #EAEAED;
            color: #737373;
            border-radius: 5px;
            font-family: "Ionicons";
            font-size: 18px;
            height: 48px;
            width: 48px;
            line-height: 48px;
            text-align: center;
            -moz-transition: all 0.3s ease-in-out;
            -o-transition: all 0.3s ease-in-out;
            -webkit-transition: all 0.3s ease-in-out;
            -ms-transition: all 0.3s ease-in-out;
            transition: all 0.3s ease-in-out;
        }

        #testimonials .flex-direction-nav li a.flex-prev::before {
            content: "\\f2ca";
        }

        #testimonials .flex-direction-nav li a.flex-next::after {
            content: "\\f30f";
        }

        #testimonials .flex-direction-nav li a.flex-next:hover::after,
        #testimonials .flex-direction-nav li a.flex-prev:hover::before {
            background: rgb(177, 139, 94);
            color: #FFFFFF;
        }

    #testimonials .flex-direction-nav li.flex-nav-prev {
        left: 0;
    }

    #testimonials .flex-direction-nav li.flex-nav-next {
        right: 0;
    }

/**
 * responsive:
 * testimonial slider
 * -
 */

@media only screen and (max-width:1024px) {
    #testimonials .flex-container {
        max-width: 600px;
    }

    #testimonial-slider p {
        font-size: 2.4rem;
    }
}

@media only screen and (max-width:768px) {
    #testimonials .flex-container {
        width: 90%;
    }

    #testimonial-slider p {
        font-size: 2.2rem;
    }
}

@media only screen and (max-width:600px) {
    #testimonials .flex-container {
        width: 95%;
    }

    #testimonial-slider p {
        font-size: 2rem;
    }

        #testimonial-slider p::before, #testimonial-slider p::after {
            top: -0.5rem;
        }
}

@media only screen and (max-width:400px) {
    #testimonials .flex-container {
        width: auto;
    }

    #testimonial-slider p {
        font-size: 1.8rem;
    }
}


/** 
 * ===================================================================
 * faq section
 *
 * ------------------------------------------------------------------- 
 */

#edesextra {
    background: #EAEAED;
    padding-top: 12rem;
    padding-bottom: 12rem;
}

.faq-content {
    margin-top: 5.4rem;
    max-width: 1020px;
}

    .faq-content .bgrid {
        padding: 0 30px;
    }

/**
 * responsive:
 * faq
 * -
 */

@media only screen and (max-width:768px) {
    .faq-content {
        max-width: 650px;
    }
}

@media only screen and (max-width:480px) {
    .faq-content .bgrid {
        padding: 0 20px;
    }
}

@media only screen and (max-width:400px) {
    .faq-content .bgrid {
        padding: 0;
    }
}


/** 
 * ===================================================================
 * ad-section
 *
 * ------------------------------------------------------------------- 
 */

.section-ads {
    margin-top: 4.8rem;
    padding-top: 6rem;
    max-width: 650px;
    border-top: 1px dotted rgba(0, 0, 0, 0.1);
    text-align: center;
}

    .section-ads h2 a, .section-ads h2 a:visited {
        color: #252525;
    }

    .section-ads span {
        color: #0087cc;
    }

    .section-ads .button {
        background: rgb(177, 139, 94);
        color: #FFFFFF;
    }

        .section-ads .button:hover, .section-ads .button:focus {
            background: #05ad9c;
        }


/** 
 * ===================================================================
 * call-to-action section
 *
 * ------------------------------------------------------------------- 
 */

#idopontfoglalas {
    background: rgb(177, 139, 94);
    padding-top: 7.2rem;
    padding-bottom: 9rem;
    text-align: center;
    color: #FFFFFF;
}

.cta-content {
    max-width: 740px;
    margin: 0 auto;
}

    .cta-content h1 {
        color: #FFFFFF;
        margin-bottom: .6rem;
    }

    .cta-content p {
        color: rgba(255, 255, 255, 0.8);
    }

    .cta-content .stores {
        margin: 0;
        padding: 0;
        display: block;
    }

        .cta-content .stores li {
            padding: 0;
            display: inline-block;
        }

            .cta-content .stores li .button {
                background: rgb(254, 248, 237);
                color: #FFFFFF;
                margin-right: 12px;
                display: block;
                line-height: 60px;
            }

                .cta-content .stores li .button:hover,
                .cta-content .stores li .button:focus {
                    background: rgb(254, 248, 237);
                }

                .cta-content .stores li .button i {
                    font-size: 18px;
                    line-height: inherit;
                    margin-right: 8px;
                }

                    .cta-content .stores li .button i.ion-social-windows {
                        font-size: 15px;
                    }

            .cta-content .stores li:last-child .button {
                margin-right: 0;
            }

/**
 * responsive:
 * cta
 * -
 */

@media only screen and (max-width:650px) {
    .cta-content {
        max-width: 650px;
    }

        .cta-content .stores li {
            display: block;
        }

            .cta-content .stores li .button {
                width: 300px;
                display: block;
                margin-left: auto !important;
                margin-right: auto !important;
                margin-bottom: 1.8rem;
            }

                .cta-content .stores li .button::before {
                    display: none;
                }
}

@media only screen and (max-width:600px) {
    .cta-content .stores li .button {
        width: 70%;
    }
}

@media only screen and (max-width:400px) {
    .cta-content .stores li .button {
        width: 80%;
    }
}


/** 
 * ===================================================================
 * footer
 *
 * ------------------------------------------------------------------- 
 */

footer {
    padding-bottom: 3rem;
    font-size: 1.5rem;
    line-height: 2.7rem;
    font-family: "raleway-medium", sans-serif;
    color: #465166;
}

    footer a, footer a:visited {
        color: rgb(177, 139, 94);
    }

        footer a:hover, footer a:focus {
            color: #FFFFFF;
        }

    footer h4 {
        border-bottom: 1px solid rgba(255, 255, 255, 0.03);
        padding-bottom: 1.2rem;
        margin-bottom: 1.2rem;
        color: #FFFFFF;
    }

    footer ul {
        margin-left: 0;
    }

        footer ul li {
            padding-left: 0;
        }

.footer-main {
    padding-top: 6.6rem;
    padding-bottom: 4.2rem;
    background: rgb(177, 139, 94);
}

    .footer-main ul {
        font-size: 1.5rem;
    }

        .footer-main ul li {
            font-family: "raleway-bold", sans-serif;
            list-style: none;
        }

        .footer-main ul a, .footer-main ul a:visited {
            color: #465166;
        }

            .footer-main ul a:hover, .footer-main ul a:focus {
                color: #FFFFFF;
            }

    .footer-main .footer-logo {
        width: 162px;
        height: 39px;
        background-size: 162px 39px;
        margin: -.6rem 0 2.1rem -.3rem;
        display: block;
    }

    .footer-main .footer-subscribe p {
        margin-bottom: 1.2rem;
    }

    .footer-main .footer-subscribe .subscribe-form #mc-form {
        padding: 0;
    }

    .footer-main .footer-subscribe .subscribe-form input[type="email"] {
        padding: .6rem 2rem;
        border-radius: 5px;
        background: #232933;
        border: none;
        width: 100%;
        font-family: "raleway-regular", sans-serif;
        color: #bababa;
        margin-bottom: 1.8rem;
    }

    .footer-main .footer-subscribe .subscribe-form input[type="submit"] {
        display: none;
    }

    .footer-main .footer-subscribe .subscribe-form .subscribe-message {
        font-family: "raleway-bold", sans-serif;
        color: #FFFFFF;
    }

        .footer-main .footer-subscribe .subscribe-form .subscribe-message i {
            color: #ff7b29;
            margin-right: 5px;
        }

    .footer-main .footer-subscribe .subscribe-form ::-webkit-input-placeholder {
        color: #545454;
    }

    .footer-main .footer-subscribe .subscribe-form :-moz-placeholder {
        /* Firefox 18- */
        color: #545454;
    }

    .footer-main .footer-subscribe .subscribe-form ::-moz-placeholder {
        /* Firefox 19+ */
        color: #545454;
    }

    .footer-main .footer-subscribe .subscribe-form :-ms-input-placeholder {
        color: #545454;
    }

    .footer-main .footer-subscribe .subscribe-form .placeholder {
        color: #545454 !important;
    }

.footer-bottom {
    margin-top: 3rem;
    text-align: center;
}

    .footer-bottom .copyright span {
        display: inline-block;
    }

        .footer-bottom .copyright span::after {
            content: "|";
            display: inline-block;
            padding: 0 1rem 0 1.2rem;
            color: rgba(255, 255, 255, 0.1);
        }

        .footer-bottom .copyright span:last-child::after {
            display: none;
        }

/**
 * responsive:
 * footer
 * -
 */

@media only screen and (max-width:768px) {
    .footer-main .footer-logo {
        margin-left: auto;
        margin-right: auto;
    }

    .footer-main .footer-info {
        text-align: center;
    }
}

@media only screen and (max-width:600px) {
    .footer-main .row {
        max-width: 420px;
    }

    .footer-main .footer-subscribe {
        text-align: center;
    }

    .footer-main .subscribe-form form input[type="email"] {
        margin-left: auto !important;
        margin-right: auto !important;
        text-align: center;
    }

    .footer-bottom {
        padding-bottom: .6rem;
    }

        .footer-bottom .copyright span {
            display: block;
        }

            .footer-bottom .copyright span::after {
                display: none;
            }
}

@media only screen and (max-width:400px) {
    .footer-main .site-links, .footer-main .social-links {
        text-align: center;
    }

        .footer-main .site-links h4, .footer-main .social-links h4 {
            border: none;
        }

    .footer-main ul {
        width: 80%;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }

        .footer-main ul li a {
            display: block;
            border-bottom: 1px solid rgba(255, 255, 255, 0.03);
            padding: .6rem 0;
        }

        .footer-main ul li:first-child a {
            border-top: 1px solid rgba(255, 255, 255, 0.03);
        }
}

/**
 * go to top
 * -
 */

#go-top {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 600;
    display: none;
}

    #go-top a {
        text-decoration: none;
        border: 0 none;
        display: block;
        height: 66px;
        width: 60px;
        line-height: 66px;
        text-align: center;
        background: #048a7c;
        color: #FFFFFF;
        text-align: center;
        text-transform: uppercase;
        -moz-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
        -webkit-transition: all 0.3s ease-in-out;
        -ms-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
    }

        #go-top a i {
            font-size: 20px;
            line-height: inherit;
        }

        #go-top a:hover {
            background: #ff7b29;
            color: #FFFFFF;
        }

h1, h2, h3, h4, h5, h6, .h01, .h02, .h03, .h04, .h05, .h06 {
    font-family: "raleway-bold", sans-serif;
    color: #252525;
    font-style: normal;
    text-rendering: optimizeLegibility;
    margin-bottom: 2.1rem;
}

h3, .h03, h4, .h04 {
    margin-bottom: 1.8rem;
}

h5, .h05, h6, .h06 {
    font-family: "raleway-heavy";
    margin-bottom: 1.2rem;
}

h1, .h01 {
    font-size: 3.1rem;
    line-height: 1.35;
    letter-spacing: -.1rem;
}

@media only screen and (max-width:600px) {
    h1, .h01 {
        font-size: 2.6rem;
        letter-spacing: -.07rem;
    }
}

h2, .h02 {
    font-size: 2.4rem;
    line-height: 1.25;
}

h3, .h03 {
    font-size: 2rem;
    line-height: 1.5;
}

h4, .h04 {
    font-size: 1.7rem;
    line-height: 1.76;
}

h5, .h05 {
    font-size: 1.4rem;
    line-height: 1.7;
    text-transform: uppercase;
    letter-spacing: .15rem;
}

h6, .h06 {
    font-size: 1.3rem;
    line-height: 1.85;
    text-transform: uppercase;
    letter-spacing: .15rem;
}

p img {
    margin: 0;
}

p.lead {
    font-family: "merriweather-light", serif;
    font-size: 1.8rem;
    line-height: 1.8;
    color: #737373;
}

@media only screen and (max-width:768px) {
    p.lead {
        font-size: 1.7rem;
    }
}

em, i, strong, b {
    font-size: 1.6rem;
    line-height: 3rem;
    font-style: normal;
    font-weight: normal;
}

em, i {
    font-family: "merriweather-italic", serif;
}

strong, b {
    font-family: "merriweather-bold", serif;
}

small {
    font-size: 1.1rem;
    line-height: inherit;
}

blockquote {
    margin: 3rem 0;
    padding-left: 4rem;
    position: relative;
}

    blockquote:before {
        content: "\\201C";
        font-size: 8rem;
        line-height: 0px;
        margin: 0;
        color: #333;
        font-family: arial, sans-serif;
        position: absolute;
        top: 3rem;
        left: 0;
    }

    blockquote p {
        font-family: georgia, serif;
        font-style: italic;
        padding: 0;
        font-size: 1.9rem;
        line-height: 1.75;
    }

    blockquote cite {
        display: block;
        font-size: 1.2rem;
        font-style: normal;
        line-height: 1.65;
    }

        blockquote cite:before {
            content: "\\2014 \\0020";
        }

        blockquote cite a, blockquote cite a:visited {
            color: #8d8d8d;
            border: none;
        }

abbr {
    font-family: "merriweather-bold", serif;
    font-variant: small-caps;
    text-transform: lowercase;
    letter-spacing: .05rem;
    color: #8d8d8d;
}

var, kbd, samp, code, pre {
    font-family: Consolas, "Andale Mono", Courier, "Courier New", monospace;
}

pre {
    padding: 2.4rem 3rem 3rem;
    background: #F1F1F1;
}

code {
    font-size: 1.4rem;
    margin: 0 .2rem;
    padding: .3rem .6rem;
    white-space: nowrap;
    background: #F1F1F1;
    border: 1px solid #E1E1E1;
    border-radius: 3px;
}

pre > code {
    display: block;
    white-space: pre;
    line-height: 2;
    padding: 0;
    margin: 0;
}

pre.prettyprint > code {
    border: none;
}

del {
    text-decoration: line-through;
}

abbr[title], dfn[title] {
    border-bottom: 1px dotted;
    cursor: help;
}

mark {
    background: #FFF49B;
    color: #000;
}

hr {
    border: solid #cfcfd5;
    border-width: 1px 0 0;
    clear: both;
    margin: 2.4rem 0 1.5rem;
    height: 0;
}

/**
 * Lists  
 * -
 */

ol {
    list-style: decimal;
}

ul {
    list-style: disc;
}

li {
    display: list-item;
}

ol, ul {
    margin-left: 1.7rem;
}

    ul li {
        padding-left: .4rem;
    }

    ul ul, ul ol, ol ol, ol ul {
        margin: .6rem 0 .6rem 1.7rem;
    }

    ul.disc li {
        display: list-item;
        list-style: none;
        padding: 0 0 0 .8rem;
        position: relative;
    }

        ul.disc li::before {
            content: "";
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: rgb(177, 139, 94);
            position: absolute;
            left: -17px;
            top: 11px;
            vertical-align: middle;
        }

dt {
    margin: 0;
    color: rgb(177, 139, 94);
}

dd {
    margin: 0 0 0 2rem;
}

/**
 * tables  
 * -
 */

table {
    border-width: 0;
    width: 100%;
    max-width: 100%;
    font-family: "raleway-regular", sans-serif;
}

th, td {
    padding: 1.5rem 3rem;
    text-align: left;
    border-bottom: 1px solid #E8E8E8;
}

th {
    color: #252525;
    font-family: "raleway-bold", sans-serif;
}

td {
    line-height: 1.5;
}

    th:first-child, td:first-child {
        padding-left: 0;
    }

    th:last-child, td:last-child {
        padding-right: 0;
    }

.table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

/**
 * Spacing  
 * -
 */

button, .button {
    margin-bottom: 1.2;
}

fieldset {
    margin-bottom: 1.5rem;
}

input,
textarea,
select,
pre,
blockquote,
figure,
table,
p,
ul,
ol,
dl,
form,
.fluid-video-wrapper,
.iw-custom-select {
    margin-bottom: 3rem;
}

/**
 * floated image  
 * -
 */

img.pull-right {
    margin: 1.5rem 0 0 3rem;
}

img.pull-left {
    margin: 1.5rem 3rem 0 0;
}

/**
 * block grids paddings 
 * -
 */

.bgrid {
    padding: 0 20px;
}

@media only screen and (max-width:1024px) {
    .bgrid {
        padding: 0 18px;
    }
}

@media only screen and (max-width:768px) {
    .bgrid {
        padding: 0 15px;
    }
}

@media only screen and (max-width:600px) {
    .bgrid {
        padding: 0 10px;
    }
}

@media only screen and (max-width:400px) {
    .bgrid {
        padding: 0;
    }
}


/** 
 * ===================================================================
 * preloader
 *
 * ------------------------------------------------------------------- 
 */

#preloader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #00d9ec;
    z-index: 9999999;
    height: 100%;
    width: 100%;
}

.no-js #preloader, .oldie #preloader {
    display: none;
}

#loader {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 60px;
    height: 60px;
    margin-left: -30px;
    margin-top: -30px;
    padding: 0;
    background-color: white;
    border-radius: 100%;
    -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
    animation: sk-scaleout 1.0s infinite ease-in-out;
}

@-webkit-keyframes sk-scaleout {
    0% {
        -webkit-transform: scale(0);
    }

    100% {
        -webkit-transform: scale(1);
        opacity: 0;
    }
}

@keyframes sk-scaleout {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0);
    }

    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
        opacity: 0;
    }
}


/** 
 * ===================================================================
 * forms
 *
 * ------------------------------------------------------------------- 
 */

fieldset {
    border: none;
}

input[type="email"],
input[type="number"],
input[type="search"],
input[type="text"],
input[type="tel"],
input[type="url"],
input[type="password"],
textarea,
select {
    display: block;
    height: 6rem;
    padding: 1.5rem 2rem;
    border: 0;
    outline: none;
    vertical-align: middle;
    color: #737373;
    font-family: "merriweather-regular", sans-serif;
    font-size: 1.5rem;
    line-height: 3rem;
    border-radius: 3px;
    background: #FFFFFF;
    max-width: 100%;
    border: 1px solid #d5d5d5;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

.ss-custom-select {
    position: relative;
    padding: 0;
    display: inline-block;
}

    .ss-custom-select select {
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        -o-appearance: none;
        appearance: none;
        text-indent: 0.01px;
        text-overflow: '';
        margin: 0;
        line-height: 3rem;
        vertical-align: middle;
        padding-right: 4rem;
    }

        .ss-custom-select select option {
            padding-left: 2rem;
            padding-right: 2rem;
        }

        .ss-custom-select select::-ms-expand {
            display: none;
        }

    .ss-custom-select::after {
        content: '\\f123';
        font-family: 'Ionicons';
        position: absolute;
        top: 50%;
        right: 18px;
        margin-top: -10px;
        bottom: auto;
        width: 20px;
        height: 20px;
        line-height: 20px;
        font-size: 15px;
        text-align: center;
        pointer-events: none;
        color: #252525;
    }

textarea {
    min-height: 25rem;
}

    input[type="email"]:focus,
    input[type="number"]:focus,
    input[type="search"]:focus,
    input[type="text"]:focus,
    input[type="tel"]:focus,
    input[type="url"]:focus,
    input[type="password"]:focus,
    textarea:focus,
    select:focus {
        color: #000000;
        background: #f4fffe;
        border: 1px solid #d2fef9;
    }

label, legend {
    font-family: "merriweather-bold", sans-serif;
    font-size: 1.4rem;
    margin-bottom: .6rem;
    color: #404040;
    display: block;
}

    label span, legend span {
        color: rgb(177, 139, 94);
    }

input[type="checkbox"], input[type="radio"] {
    display: inline;
}

/**
 * Style Placeholder Text  
 * -
 */

::-webkit-input-placeholder {
    color: #a1a1a1;
}

:-moz-placeholder {
    /* Firefox 18- */
    color: #a1a1a1;
}

::-moz-placeholder {
    /* Firefox 19+ */
    color: #a1a1a1;
}

:-ms-input-placeholder {
    color: #a1a1a1;
}

.placeholder {
    color: #a1a1a1 !important;
}


/** 
 * ===================================================================
 * buttons
 *
 * ------------------------------------------------------------------- 
 */

.button,
button,
input[type="submit"],
input[type="reset"],
input[type="button"] {
    display: inline-block;
    font-family: "raleway-bold", sans-serif;
    font-size: 1.6rem;
    height: 5rem;
    line-height: 5rem;
    padding: 0 3rem;
    margin: 0 .3rem 1rem 0;
    background: #d8d8d8;
    color: #252525;
    text-decoration: none;
    cursor: pointer;
    text-align: center;
    white-space: nowrap;
    border: none;
    border-radius: 1000px;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

    .button:hover,
    button:hover,
    input[type="submit"]:hover,
    input[type="reset"]:hover,
    input[type="button"]:hover,
    .button:focus,
    button:focus,
    input[type="submit"]:focus,
    input[type="reset"]:focus,
    input[type="button"]:focus {
        background: #bebebe;
        color: #FFFFFF;
        outline: 0;
    }

    .button.button-primary,
    button.button-primary,
    input[type="submit"].button-primary,
    input[type="reset"].button-primary,
    input[type="button"].button-primary {
        background: rgb(177, 139, 94);
        color: #FFFFFF;
    }

        .button.button-primary:hover,
        button.button-primary:hover,
        input[type="submit"].button-primary:hover,
        input[type="reset"].button-primary:hover,
        input[type="button"].button-primary:hover,
        .button.button-primary:focus,
        button.button-primary:focus,
        input[type="submit"].button-primary:focus,
        input[type="reset"].button-primary:focus,
        input[type="button"].button-primary:focus {
            background: #04998a;
        }

    button.full-width, .button.full-width {
        width: 100%;
        margin-right: 0;
    }

    button.medium, .button.medium {
        height: 5.5rem !important;
        line-height: 5.5rem !important;
        padding: 0 1.8rem !important;
    }

    button.large, .button.large {
        height: 6rem !important;
        line-height: 6rem !important;
        padding: 0rem 3rem !important;
    }

    button.round, .button.round {
        padding-left: 3rem !important;
        padding-right: 3rem !important;
        border-radius: 1000px;
    }

    button.stroke, .button.stroke {
        background: transparent !important;
        border: 3px solid transparent;
        line-height: 4.4rem;
    }

    button::-moz-focus-inner, input::-moz-focus-inner {
        border: 0;
        padding: 0;
    }

/** 
 * ===================================================================
 * common styles 
 *
 * ------------------------------------------------------------------- 
 */

.section-intro {
    max-width: 700px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 5.2rem;
    position: relative;
}

    .section-intro h1 {
        font-family: "merriweather-bold", serif;
        font-size: 4.8rem;
        color: #252525;
        line-height: 1.25;
        margin-bottom: 1.2rem;
    }

    .section-intro h5 {
        color: rgba(56, 66, 78, 0.5);
        font-size: 1.6rem;
        line-height: 1.875;
        margin-bottom: 0.3rem;
        letter-spacing: .4rem;
    }

    .section-intro .lead {
        color: rgba(0, 0, 0, 0.45);
    }

    .section-intro .with-bottom-line {
        position: relative;
        overflow: hidden;
    }

        .section-intro .with-bottom-line::after {
            display: block;
            background-color: rgb(177, 139, 94);
            width: 120px;
            height: 3px;
            content: '\\0020';
            position: absolute;
            left: 50%;
            bottom: 0;
            margin-left: -60px;
        }

@media only screen and (max-width:600px) {
    section .h01 {
        font-size: 2.5rem;
    }
}

/**
 * responsive:
 * common styles
 * - 
 */

@media only screen and (max-width:768px) {
    .section-intro {
        max-width: 650px;
    }

        .section-intro h1 {
            font-size: 4.2rem;
        }
}

@media only screen and (max-width:600px) {
    .section-intro h1 {
        font-size: 3.8rem;
    }

    .section-intro h5 {
        font-size: 1.5rem;
        letter-spacing: .3rem;
    }
}

@media only screen and (max-width:400px) {
    .section-intro h1 {
        font-size: 3.6rem;
    }
}

@media screen and (min-width: 320px) and (max-width: 499px) {
    #intro {
        background: #14181E url(/wp-content/uploads/new/bg-small-small.png) no-repeat center;
    }
}

@media screen and (min-width: 500px) and (max-width: 727px) {
    #intro {
        background: #14181E url(/wp-content/uploads/new/bg-small.png) no-repeat center;
    }
}

@media screen and (min-width: 728px) and (max-width: 889px) {
    #intro {
        background: #14181E url(/wp-content/uploads/new/bg.png) no-repeat right;
    }
}

@media (min-width:890px) {
    #intro {
        background: #14181E url(/wp-content/uploads/new/bg-desktop.png) no-repeat center;
    }
}

#intro {
    -webkit-background-size: cover;
    -moz-background-size: cover;
    background-size: cover;
    width: 100%;
    height: 100%;
    min-height: 720px;
    display: table;
    position: relative;
}

.shadow-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0.25) 25%, transparent 56%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0.25) 25%, transparent 56%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0.25) 25%, transparent 56%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#73000000', endColorstr='#00000000', GradientType=0); /* IE6-9 */
}

.intro-content {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    -webkit-transform: translateY(-1.2rem);
    -ms-transform: translateY(-1.2rem);
    transform: translateY(-1.2rem);
}

    .intro-content h1 {
        color: #FFFFFF;
        font-family: "merriweather-bold", serif;
        font-size: 5.4rem;
        line-height: 1.334;
        max-width: 800px;
        margin-left: auto;
        margin-right: auto;
    }

    .intro-content h5 {
        color: rgba(255, 255, 255, 0.6);
        font-family: "raleway-heavy", sans-serif;
        font-size: 1.8rem;
        line-height: 1.667;
        margin-bottom: 0.6rem;
        text-transform: uppercase;
        letter-spacing: .25rem;
    }

    .intro-content .video-link a {
        display: inline-block;
        width: 90px;
        height: 90px;
        margin-bottom: 4.2rem;
        outline: none;
    }

    .intro-content .button {
        border-color: #FFFFFF;
        color: #FFFFFF;
        height: 6.6rem;
        line-height: 6rem;
        padding: 0 3rem !important;
        margin-top: 1.8rem;
        font-family: "raleway-heavy", sans-serif;
        font-size: 1.4rem;
        text-transform: uppercase;
        letter-spacing: .4rem;
    }

        .intro-content .button:hover, .intro-content .button:focus {
            color: rgb(177, 139, 94);
            border-color: rgb(177, 139, 94);
        }

/**
 * responsive:
 * intro
 * -
 */

@media only screen and (max-width:1024px) {
    .intro-content {
        -webkit-transform: translateY(0);
        -ms-transform: translateY(0);
        transform: translateY(0);
    }

        .intro-content h1 {
            font-size: 4.8rem;
            max-width: 700px;
        }

        .intro-content h5 {
            font-size: 1.6rem;
        }

        .intro-content .video-link a {
            width: 72px;
            height: 72px;
            margin-bottom: 3rem;
        }
}

@media only screen and (max-width:768px) {
    #intro {
        min-height: 660px;
    }

    .intro-content h1 {
        font-size: 4.2rem;
        max-width: 550px;
    }

    .intro-content h5 {
        font-size: 1.5rem;
        letter-spacing: .15rem;
    }
}

@media only screen and (max-width:600px) {
    #intro {
        min-height: 600px;
    }

    .intro-content h1 {
        font-size: 3.8rem;
        margin-bottom: .9rem;
    }

    .intro-content h5 {
        font-size: 1.4rem;
        letter-spacing: .15rem;
    }

    .intro-content .video-link a {
        width: 66px;
        height: 66px;
        margin-bottom: 1.5rem;
    }
}

@media only screen and (max-width:400px) {
    #intro {
        min-height: 550px;
    }

    .intro-content h1 {
        font-size: 3.4rem;
    }

    .intro-content h5 {
        font-size: 1.4rem;
        letter-spacing: .15rem;
    }

    .intro-content .video-link a {
        width: 60px;
        height: 60px;
    }
}

/**
 * video popup modal
 * - 
 */

.popup-modal {
    max-width: 800px;
    background: #FFFFFF;
    position: relative;
    margin: 0 auto; /* close */
}

    .popup-modal .close-popup {
        position: absolute;
        right: 0;
        top: -42px;
        cursor: pointer;
        display: block;
        width: 30px;
        height: 30px;
        color: rgba(255, 255, 255, 0.5);
        text-align: center;
        font: 0/0 a;
        text-shadow: none;
        color: transparent;
    }

        .popup-modal .close-popup::before {
            display: block;
            width: 30px;
            height: 30px;
            line-height: 30px;
            font-family: "Ionicons";
            content: "\\f2d7";
            font-size: 21px;
            color: rgba(255, 255, 255, 0.5);
        }

/**
 * responsive:
 * video popup modal
 * - 
 */

@media only screen and (max-width:900px) {
    .popup-modal {
        max-width: 700px;
    }
}

@media only screen and (max-width:768px) {
    .popup-modal {
        width: auto;
        margin: 0 20px;
    }
}

/**
 * transition effect for modal popup
 * - 
 */

/* overlay at start */
.mfp-fade.mfp-bg {
    opacity: 0;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

    /* overlay animate in */
    .mfp-fade.mfp-bg.mfp-ready {
        opacity: 0.8;
    }

    /* overlay animate out */
    .mfp-fade.mfp-bg.mfp-removing {
        opacity: 0;
    }

/* content at start */
.mfp-fade.mfp-wrap .mfp-content {
    opacity: 0;
    -webkit-transform: translateY(-100%);
    -ms-transform: translateY(-100%);
    transform: translateY(-100%);
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

/* content animate in */
.mfp-fade.mfp-wrap.mfp-ready .mfp-content {
    opacity: 1;
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
}

/* content animate out */
.mfp-fade.mfp-wrap.mfp-removing .mfp-content {
    opacity: 0;
    -webkit-transform: translateY(-100%);
    -ms-transform: translateY(-100%);
    transform: translateY(-100%);
}

/** 
 * ===================================================================
 * features section
 *
 * ------------------------------------------------------------------- 
 */

#infraslimx {
    background: #090909 url(/wp-content/uploads/new/features-bg.jpg) repeat center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    background-size: cover;
    padding-top: 12rem;
    padding-bottom: 12rem;
    color: white;
}

    #infraslimx .section-intro h1 {
        color: white;
    }

    #infraslimx .section-intro h5 {
        color: rgba(255, 255, 255, 0.5);
    }

    #infraslimx .section-intro p {
        color: rgba(255, 255, 255, 0.7);
    }

.features-content {
    max-width: 1200px;
}

.features-list {
    margin-top: 1.2rem;
    text-align: center;
}

    .features-list .feature {
        margin-bottom: 1.2rem;
        padding: 0 32px;
    }

    .features-list .icon {
        display: inline-block;
        margin-bottom: 2.1rem;
    }

        .features-list .icon i {
            font-size: 4.8rem;
        }

    .features-list .h05 {
        font-size: 1.7rem;
        line-height: 1.765;
        color: rgb(177, 139, 94);
        margin-bottom: 1.8rem;
    }

/**
 * responsive:
 * features
 * -
 */

@media only screen and (max-width:768px) {
    .features-content {
        max-width: 600px;
    }

    .features-list .feature {
        padding: 0 15px;
    }
}

@media only screen and (max-width:600px) {
    .features-list .feature {
        padding: 0 10px;
    }
}

@media only screen and (max-width:400px) {
    .features-list .feature {
        padding: 0;
    }
}


/** 
 * ===================================================================
 * pricing section
 *
 * ------------------------------------------------------------------- 
 */

#pricing {
    background: #EAEAED;
    padding-top: 12rem;
    padding-bottom: 9.6rem;
}

.pricing-content {
    margin-top: 6.6rem;
    max-width: 1280px;
}

    .pricing-content .bgrid {
        margin-bottom: 3.6rem;
    }

    .pricing-content .price-block {
        background-color: #FFFFFF;
        border-radius: 5px;
        overflow: hidden;
        text-align: center;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    }

        .pricing-content .price-block .top-part,
        .pricing-content .price-block .bottom-part {
            padding: 3.9rem 1.5rem;
        }

        .pricing-content .price-block .top-part {
            background: rgb(177, 139, 94);
            color: #FFFFFF;
            padding-bottom: 2.4rem;
            position: relative;
        }

        .pricing-content .price-block .bottom-part {
            padding-top: 2.4rem;
            padding-left: 3rem;
            padding-right: 3rem;
        }

        .pricing-content .price-block .plan-title {
            color: #FFFFFF;
            padding-bottom: 2.4rem;
            margin-bottom: 1.2rem;
            font-size: 2.4rem;
            position: relative;
        }

            .pricing-content .price-block .plan-title::after {
                display: block;
                background-color: rgba(255, 255, 255, 0.3);
                width: 80px;
                height: 1px;
                content: '\\0020';
                position: absolute;
                left: 50%;
                bottom: 0;
                margin-left: -40px;
            }

        .pricing-content .price-block .plan-price {
            font-family: "raleway-bold", sans-serif;
            font-size: 5rem;
            line-height: 1;
            margin-bottom: .6rem;
        }

            .pricing-content .price-block .plan-price sup {
                font-size: 2.4rem;
                top: -1.5rem;
                margin-right: 3px;
            }

        .pricing-content .price-block .price-month {
            margin-bottom: 1.2rem;
            font-family: "raleway-bold", sans-serif;
            font-size: 1.6rem;
        }

        .pricing-content .price-block .price-meta {
            color: rgba(255, 255, 255, 0.5);
            line-height: 1.8rem;
        }

        .pricing-content .price-block .button {
            color: #353F49;
            padding: 0 5rem;
            margin-left: auto;
            margin-right: auto;
        }

            .pricing-content .price-block .button:hover,
            .pricing-content .price-block .button:focus {
                background: #58687b;
                color: #FFFFFF;
            }

        .pricing-content .price-block .features {
            list-style: none;
            font-family: "raleway-bold", sans-serif;
            font-size: 1.5rem;
            color: rgba(0, 0, 0, 0.4);
            margin: .6rem 0 1.8rem 0;
        }

            .pricing-content .price-block .features li {
                padding: .6rem 0;
                border-bottom: 1px solid #EAEAED;
            }

                .pricing-content .price-block .features li strong {
                    color: #353F49;
                    font-family: "raleway-bold", serif;
                    margin-right: 5px;
                }

                .pricing-content .price-block .features li:last-child {
                    border: none;
                }

    .pricing-content .primary .top-part {
        background: rgb(177, 139, 94);
    }

        .pricing-content .primary .top-part::before {
            content: attr(data-info);
            display: block;
            min-height: 48px;
            line-height: 48px;
            width: 75%;
            text-align: center;
            color: #FFFFFF;
            background: #38424e;
            font-family: "raleway-heavy", sans-serif;
            font-size: 1.2rem;
            text-transform: uppercase;
            letter-spacing: .15rem;
            position: absolute;
            bottom: -18px;
            left: 50%;
            -webkit-transform: translateX(-50%);
            -ms-transform: translateX(-50%);
            transform: translateX(-50%);
            z-index: 500;
            border-radius: 5px;
        }

/**
 * responsive:
 * pricing
 * -
 */

@media only screen and (max-width:1140px) {
    .pricing-content {
        max-width: 800px;
    }

        .pricing-content .bgrid {
            width: 50%;
            clear: none;
        }

            .pricing-content .bgrid:nth-child(2n+1) {
                clear: both;
            }
}

@media only screen and (max-width:600px) {
    .pricing-content {
        max-width: 420px;
    }

        .pricing-content .bgrid {
            width: 100% !important;
            float: none !important;
            clear: both !important;
            margin-left: 0;
            margin-right: 0;
        }
}


/** 
 * ===================================================================
 * testimonials section
 *
 * ------------------------------------------------------------------- 
 */

#testimonials {
    background: #FFFFFF;
    padding-top: 10.2rem;
    padding-bottom: 12rem;
    position: relative;
    min-height: 20.4rem;
    width: 100%;
    overflow: hidden;
    text-align: center;
}

    #testimonials .h01 {
        padding-bottom: 2.1rem;
        margin-bottom: 3.6rem;
        position: relative;
        color: #252525;
    }

        #testimonials .h01::after {
            display: block;
            background-color: rgb(177, 139, 94);
            width: 120px;
            height: 3px;
            content: '\\0020';
            position: absolute;
            left: 50%;
            bottom: 0;
            margin-left: -60px;
        }

    #testimonials .flex-container {
        width: 80%;
        max-width: 800px;
        margin: 0 auto;
    }

#testimonial-slider {
    margin: 0 0 3rem 0;
    position: relative;
}

    #testimonial-slider p {
        font-family: "raleway-medium", sans-serif;
        font-size: 2.5rem;
        line-height: 1.8;
        color: #8d8d8d;
    }

        #testimonial-slider p::before, #testimonial-slider p::after {
            display: inline;
            font-family: Arial, sans-serif;
            color: #c7c7c7;
            font-size: 6rem;
            line-height: 0;
            vertical-align: bottom;
            position: relative;
            top: -1.2rem;
        }

        #testimonial-slider p::before {
            margin-right: .5rem;
            content: '\\201C';
        }

        #testimonial-slider p::after {
            margin-left: .5rem;
            content: '\\201D';
        }

    #testimonial-slider .testimonial-author img {
        width: 8.2rem;
        height: 8.2rem;
        margin: 0 auto 1.2rem auto;
        display: block;
        border-radius: 50%;
        vertical-align: middle;
        border: 9px solid #EAEAED;
    }

    #testimonial-slider .testimonial-author .author-info {
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        font-family: "raleway-heavy", sans-serif;
        font-size: 1.5rem;
        letter-spacing: 2px;
        text-transform: uppercase;
        margin-bottom: 3rem;
        color: #252525;
    }

        #testimonial-slider .testimonial-author .author-info span {
            display: block;
            font-family: "raleway-semibold", sans-serif;
            font-size: 1.4rem;
            line-height: 2.1rem;
            letter-spacing: 0;
            text-transform: none;
            color: rgba(0, 0, 0, 0.4);
        }

/* control nav */
#testimonials .flex-control-nav {
    width: 100%;
    text-align: center;
    display: block;
    position: absolute;
    bottom: -42px;
}

    #testimonials .flex-control-nav li {
        margin: 0 6px;
        display: inline-block;
        zoom: 1;
    }

#testimonials .flex-control-paging li a {
    width: 15px;
    height: 15px;
    display: block;
    border: 4px solid #8d8d8d;
    cursor: pointer;
    border-radius: 50%;
    font: 0/0 a;
    text-shadow: none;
    color: transparent;
}

    #testimonials .flex-control-paging li a:hover {
        border: 4px solid rgb(177, 139, 94);
    }

    #testimonials .flex-control-paging li a.flex-active {
        background: rgb(177, 139, 94);
        border-color: rgb(177, 139, 94);
        cursor: default;
    }

/* direction nav */
#testimonials .flex-direction-nav li {
    padding: 0;
    z-index: 500;
    position: absolute;
    bottom: 0;
    margin-bottom: -57px;
}

    #testimonials .flex-direction-nav li a {
        display: block;
        opacity: .8;
        font: 0/0 a;
        text-shadow: none;
        color: transparent;
    }

        #testimonials .flex-direction-nav li a.flex-prev::before,
        #testimonials .flex-direction-nav li a.flex-next::after {
            display: block;
            background: #EAEAED;
            color: #737373;
            border-radius: 5px;
            font-family: "Ionicons";
            font-size: 18px;
            height: 48px;
            width: 48px;
            line-height: 48px;
            text-align: center;
            -moz-transition: all 0.3s ease-in-out;
            -o-transition: all 0.3s ease-in-out;
            -webkit-transition: all 0.3s ease-in-out;
            -ms-transition: all 0.3s ease-in-out;
            transition: all 0.3s ease-in-out;
        }

        #testimonials .flex-direction-nav li a.flex-prev::before {
            content: "\\f2ca";
        }

        #testimonials .flex-direction-nav li a.flex-next::after {
            content: "\\f30f";
        }

        #testimonials .flex-direction-nav li a.flex-next:hover::after,
        #testimonials .flex-direction-nav li a.flex-prev:hover::before {
            background: rgb(177, 139, 94);
            color: #FFFFFF;
        }

    #testimonials .flex-direction-nav li.flex-nav-prev {
        left: 0;
    }

    #testimonials .flex-direction-nav li.flex-nav-next {
        right: 0;
    }

/**
 * responsive:
 * testimonial slider
 * -
 */

@media only screen and (max-width:1024px) {
    #testimonials .flex-container {
        max-width: 600px;
    }

    #testimonial-slider p {
        font-size: 2.4rem;
    }
}

@media only screen and (max-width:768px) {
    #testimonials .flex-container {
        width: 90%;
    }

    #testimonial-slider p {
        font-size: 2.2rem;
    }
}

@media only screen and (max-width:600px) {
    #testimonials .flex-container {
        width: 95%;
    }

    #testimonial-slider p {
        font-size: 2rem;
    }

        #testimonial-slider p::before, #testimonial-slider p::after {
            top: -0.5rem;
        }
}

@media only screen and (max-width:400px) {
    #testimonials .flex-container {
        width: auto;
    }

    #testimonial-slider p {
        font-size: 1.8rem;
    }
}


/** 
 * ===================================================================
 * faq section
 *
 * ------------------------------------------------------------------- 
 */

#edesextra {
    background: #EAEAED;
    padding-top: 12rem;
    padding-bottom: 12rem;
}

.faq-content {
    margin-top: 5.4rem;
    max-width: 1020px;
}

    .faq-content .bgrid {
        padding: 0 30px;
    }

/**
 * responsive:
 * faq
 * -
 */

@media only screen and (max-width:768px) {
    .faq-content {
        max-width: 650px;
    }
}

@media only screen and (max-width:480px) {
    .faq-content .bgrid {
        padding: 0 20px;
    }
}

@media only screen and (max-width:400px) {
    .faq-content .bgrid {
        padding: 0;
    }
}


/** 
 * ===================================================================
 * ad-section
 *
 * ------------------------------------------------------------------- 
 */

.section-ads {
    margin-top: 4.8rem;
    padding-top: 6rem;
    max-width: 650px;
    border-top: 1px dotted rgba(0, 0, 0, 0.1);
    text-align: center;
}

    .section-ads h2 a, .section-ads h2 a:visited {
        color: #252525;
    }

    .section-ads span {
        color: #0087cc;
    }

    .section-ads .button {
        background: rgb(177, 139, 94);
        color: #FFFFFF;
    }

        .section-ads .button:hover, .section-ads .button:focus {
            background: #05ad9c;
        }


/** 
 * ===================================================================
 * call-to-action section
 *
 * ------------------------------------------------------------------- 
 */

#idopontfoglalas {
    background: rgb(177, 139, 94);
    padding-top: 7.2rem;
    padding-bottom: 9rem;
    text-align: center;
    color: #FFFFFF;
}

.cta-content {
    max-width: 740px;
    margin: 0 auto;
}

    .cta-content h1 {
        color: #FFFFFF;
        margin-bottom: .6rem;
    }

    .cta-content p {
        color: rgba(255, 255, 255, 0.8);
    }

    .cta-content .stores {
        margin: 0;
        padding: 0;
        display: block;
    }

        .cta-content .stores li {
            padding: 0;
            display: inline-block;
        }

            .cta-content .stores li .button {
                background: rgb(254, 248, 237);
                color: #FFFFFF;
                margin-right: 12px;
                display: block;
                line-height: 60px;
            }

                .cta-content .stores li .button:hover,
                .cta-content .stores li .button:focus {
                    background: rgb(254, 248, 237);
                }

                .cta-content .stores li .button i {
                    font-size: 18px;
                    line-height: inherit;
                    margin-right: 8px;
                }

                    .cta-content .stores li .button i.ion-social-windows {
                        font-size: 15px;
                    }

            .cta-content .stores li:last-child .button {
                margin-right: 0;
            }

/**
 * responsive:
 * cta
 * -
 */

@media only screen and (max-width:650px) {
    .cta-content {
        max-width: 650px;
    }

        .cta-content .stores li {
            display: block;
        }

            .cta-content .stores li .button {
                width: 300px;
                display: block;
                margin-left: auto !important;
                margin-right: auto !important;
                margin-bottom: 1.8rem;
            }

                .cta-content .stores li .button::before {
                    display: none;
                }
}

@media only screen and (max-width:600px) {
    .cta-content .stores li .button {
        width: 70%;
    }
}

@media only screen and (max-width:400px) {
    .cta-content .stores li .button {
        width: 80%;
    }
}


/** 
 * ===================================================================
 * footer
 *
 * ------------------------------------------------------------------- 
 */

footer {
    padding-bottom: 3rem;
    font-size: 1.5rem;
    line-height: 2.7rem;
    font-family: "raleway-medium", sans-serif;
    color: #465166;
}

    footer a, footer a:visited {
        color: rgb(177, 139, 94);
    }

        footer a:hover, footer a:focus {
            color: #FFFFFF;
        }

    footer h4 {
        border-bottom: 1px solid rgba(255, 255, 255, 0.03);
        padding-bottom: 1.2rem;
        margin-bottom: 1.2rem;
        color: #FFFFFF;
    }

    footer ul {
        margin-left: 0;
    }

        footer ul li {
            padding-left: 0;
        }

.footer-main {
    padding-top: 6.6rem;
    padding-bottom: 4.2rem;
    background: rgb(177, 139, 94);
}

    .footer-main ul {
        font-size: 1.5rem;
    }

        .footer-main ul li {
            font-family: "raleway-bold", sans-serif;
            list-style: none;
        }

        .footer-main ul a, .footer-main ul a:visited {
            color: #465166;
        }

            .footer-main ul a:hover, .footer-main ul a:focus {
                color: #FFFFFF;
            }

    .footer-main .footer-logo {
        width: 162px;
        height: 39px;
        background-size: 162px 39px;
        margin: -.6rem 0 2.1rem -.3rem;
        display: block;
    }

    .footer-main .footer-subscribe p {
        margin-bottom: 1.2rem;
    }

    .footer-main .footer-subscribe .subscribe-form #mc-form {
        padding: 0;
    }

    .footer-main .footer-subscribe .subscribe-form input[type="email"] {
        padding: .6rem 2rem;
        border-radius: 5px;
        background: #232933;
        border: none;
        width: 100%;
        font-family: "raleway-regular", sans-serif;
        color: #bababa;
        margin-bottom: 1.8rem;
    }

    .footer-main .footer-subscribe .subscribe-form input[type="submit"] {
        display: none;
    }

    .footer-main .footer-subscribe .subscribe-form .subscribe-message {
        font-family: "raleway-bold", sans-serif;
        color: #FFFFFF;
    }

        .footer-main .footer-subscribe .subscribe-form .subscribe-message i {
            color: #ff7b29;
            margin-right: 5px;
        }

    .footer-main .footer-subscribe .subscribe-form ::-webkit-input-placeholder {
        color: #545454;
    }

    .footer-main .footer-subscribe .subscribe-form :-moz-placeholder {
        /* Firefox 18- */
        color: #545454;
    }

    .footer-main .footer-subscribe .subscribe-form ::-moz-placeholder {
        /* Firefox 19+ */
        color: #545454;
    }

    .footer-main .footer-subscribe .subscribe-form :-ms-input-placeholder {
        color: #545454;
    }

    .footer-main .footer-subscribe .subscribe-form .placeholder {
        color: #545454 !important;
    }

.footer-bottom {
    margin-top: 3rem;
    text-align: center;
}

    .footer-bottom .copyright span {
        display: inline-block;
    }

        .footer-bottom .copyright span::after {
            content: "|";
            display: inline-block;
            padding: 0 1rem 0 1.2rem;
            color: rgba(255, 255, 255, 0.1);
        }

        .footer-bottom .copyright span:last-child::after {
            display: none;
        }

/**
 * responsive:
 * footer
 * -
 */

@media only screen and (max-width:768px) {
    .footer-main .footer-logo {
        margin-left: auto;
        margin-right: auto;
    }

    .footer-main .footer-info {
        text-align: center;
    }
}

@media only screen and (max-width:600px) {
    .footer-main .row {
        max-width: 420px;
    }

    .footer-main .footer-subscribe {
        text-align: center;
    }

    .footer-main .subscribe-form form input[type="email"] {
        margin-left: auto !important;
        margin-right: auto !important;
        text-align: center;
    }

    .footer-bottom {
        padding-bottom: .6rem;
    }

        .footer-bottom .copyright span {
            display: block;
        }

            .footer-bottom .copyright span::after {
                display: none;
            }
}

@media only screen and (max-width:400px) {
    .footer-main .site-links, .footer-main .social-links {
        text-align: center;
    }

        .footer-main .site-links h4, .footer-main .social-links h4 {
            border: none;
        }

    .footer-main ul {
        width: 80%;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }

        .footer-main ul li a {
            display: block;
            border-bottom: 1px solid rgba(255, 255, 255, 0.03);
            padding: .6rem 0;
        }

        .footer-main ul li:first-child a {
            border-top: 1px solid rgba(255, 255, 255, 0.03);
        }
}

/**
 * go to top
 * -
 */

#go-top {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 600;
    display: none;
}

    #go-top a {
        text-decoration: none;
        border: 0 none;
        display: block;
        height: 66px;
        width: 60px;
        line-height: 66px;
        text-align: center;
        background: #048a7c;
        color: #FFFFFF;
        text-align: center;
        text-transform: uppercase;
        -moz-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
        -webkit-transition: all 0.3s ease-in-out;
        -ms-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
    }

        #go-top a i {
            font-size: 20px;
            line-height: inherit;
        }

        #go-top a:hover {
            background: #ff7b29;
            color: #FFFFFF;
        }

/*# sourceMappingURL=main.css.map */

/**
 * =================================================================== 
 *
 *  Lhander 1.0 | Vendor/Third Party CSS 
 *  url: styleshout.com
 *  01-11-2016
 *
 * =================================================================== 
 */


/**
 * jQuery FlexSlider v2.5.0
 * http://www.woothemes.com/flexslider/
 *
 * Copyright 2012 WooThemes
 * Free to use under the GPLv2 and later license.
 * http://www.gnu.org/licenses/gpl-2.0.html
 *
 * Contributing author: Tyler Smith (@mbmufffin)
 * 
 * ===================================================================
 */

/* reset */
.flex-container a:hover,
.flex-slider a:hover,
.flex-container a:focus,
.flex-slider a:focus {
    outline: none;
}

.slides,
.slides > li,
.flex-control-nav,
.flex-direction-nav {
    margin: 0;
    padding: 0;
    list-style: none;
}

.flex-pauseplay span {
    text-transform: capitalize;
}

/* base styles */
.flexslider {
    margin: 0;
    padding: 0;
}

    .flexslider .slides > li {
        display: none;
        -webkit-backface-visibility: hidden;
    }

    .flexslider .slides img {
        width: 100%;
        display: block;
    }

    .flexslider .slides:after {
        content: "\\0020";
        display: block;
        clear: both;
        visibility: hidden;
        line-height: 0;
        height: 0;
    }

html[xmlns] .flexslider .slides {
    display: block;
}

* html .flexslider .slides {
    height: 1%;
}

.no-js .flexslider .slides > li:first-child {
    display: block;
}


/**
 * Magnific Popup CSS 
 * ===================================================================
 */

.mfp-bg {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1042;
    overflow: hidden;
    position: fixed;
    background: #0b0b0b;
    opacity: 0.8;
    filter: alpha(opacity=80);
}

.mfp-wrap {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1043;
    position: fixed;
    outline: none !important;
    -webkit-backface-visibility: hidden;
}

.mfp-container {
    text-align: center;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    padding: 0 8px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

    .mfp-container:before {
        content: '';
        display: inline-block;
        height: 100%;
        vertical-align: middle;
    }

.mfp-align-top .mfp-container:before {
    display: none;
}

.mfp-content {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    margin: 0 auto;
    text-align: left;
    z-index: 1045;
}

.mfp-inline-holder .mfp-content,
.mfp-ajax-holder .mfp-content {
    width: 100%;
    cursor: auto;
}

.mfp-ajax-cur {
    cursor: progress;
}

.mfp-zoom-out-cur, .mfp-zoom-out-cur .mfp-image-holder .mfp-close {
    cursor: -moz-zoom-out;
    cursor: -webkit-zoom-out;
    cursor: zoom-out;
}

.mfp-zoom {
    cursor: pointer;
    cursor: -webkit-zoom-in;
    cursor: -moz-zoom-in;
    cursor: zoom-in;
}

.mfp-auto-cursor .mfp-content {
    cursor: auto;
}

.mfp-close,
.mfp-arrow,
.mfp-preloader,
.mfp-counter {
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
}

.mfp-loading.mfp-figure {
    display: none;
}

.mfp-hide {
    display: none !important;
}

.mfp-preloader {
    color: #CCC;
    position: absolute;
    top: 50%;
    width: auto;
    text-align: center;
    margin-top: -0.8em;
    left: 8px;
    right: 8px;
    z-index: 1044;
}

    .mfp-preloader a {
        color: #CCC;
    }

        .mfp-preloader a:hover {
            color: #FFF;
        }

.mfp-s-ready .mfp-preloader {
    display: none;
}

.mfp-s-error .mfp-content {
    display: none;
}

button.mfp-close,
button.mfp-arrow {
    overflow: visible;
    cursor: pointer;
    background: transparent;
    border: 0;
    -webkit-appearance: none;
    display: block;
    outline: none;
    padding: 0;
    z-index: 1046;
    -webkit-box-shadow: none;
    box-shadow: none;
}

button::-moz-focus-inner {
    padding: 0;
    border: 0;
}

.mfp-close {
    width: 44px;
    height: 44px;
    line-height: 44px;
    position: absolute;
    right: 0;
    top: 0;
    text-decoration: none;
    text-align: center;
    opacity: 0.65;
    filter: alpha(opacity=65);
    padding: 0 0 18px 10px;
    color: #FFF;
    font-style: normal;
    font-size: 28px;
    font-family: Arial, Baskerville, monospace;
}

    .mfp-close:hover,
    .mfp-close:focus {
        opacity: 1;
        filter: alpha(opacity=100);
    }

    .mfp-close:active {
        top: 1px;
    }

.mfp-close-btn-in .mfp-close {
    color: #333;
}

.mfp-image-holder .mfp-close,
.mfp-iframe-holder .mfp-close {
    color: #FFF;
    right: -6px;
    text-align: right;
    padding-right: 6px;
    width: 100%;
}

.mfp-counter {
    position: absolute;
    top: 0;
    right: 0;
    color: #CCC;
    font-size: 12px;
    line-height: 18px;
    white-space: nowrap;
}

.mfp-arrow {
    position: absolute;
    opacity: 0.65;
    filter: alpha(opacity=65);
    margin: 0;
    top: 50%;
    margin-top: -55px;
    padding: 0;
    width: 90px;
    height: 110px;
    -webkit-tap-highlight-color: transparent;
}

    .mfp-arrow:active {
        margin-top: -54px;
    }

    .mfp-arrow:hover,
    .mfp-arrow:focus {
        opacity: 1;
        filter: alpha(opacity=100);
    }

    .mfp-arrow:before,
    .mfp-arrow:after,
    .mfp-arrow .mfp-b,
    .mfp-arrow .mfp-a {
        content: '';
        display: block;
        width: 0;
        height: 0;
        position: absolute;
        left: 0;
        top: 0;
        margin-top: 35px;
        margin-left: 35px;
        border: medium inset transparent;
    }

    .mfp-arrow:after,
    .mfp-arrow .mfp-a {
        border-top-width: 13px;
        border-bottom-width: 13px;
        top: 8px;
    }

    .mfp-arrow:before,
    .mfp-arrow .mfp-b {
        border-top-width: 21px;
        border-bottom-width: 21px;
        opacity: 0.7;
    }

.mfp-arrow-left {
    left: 0;
}

    .mfp-arrow-left:after,
    .mfp-arrow-left .mfp-a {
        border-right: 17px solid #FFF;
        margin-left: 31px;
    }

    .mfp-arrow-left:before,
    .mfp-arrow-left .mfp-b {
        margin-left: 25px;
        border-right: 27px solid #3F3F3F;
    }

.mfp-arrow-right {
    right: 0;
}

    .mfp-arrow-right:after,
    .mfp-arrow-right .mfp-a {
        border-left: 17px solid #FFF;
        margin-left: 39px;
    }

    .mfp-arrow-right:before,
    .mfp-arrow-right .mfp-b {
        border-left: 27px solid #3F3F3F;
    }

.mfp-iframe-holder {
    padding-top: 40px;
    padding-bottom: 40px;
}

    .mfp-iframe-holder .mfp-content {
        line-height: 0;
        width: 100%;
        max-width: 900px;
    }

    .mfp-iframe-holder .mfp-close {
        top: -40px;
    }

.mfp-iframe-scaler {
    width: 100%;
    height: 0;
    overflow: hidden;
    padding-top: 56.25%;
}

    .mfp-iframe-scaler iframe {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
        background: #000;
    }

/* Main image in popup */
img.mfp-img {
    width: auto;
    max-width: 100%;
    height: auto;
    display: block;
    line-height: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 40px 0 40px;
    margin: 0 auto;
}

/* The shadow behind the image */
.mfp-figure {
    line-height: 0;
}

    .mfp-figure:after {
        content: '';
        position: absolute;
        left: 0;
        top: 40px;
        bottom: 40px;
        display: block;
        right: 0;
        width: auto;
        height: auto;
        z-index: -1;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
        background: #444;
    }

    .mfp-figure small {
        color: #BDBDBD;
        display: block;
        font-size: 12px;
        line-height: 14px;
    }

    .mfp-figure figure {
        margin: 0;
    }

.mfp-bottom-bar {
    margin-top: -36px;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    cursor: auto;
}

.mfp-title {
    text-align: left;
    line-height: 18px;
    color: #F3F3F3;
    word-wrap: break-word;
    padding-right: 36px;
}

.mfp-image-holder .mfp-content {
    max-width: 100%;
}

.mfp-gallery .mfp-image-holder .mfp-figure {
    cursor: pointer;
}

@media screen and (max-width: 800px) and (orientation: landscape), screen and (max-height: 300px) {
    /**
       * Remove all paddings around the image on small screen
       */
    .mfp-img-mobile .mfp-image-holder {
        padding-left: 0;
        padding-right: 0;
    }

    .mfp-img-mobile img.mfp-img {
        padding: 0;
    }

    .mfp-img-mobile .mfp-figure:after {
        top: 0;
        bottom: 0;
    }

    .mfp-img-mobile .mfp-figure small {
        display: inline;
        margin-left: 5px;
    }

    .mfp-img-mobile .mfp-bottom-bar {
        background: rgba(0, 0, 0, 0.6);
        bottom: 0;
        margin: 0;
        top: auto;
        padding: 3px 5px;
        position: fixed;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }

        .mfp-img-mobile .mfp-bottom-bar:empty {
            padding: 0;
        }

    .mfp-img-mobile .mfp-counter {
        right: 5px;
        top: 3px;
    }

    .mfp-img-mobile .mfp-close {
        top: 0;
        right: 0;
        width: 35px;
        height: 35px;
        line-height: 35px;
        background: rgba(0, 0, 0, 0.6);
        position: fixed;
        text-align: center;
        padding: 0;
    }
}

@media all and (max-width: 900px) {
    .mfp-arrow {
        -webkit-transform: scale(0.75);
        transform: scale(0.75);
    }

    .mfp-arrow-left {
        -webkit-transform-origin: 0;
        transform-origin: 0;
    }

    .mfp-arrow-right {
        -webkit-transform-origin: 100%;
        transform-origin: 100%;
    }

    .mfp-container {
        padding-left: 6px;
        padding-right: 6px;
    }
}

.mfp-ie7 .mfp-img {
    padding: 0;
}

.mfp-ie7 .mfp-bottom-bar {
    width: 600px;
    left: 50%;
    margin-left: -300px;
    margin-top: 5px;
    padding-bottom: 5px;
}

.mfp-ie7 .mfp-container {
    padding: 0;
}

.mfp-ie7 .mfp-content {
    padding-top: 44px;
}

.mfp-ie7 .mfp-close {
    top: 0;
    right: 0;
    padding-top: 0;
}

/*# sourceMappingURL=vendor.css.map */

@charset "UTF-8"; /*!
  Ionicons, v2.0.1
  Created by Ben Sperry for the Ionic Framework, http://ionicons.com/
  https://twitter.com/benjsperry  https://twitter.com/ionicframework
  MIT License: https://github.com/driftyco/ionicons

  Android-style icons originally built by Googleâs
  Material Design Icons: https://github.com/google/material-design-icons
  used under CC BY http://creativecommons.org/licenses/by/4.0/
  Modified icons to fit ioniconâs grid from original.
*/

@font-face {
    font-family: "Ionicons";
    src: url("./fonts/ionicons.eot?v=2.0.1");
    src: url("./fonts/ionicons.eot?v=2.0.1#iefix") format("embedded-opentype"),url("./fonts/ionicons.ttf?v=2.0.1") format("truetype"),url("./fonts/ionicons.woff?v=2.0.1") format("woff"),url("./fonts/ionicons.svg?v=2.0.1#Ionicons") format("svg");
    font-weight: normal;
    font-style: normal
}

.ion, .ionicons, .ion-alert:before, .ion-alert-circled:before, .ion-android-add:before, .ion-android-add-circle:before, .ion-android-alarm-clock:before, .ion-android-alert:before, .ion-android-apps:before, .ion-android-archive:before, .ion-android-arrow-back:before, .ion-android-arrow-down:before, .ion-android-arrow-dropdown:before, .ion-android-arrow-dropdown-circle:before, .ion-android-arrow-dropleft:before, .ion-android-arrow-dropleft-circle:before, .ion-android-arrow-dropright:before, .ion-android-arrow-dropright-circle:before, .ion-android-arrow-dropup:before, .ion-android-arrow-dropup-circle:before, .ion-android-arrow-forward:before, .ion-android-arrow-up:before, .ion-android-attach:before, .ion-android-bar:before, .ion-android-bicycle:before, .ion-android-boat:before, .ion-android-bookmark:before, .ion-android-bulb:before, .ion-android-bus:before, .ion-android-calendar:before, .ion-android-call:before, .ion-android-camera:before, .ion-android-cancel:before, .ion-android-car:before, .ion-android-cart:before, .ion-android-chat:before, .ion-android-checkbox:before, .ion-android-checkbox-blank:before, .ion-android-checkbox-outline:before, .ion-android-checkbox-outline-blank:before, .ion-android-checkmark-circle:before, .ion-android-clipboard:before, .ion-android-close:before, .ion-android-cloud:before, .ion-android-cloud-circle:before, .ion-android-cloud-done:before, .ion-android-cloud-outline:before, .ion-android-color-palette:before, .ion-android-compass:before, .ion-android-contact:before, .ion-android-contacts:before, .ion-android-contract:before, .ion-android-create:before, .ion-android-delete:before, .ion-android-desktop:before, .ion-android-document:before, .ion-android-done:before, .ion-android-done-all:before, .ion-android-download:before, .ion-android-drafts:before, .ion-android-exit:before, .ion-android-expand:before, .ion-android-favorite:before, .ion-android-favorite-outline:before, .ion-android-film:before, .ion-android-folder:before, .ion-android-folder-open:before, .ion-android-funnel:before, .ion-android-globe:before, .ion-android-hand:before, .ion-android-hangout:before, .ion-android-happy:before, .ion-android-home:before, .ion-android-image:before, .ion-android-laptop:before, .ion-android-list:before, .ion-android-locate:before, .ion-android-lock:before, .ion-android-mail:before, .ion-android-map:before, .ion-android-menu:before, .ion-android-microphone:before, .ion-android-microphone-off:before, .ion-android-more-horizontal:before, .ion-android-more-vertical:before, .ion-android-navigate:before, .ion-android-notifications:before, .ion-android-notifications-none:before, .ion-android-notifications-off:before, .ion-android-open:before, .ion-android-options:before, .ion-android-people:before, .ion-android-person:before, .ion-android-person-add:before, .ion-android-phone-landscape:before, .ion-android-phone-portrait:before, .ion-android-pin:before, .ion-android-plane:before, .ion-android-playstore:before, .ion-android-print:before, .ion-android-radio-button-off:before, .ion-android-radio-button-on:before, .ion-android-refresh:before, .ion-android-remove:before, .ion-android-remove-circle:before, .ion-android-restaurant:before, .ion-android-sad:before, .ion-android-search:before, .ion-android-send:before, .ion-android-settings:before, .ion-android-share:before, .ion-android-share-alt:before, .ion-android-star:before, .ion-android-star-half:before, .ion-android-star-outline:before, .ion-android-stopwatch:before, .ion-android-subway:before, .ion-android-sunny:before, .ion-android-sync:before, .ion-android-textsms:before, .ion-android-time:before, .ion-android-train:before, .ion-android-unlock:before, .ion-android-upload:before, .ion-android-volume-down:before, .ion-android-volume-mute:before, .ion-android-volume-off:before, .ion-android-volume-up:before, .ion-android-walk:before, .ion-android-warning:before, .ion-android-watch:before, .ion-android-wifi:before, .ion-aperture:before, .ion-archive:before, .ion-arrow-down-a:before, .ion-arrow-down-b:before, .ion-arrow-down-c:before, .ion-arrow-expand:before, .ion-arrow-graph-down-left:before, .ion-arrow-graph-down-right:before, .ion-arrow-graph-up-left:before, .ion-arrow-graph-up-right:before, .ion-arrow-left-a:before, .ion-arrow-left-b:before, .ion-arrow-left-c:before, .ion-arrow-move:before, .ion-arrow-resize:before, .ion-arrow-return-left:before, .ion-arrow-return-right:before, .ion-arrow-right-a:before, .ion-arrow-right-b:before, .ion-arrow-right-c:before, .ion-arrow-shrink:before, .ion-arrow-swap:before, .ion-arrow-up-a:before, .ion-arrow-up-b:before, .ion-arrow-up-c:before, .ion-asterisk:before, .ion-at:before, .ion-backspace:before, .ion-backspace-outline:before, .ion-bag:before, .ion-battery-charging:before, .ion-battery-empty:before, .ion-battery-full:before, .ion-battery-half:before, .ion-battery-low:before, .ion-beaker:before, .ion-beer:before, .ion-bluetooth:before, .ion-bonfire:before, .ion-bookmark:before, .ion-bowtie:before, .ion-briefcase:before, .ion-bug:before, .ion-calculator:before, .ion-calendar:before, .ion-camera:before, .ion-card:before, .ion-cash:before, .ion-chatbox:before, .ion-chatbox-working:before, .ion-chatboxes:before, .ion-chatbubble:before, .ion-chatbubble-working:before, .ion-chatbubbles:before, .ion-checkmark:before, .ion-checkmark-circled:before, .ion-checkmark-round:before, .ion-chevron-down:before, .ion-chevron-left:before, .ion-chevron-right:before, .ion-chevron-up:before, .ion-clipboard:before, .ion-clock:before, .ion-close:before, .ion-close-circled:before, .ion-close-round:before, .ion-closed-captioning:before, .ion-cloud:before, .ion-code:before, .ion-code-download:before, .ion-code-working:before, .ion-coffee:before, .ion-compass:before, .ion-compose:before, .ion-connection-bars:before, .ion-contrast:before, .ion-crop:before, .ion-cube:before, .ion-disc:before, .ion-document:before, .ion-document-text:before, .ion-drag:before, .ion-earth:before, .ion-easel:before, .ion-edit:before, .ion-egg:before, .ion-eject:before, .ion-email:before, .ion-email-unread:before, .ion-erlenmeyer-flask:before, .ion-erlenmeyer-flask-bubbles:before, .ion-eye:before, .ion-eye-disabled:before, .ion-female:before, .ion-filing:before, .ion-film-marker:before, .ion-fireball:before, .ion-flag:before, .ion-flame:before, .ion-flash:before, .ion-flash-off:before, .ion-folder:before, .ion-fork:before, .ion-fork-repo:before, .ion-forward:before, .ion-funnel:before, .ion-gear-a:before, .ion-gear-b:before, .ion-grid:before, .ion-hammer:before, .ion-happy:before, .ion-happy-outline:before, .ion-headphone:before, .ion-heart:before, .ion-heart-broken:before, .ion-help:before, .ion-help-buoy:before, .ion-help-circled:before, .ion-home:before, .ion-icecream:before, .ion-image:before, .ion-images:before, .ion-information:before, .ion-information-circled:before, .ion-ionic:before, .ion-ios-alarm:before, .ion-ios-alarm-outline:before, .ion-ios-albums:before, .ion-ios-albums-outline:before, .ion-ios-americanfootball:before, .ion-ios-americanfootball-outline:before, .ion-ios-analytics:before, .ion-ios-analytics-outline:before, .ion-ios-arrow-back:before, .ion-ios-arrow-down:before, .ion-ios-arrow-forward:before, .ion-ios-arrow-left:before, .ion-ios-arrow-right:before, .ion-ios-arrow-thin-down:before, .ion-ios-arrow-thin-left:before, .ion-ios-arrow-thin-right:before, .ion-ios-arrow-thin-up:before, .ion-ios-arrow-up:before, .ion-ios-at:before, .ion-ios-at-outline:before, .ion-ios-barcode:before, .ion-ios-barcode-outline:before, .ion-ios-baseball:before, .ion-ios-baseball-outline:before, .ion-ios-basketball:before, .ion-ios-basketball-outline:before, .ion-ios-bell:before, .ion-ios-bell-outline:before, .ion-ios-body:before, .ion-ios-body-outline:before, .ion-ios-bolt:before, .ion-ios-bolt-outline:before, .ion-ios-book:before, .ion-ios-book-outline:before, .ion-ios-bookmarks:before, .ion-ios-bookmarks-outline:before, .ion-ios-box:before, .ion-ios-box-outline:before, .ion-ios-briefcase:before, .ion-ios-briefcase-outline:before, .ion-ios-browsers:before, .ion-ios-browsers-outline:before, .ion-ios-calculator:before, .ion-ios-calculator-outline:before, .ion-ios-calendar:before, .ion-ios-calendar-outline:before, .ion-ios-camera:before, .ion-ios-camera-outline:before, .ion-ios-cart:before, .ion-ios-cart-outline:before, .ion-ios-chatboxes:before, .ion-ios-chatboxes-outline:before, .ion-ios-chatbubble:before, .ion-ios-chatbubble-outline:before, .ion-ios-checkmark:before, .ion-ios-checkmark-empty:before, .ion-ios-checkmark-outline:before, .ion-ios-circle-filled:before, .ion-ios-circle-outline:before, .ion-ios-clock:before, .ion-ios-clock-outline:before, .ion-ios-close:before, .ion-ios-close-empty:before, .ion-ios-close-outline:before, .ion-ios-cloud:before, .ion-ios-cloud-download:before, .ion-ios-cloud-download-outline:before, .ion-ios-cloud-outline:before, .ion-ios-cloud-upload:before, .ion-ios-cloud-upload-outline:before, .ion-ios-cloudy:before, .ion-ios-cloudy-night:before, .ion-ios-cloudy-night-outline:before, .ion-ios-cloudy-outline:before, .ion-ios-cog:before, .ion-ios-cog-outline:before, .ion-ios-color-filter:before, .ion-ios-color-filter-outline:before, .ion-ios-color-wand:before, .ion-ios-color-wand-outline:before, .ion-ios-compose:before, .ion-ios-compose-outline:before, .ion-ios-contact:before, .ion-ios-contact-outline:before, .ion-ios-copy:before, .ion-ios-copy-outline:before, .ion-ios-crop:before, .ion-ios-crop-strong:before, .ion-ios-download:before, .ion-ios-download-outline:before, .ion-ios-drag:before, .ion-ios-email:before, .ion-ios-email-outline:before, .ion-ios-eye:before, .ion-ios-eye-outline:before, .ion-ios-fastforward:before, .ion-ios-fastforward-outline:before, .ion-ios-filing:before, .ion-ios-filing-outline:before, .ion-ios-film:before, .ion-ios-film-outline:before, .ion-ios-flag:before, .ion-ios-flag-outline:before, .ion-ios-flame:before, .ion-ios-flame-outline:before, .ion-ios-flask:before, .ion-ios-flask-outline:before, .ion-ios-flower:before, .ion-ios-flower-outline:before, .ion-ios-folder:before, .ion-ios-folder-outline:before, .ion-ios-football:before, .ion-ios-football-outline:before, .ion-ios-game-controller-a:before, .ion-ios-game-controller-a-outline:before, .ion-ios-game-controller-b:before, .ion-ios-game-controller-b-outline:before, .ion-ios-gear:before, .ion-ios-gear-outline:before, .ion-ios-glasses:before, .ion-ios-glasses-outline:before, .ion-ios-grid-view:before, .ion-ios-grid-view-outline:before, .ion-ios-heart:before, .ion-ios-heart-outline:before, .ion-ios-help:before, .ion-ios-help-empty:before, .ion-ios-help-outline:before, .ion-ios-home:before, .ion-ios-home-outline:before, .ion-ios-infinite:before, .ion-ios-infinite-outline:before, .ion-ios-information:before, .ion-ios-information-empty:before, .ion-ios-information-outline:before, .ion-ios-ionic-outline:before, .ion-ios-keypad:before, .ion-ios-keypad-outline:before, .ion-ios-lightbulb:before, .ion-ios-lightbulb-outline:before, .ion-ios-list:before, .ion-ios-list-outline:before, .ion-ios-location:before, .ion-ios-location-outline:before, .ion-ios-locked:before, .ion-ios-locked-outline:before, .ion-ios-loop:before, .ion-ios-loop-strong:before, .ion-ios-medical:before, .ion-ios-medical-outline:before, .ion-ios-medkit:before, .ion-ios-medkit-outline:before, .ion-ios-mic:before, .ion-ios-mic-off:before, .ion-ios-mic-outline:before, .ion-ios-minus:before, .ion-ios-minus-empty:before, .ion-ios-minus-outline:before, .ion-ios-monitor:before, .ion-ios-monitor-outline:before, .ion-ios-moon:before, .ion-ios-moon-outline:before, .ion-ios-more:before, .ion-ios-more-outline:before, .ion-ios-musical-note:before, .ion-ios-musical-notes:before, .ion-ios-navigate:before, .ion-ios-navigate-outline:before, .ion-ios-nutrition:before, .ion-ios-nutrition-outline:before, .ion-ios-paper:before, .ion-ios-paper-outline:before, .ion-ios-paperplane:before, .ion-ios-paperplane-outline:before, .ion-ios-partlysunny:before, .ion-ios-partlysunny-outline:before, .ion-ios-pause:before, .ion-ios-pause-outline:before, .ion-ios-paw:before, .ion-ios-paw-outline:before, .ion-ios-people:before, .ion-ios-people-outline:before, .ion-ios-person:before, .ion-ios-person-outline:before, .ion-ios-personadd:before, .ion-ios-personadd-outline:before, .ion-ios-photos:before, .ion-ios-photos-outline:before, .ion-ios-pie:before, .ion-ios-pie-outline:before, .ion-ios-pint:before, .ion-ios-pint-outline:before, .ion-ios-play:before, .ion-ios-play-outline:before, .ion-ios-plus:before, .ion-ios-plus-empty:before, .ion-ios-plus-outline:before, .ion-ios-pricetag:before, .ion-ios-pricetag-outline:before, .ion-ios-pricetags:before, .ion-ios-pricetags-outline:before, .ion-ios-printer:before, .ion-ios-printer-outline:before, .ion-ios-pulse:before, .ion-ios-pulse-strong:before, .ion-ios-rainy:before, .ion-ios-rainy-outline:before, .ion-ios-recording:before, .ion-ios-recording-outline:before, .ion-ios-redo:before, .ion-ios-redo-outline:before, .ion-ios-refresh:before, .ion-ios-refresh-empty:before, .ion-ios-refresh-outline:before, .ion-ios-reload:before, .ion-ios-reverse-camera:before, .ion-ios-reverse-camera-outline:before, .ion-ios-rewind:before, .ion-ios-rewind-outline:before, .ion-ios-rose:before, .ion-ios-rose-outline:before, .ion-ios-search:before, .ion-ios-search-strong:before, .ion-ios-settings:before, .ion-ios-settings-strong:before, .ion-ios-shuffle:before, .ion-ios-shuffle-strong:before, .ion-ios-skipbackward:before, .ion-ios-skipbackward-outline:before, .ion-ios-skipforward:before, .ion-ios-skipforward-outline:before, .ion-ios-snowy:before, .ion-ios-speedometer:before, .ion-ios-speedometer-outline:before, .ion-ios-star:before, .ion-ios-star-half:before, .ion-ios-star-outline:before, .ion-ios-stopwatch:before, .ion-ios-stopwatch-outline:before, .ion-ios-sunny:before, .ion-ios-sunny-outline:before, .ion-ios-telephone:before, .ion-ios-telephone-outline:before, .ion-ios-tennisball:before, .ion-ios-tennisball-outline:before, .ion-ios-thunderstorm:before, .ion-ios-thunderstorm-outline:before, .ion-ios-time:before, .ion-ios-time-outline:before, .ion-ios-timer:before, .ion-ios-timer-outline:before, .ion-ios-toggle:before, .ion-ios-toggle-outline:before, .ion-ios-trash:before, .ion-ios-trash-outline:before, .ion-ios-undo:before, .ion-ios-undo-outline:before, .ion-ios-unlocked:before, .ion-ios-unlocked-outline:before, .ion-ios-upload:before, .ion-ios-upload-outline:before, .ion-ios-videocam:before, .ion-ios-videocam-outline:before, .ion-ios-volume-high:before, .ion-ios-volume-low:before, .ion-ios-wineglass:before, .ion-ios-wineglass-outline:before, .ion-ios-world:before, .ion-ios-world-outline:before, .ion-ipad:before, .ion-iphone:before, .ion-ipod:before, .ion-jet:before, .ion-key:before, .ion-knife:before, .ion-laptop:before, .ion-leaf:before, .ion-levels:before, .ion-lightbulb:before, .ion-link:before, .ion-load-a:before, .ion-load-b:before, .ion-load-c:before, .ion-load-d:before, .ion-location:before, .ion-lock-combination:before, .ion-locked:before, .ion-log-in:before, .ion-log-out:before, .ion-loop:before, .ion-magnet:before, .ion-male:before, .ion-man:before, .ion-map:before, .ion-medkit:before, .ion-merge:before, .ion-mic-a:before, .ion-mic-b:before, .ion-mic-c:before, .ion-minus:before, .ion-minus-circled:before, .ion-minus-round:before, .ion-model-s:before, .ion-monitor:before, .ion-more:before, .ion-mouse:before, .ion-music-note:before, .ion-navicon:before, .ion-navicon-round:before, .ion-navigate:before, .ion-network:before, .ion-no-smoking:before, .ion-nuclear:before, .ion-outlet:before, .ion-paintbrush:before, .ion-paintbucket:before, .ion-paper-airplane:before, .ion-paperclip:before, .ion-pause:before, .ion-person:before, .ion-person-add:before, .ion-person-stalker:before, .ion-pie-graph:before, .ion-pin:before, .ion-pinpoint:before, .ion-pizza:before, .ion-plane:before, .ion-planet:before, .ion-play:before, .ion-playstation:before, .ion-plus:before, .ion-plus-circled:before, .ion-plus-round:before, .ion-podium:before, .ion-pound:before, .ion-power:before, .ion-pricetag:before, .ion-pricetags:before, .ion-printer:before, .ion-pull-request:before, .ion-qr-scanner:before, .ion-quote:before, .ion-radio-waves:before, .ion-record:before, .ion-refresh:before, .ion-reply:before, .ion-reply-all:before, .ion-ribbon-a:before, .ion-ribbon-b:before, .ion-sad:before, .ion-sad-outline:before, .ion-scissors:before, .ion-search:before, .ion-settings:before, .ion-share:before, .ion-shuffle:before, .ion-skip-backward:before, .ion-skip-forward:before, .ion-social-android:before, .ion-social-android-outline:before, .ion-social-angular:before, .ion-social-angular-outline:before, .ion-social-apple:before, .ion-social-apple-outline:before, .ion-social-bitcoin:before, .ion-social-bitcoin-outline:before, .ion-social-buffer:before, .ion-social-buffer-outline:before, .ion-social-chrome:before, .ion-social-chrome-outline:before, .ion-social-codepen:before, .ion-social-codepen-outline:before, .ion-social-css3:before, .ion-social-css3-outline:before, .ion-social-designernews:before, .ion-social-designernews-outline:before, .ion-social-dribbble:before, .ion-social-dribbble-outline:before, .ion-social-dropbox:before, .ion-social-dropbox-outline:before, .ion-social-euro:before, .ion-social-euro-outline:before, .ion-social-facebook:before, .ion-social-facebook-outline:before, .ion-social-foursquare:before, .ion-social-foursquare-outline:before, .ion-social-freebsd-devil:before, .ion-social-github:before, .ion-social-github-outline:before, .ion-social-google:before, .ion-social-google-outline:before, .ion-social-googleplus:before, .ion-social-googleplus-outline:before, .ion-social-hackernews:before, .ion-social-hackernews-outline:before, .ion-social-html5:before, .ion-social-html5-outline:before, .ion-social-instagram:before, .ion-social-instagram-outline:before, .ion-social-javascript:before, .ion-social-javascript-outline:before, .ion-social-linkedin:before, .ion-social-linkedin-outline:before, .ion-social-markdown:before, .ion-social-nodejs:before, .ion-social-octocat:before, .ion-social-pinterest:before, .ion-social-pinterest-outline:before, .ion-social-python:before, .ion-social-reddit:before, .ion-social-reddit-outline:before, .ion-social-rss:before, .ion-social-rss-outline:before, .ion-social-sass:before, .ion-social-skype:before, .ion-social-skype-outline:before, .ion-social-snapchat:before, .ion-social-snapchat-outline:before, .ion-social-tumblr:before, .ion-social-tumblr-outline:before, .ion-social-tux:before, .ion-social-twitch:before, .ion-social-twitch-outline:before, .ion-social-twitter:before, .ion-social-twitter-outline:before, .ion-social-usd:before, .ion-social-usd-outline:before, .ion-social-vimeo:before, .ion-social-vimeo-outline:before, .ion-social-whatsapp:before, .ion-social-whatsapp-outline:before, .ion-social-windows:before, .ion-social-windows-outline:before, .ion-social-wordpress:before, .ion-social-wordpress-outline:before, .ion-social-yahoo:before, .ion-social-yahoo-outline:before, .ion-social-yen:before, .ion-social-yen-outline:before, .ion-social-youtube:before, .ion-social-youtube-outline:before, .ion-soup-can:before, .ion-soup-can-outline:before, .ion-speakerphone:before, .ion-speedometer:before, .ion-spoon:before, .ion-star:before, .ion-stats-bars:before, .ion-steam:before, .ion-stop:before, .ion-thermometer:before, .ion-thumbsdown:before, .ion-thumbsup:before, .ion-toggle:before, .ion-toggle-filled:before, .ion-transgender:before, .ion-trash-a:before, .ion-trash-b:before, .ion-trophy:before, .ion-tshirt:before, .ion-tshirt-outline:before, .ion-umbrella:before, .ion-university:before, .ion-unlocked:before, .ion-upload:before, .ion-usb:before, .ion-videocamera:before, .ion-volume-high:before, .ion-volume-low:before, .ion-volume-medium:before, .ion-volume-mute:before, .ion-wand:before, .ion-waterdrop:before, .ion-wifi:before, .ion-wineglass:before, .ion-woman:before, .ion-wrench:before, .ion-xbox:before {
    display: inline-block;
    font-family: "Ionicons";
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    text-rendering: auto;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale
}

.ion-alert:before {
    content: "\\f101"
}

.ion-alert-circled:before {
    content: "\\f100"
}

.ion-android-add:before {
    content: "\\f2c7"
}

.ion-android-add-circle:before {
    content: "\\f359"
}

.ion-android-alarm-clock:before {
    content: "\\f35a"
}

.ion-android-alert:before {
    content: "\\f35b"
}

.ion-android-apps:before {
    content: "\\f35c"
}

.ion-android-archive:before {
    content: "\\f2c9"
}

.ion-android-arrow-back:before {
    content: "\\f2ca"
}

.ion-android-arrow-down:before {
    content: "\\f35d"
}

.ion-android-arrow-dropdown:before {
    content: "\\f35f"
}

.ion-android-arrow-dropdown-circle:before {
    content: "\\f35e"
}

.ion-android-arrow-dropleft:before {
    content: "\\f361"
}

.ion-android-arrow-dropleft-circle:before {
    content: "\\f360"
}

.ion-android-arrow-dropright:before {
    content: "\\f363"
}

.ion-android-arrow-dropright-circle:before {
    content: "\\f362"
}

.ion-android-arrow-dropup:before {
    content: "\\f365"
}

.ion-android-arrow-dropup-circle:before {
    content: "\\f364"
}

.ion-android-arrow-forward:before {
    content: "\\f30f"
}

.ion-android-arrow-up:before {
    content: "\\f366"
}

.ion-android-attach:before {
    content: "\\f367"
}

.ion-android-bar:before {
    content: "\\f368"
}

.ion-android-bicycle:before {
    content: "\\f369"
}

.ion-android-boat:before {
    content: "\\f36a"
}

.ion-android-bookmark:before {
    content: "\\f36b"
}

.ion-android-bulb:before {
    content: "\\f36c"
}

.ion-android-bus:before {
    content: "\\f36d"
}

.ion-android-calendar:before {
    content: "\\f2d1"
}

.ion-android-call:before {
    content: "\\f2d2"
}

.ion-android-camera:before {
    content: "\\f2d3"
}

.ion-android-cancel:before {
    content: "\\f36e"
}

.ion-android-car:before {
    content: "\\f36f"
}

.ion-android-cart:before {
    content: "\\f370"
}

.ion-android-chat:before {
    content: "\\f2d4"
}

.ion-android-checkbox:before {
    content: "\\f374"
}

.ion-android-checkbox-blank:before {
    content: "\\f371"
}

.ion-android-checkbox-outline:before {
    content: "\\f373"
}

.ion-android-checkbox-outline-blank:before {
    content: "\\f372"
}

.ion-android-checkmark-circle:before {
    content: "\\f375"
}

.ion-android-clipboard:before {
    content: "\\f376"
}

.ion-android-close:before {
    content: "\\f2d7"
}

.ion-android-cloud:before {
    content: "\\f37a"
}

.ion-android-cloud-circle:before {
    content: "\\f377"
}

.ion-android-cloud-done:before {
    content: "\\f378"
}

.ion-android-cloud-outline:before {
    content: "\\f379"
}

.ion-android-color-palette:before {
    content: "\\f37b"
}

.ion-android-compass:before {
    content: "\\f37c"
}

.ion-android-contact:before {
    content: "\\f2d8"
}

.ion-android-contacts:before {
    content: "\\f2d9"
}

.ion-android-contract:before {
    content: "\\f37d"
}

.ion-android-create:before {
    content: "\\f37e"
}

.ion-android-delete:before {
    content: "\\f37f"
}

.ion-android-desktop:before {
    content: "\\f380"
}

.ion-android-document:before {
    content: "\\f381"
}

.ion-android-done:before {
    content: "\\f383"
}

.ion-android-done-all:before {
    content: "\\f382"
}

.ion-android-download:before {
    content: "\\f2dd"
}

.ion-android-drafts:before {
    content: "\\f384"
}

.ion-android-exit:before {
    content: "\\f385"
}

.ion-android-expand:before {
    content: "\\f386"
}

.ion-android-favorite:before {
    content: "\\f388"
}

.ion-android-favorite-outline:before {
    content: "\\f387"
}

.ion-android-film:before {
    content: "\\f389"
}

.ion-android-folder:before {
    content: "\\f2e0"
}

.ion-android-folder-open:before {
    content: "\\f38a"
}

.ion-android-funnel:before {
    content: "\\f38b"
}

.ion-android-globe:before {
    content: "\\f38c"
}

.ion-android-hand:before {
    content: "\\f2e3"
}

.ion-android-hangout:before {
    content: "\\f38d"
}

.ion-android-happy:before {
    content: "\\f38e"
}

.ion-android-home:before {
    content: "\\f38f"
}

.ion-android-image:before {
    content: "\\f2e4"
}

.ion-android-laptop:before {
    content: "\\f390"
}

.ion-android-list:before {
    content: "\\f391"
}

.ion-android-locate:before {
    content: "\\f2e9"
}

.ion-android-lock:before {
    content: "\\f392"
}

.ion-android-mail:before {
    content: "\\f2eb"
}

.ion-android-map:before {
    content: "\\f393"
}

.ion-android-menu:before {
    content: "\\f394"
}

.ion-android-microphone:before {
    content: "\\f2ec"
}

.ion-android-microphone-off:before {
    content: "\\f395"
}

.ion-android-more-horizontal:before {
    content: "\\f396"
}

.ion-android-more-vertical:before {
    content: "\\f397"
}

.ion-android-navigate:before {
    content: "\\f398"
}

.ion-android-notifications:before {
    content: "\\f39b"
}

.ion-android-notifications-none:before {
    content: "\\f399"
}

.ion-android-notifications-off:before {
    content: "\\f39a"
}

.ion-android-open:before {
    content: "\\f39c"
}

.ion-android-options:before {
    content: "\\f39d"
}

.ion-android-people:before {
    content: "\\f39e"
}

.ion-android-person:before {
    content: "\\f3a0"
}

.ion-android-person-add:before {
    content: "\\f39f"
}

.ion-android-phone-landscape:before {
    content: "\\f3a1"
}

.ion-android-phone-portrait:before {
    content: "\\f3a2"
}

.ion-android-pin:before {
    content: "\\f3a3"
}

.ion-android-plane:before {
    content: "\\f3a4"
}

.ion-android-playstore:before {
    content: "\\f2f0"
}

.ion-android-print:before {
    content: "\\f3a5"
}

.ion-android-radio-button-off:before {
    content: "\\f3a6"
}

.ion-android-radio-button-on:before {
    content: "\\f3a7"
}

.ion-android-refresh:before {
    content: "\\f3a8"
}

.ion-android-remove:before {
    content: "\\f2f4"
}

.ion-android-remove-circle:before {
    content: "\\f3a9"
}

.ion-android-restaurant:before {
    content: "\\f3aa"
}

.ion-android-sad:before {
    content: "\\f3ab"
}

.ion-android-search:before {
    content: "\\f2f5"
}

.ion-android-send:before {
    content: "\\f2f6"
}

.ion-android-settings:before {
    content: "\\f2f7"
}

.ion-android-share:before {
    content: "\\f2f8"
}

.ion-android-share-alt:before {
    content: "\\f3ac"
}

.ion-android-star:before {
    content: "\\f2fc"
}

.ion-android-star-half:before {
    content: "\\f3ad"
}

.ion-android-star-outline:before {
    content: "\\f3ae"
}

.ion-android-stopwatch:before {
    content: "\\f2fd"
}

.ion-android-subway:before {
    content: "\\f3af"
}

.ion-android-sunny:before {
    content: "\\f3b0"
}

.ion-android-sync:before {
    content: "\\f3b1"
}

.ion-android-textsms:before {
    content: "\\f3b2"
}

.ion-android-time:before {
    content: "\\f3b3"
}

.ion-android-train:before {
    content: "\\f3b4"
}

.ion-android-unlock:before {
    content: "\\f3b5"
}

.ion-android-upload:before {
    content: "\\f3b6"
}

.ion-android-volume-down:before {
    content: "\\f3b7"
}

.ion-android-volume-mute:before {
    content: "\\f3b8"
}

.ion-android-volume-off:before {
    content: "\\f3b9"
}

.ion-android-volume-up:before {
    content: "\\f3ba"
}

.ion-android-walk:before {
    content: "\\f3bb"
}

.ion-android-warning:before {
    content: "\\f3bc"
}

.ion-android-watch:before {
    content: "\\f3bd"
}

.ion-android-wifi:before {
    content: "\\f305"
}

.ion-aperture:before {
    content: "\\f313"
}

.ion-archive:before {
    content: "\\f102"
}

.ion-arrow-down-a:before {
    content: "\\f103"
}

.ion-arrow-down-b:before {
    content: "\\f104"
}

.ion-arrow-down-c:before {
    content: "\\f105"
}

.ion-arrow-expand:before {
    content: "\\f25e"
}

.ion-arrow-graph-down-left:before {
    content: "\\f25f"
}

.ion-arrow-graph-down-right:before {
    content: "\\f260"
}

.ion-arrow-graph-up-left:before {
    content: "\\f261"
}

.ion-arrow-graph-up-right:before {
    content: "\\f262"
}

.ion-arrow-left-a:before {
    content: "\\f106"
}

.ion-arrow-left-b:before {
    content: "\\f107"
}

.ion-arrow-left-c:before {
    content: "\\f108"
}

.ion-arrow-move:before {
    content: "\\f263"
}

.ion-arrow-resize:before {
    content: "\\f264"
}

.ion-arrow-return-left:before {
    content: "\\f265"
}

.ion-arrow-return-right:before {
    content: "\\f266"
}

.ion-arrow-right-a:before {
    content: "\\f109"
}

.ion-arrow-right-b:before {
    content: "\\f10a"
}

.ion-arrow-right-c:before {
    content: "\\f10b"
}

.ion-arrow-shrink:before {
    content: "\\f267"
}

.ion-arrow-swap:before {
    content: "\\f268"
}

.ion-arrow-up-a:before {
    content: "\\f10c"
}

.ion-arrow-up-b:before {
    content: "\\f10d"
}

.ion-arrow-up-c:before {
    content: "\\f10e"
}

.ion-asterisk:before {
    content: "\\f314"
}

.ion-at:before {
    content: "\\f10f"
}

.ion-backspace:before {
    content: "\\f3bf"
}

.ion-backspace-outline:before {
    content: "\\f3be"
}

.ion-bag:before {
    content: "\\f110"
}

.ion-battery-charging:before {
    content: "\\f111"
}

.ion-battery-empty:before {
    content: "\\f112"
}

.ion-battery-full:before {
    content: "\\f113"
}

.ion-battery-half:before {
    content: "\\f114"
}

.ion-battery-low:before {
    content: "\\f115"
}

.ion-beaker:before {
    content: "\\f269"
}

.ion-beer:before {
    content: "\\f26a"
}

.ion-bluetooth:before {
    content: "\\f116"
}

.ion-bonfire:before {
    content: "\\f315"
}

.ion-bookmark:before {
    content: "\\f26b"
}

.ion-bowtie:before {
    content: "\\f3c0"
}

.ion-briefcase:before {
    content: "\\f26c"
}

.ion-bug:before {
    content: "\\f2be"
}

.ion-calculator:before {
    content: "\\f26d"
}

.ion-calendar:before {
    content: "\\f117"
}

.ion-camera:before {
    content: "\\f118"
}

.ion-card:before {
    content: "\\f119"
}

.ion-cash:before {
    content: "\\f316"
}

.ion-chatbox:before {
    content: "\\f11b"
}

.ion-chatbox-working:before {
    content: "\\f11a"
}

.ion-chatboxes:before {
    content: "\\f11c"
}

.ion-chatbubble:before {
    content: "\\f11e"
}

.ion-chatbubble-working:before {
    content: "\\f11d"
}

.ion-chatbubbles:before {
    content: "\\f11f"
}

.ion-checkmark:before {
    content: "\\f122"
}

.ion-checkmark-circled:before {
    content: "\\f120"
}

.ion-checkmark-round:before {
    content: "\\f121"
}

.ion-chevron-down:before {
    content: "\\f123"
}

.ion-chevron-left:before {
    content: "\\f124"
}

.ion-chevron-right:before {
    content: "\\f125"
}

.ion-chevron-up:before {
    content: "\\f126"
}

.ion-clipboard:before {
    content: "\\f127"
}

.ion-clock:before {
    content: "\\f26e"
}

.ion-close:before {
    content: "\\f12a"
}

.ion-close-circled:before {
    content: "\\f128"
}

.ion-close-round:before {
    content: "\\f129"
}

.ion-closed-captioning:before {
    content: "\\f317"
}

.ion-cloud:before {
    content: "\\f12b"
}

.ion-code:before {
    content: "\\f271"
}

.ion-code-download:before {
    content: "\\f26f"
}

.ion-code-working:before {
    content: "\\f270"
}

.ion-coffee:before {
    content: "\\f272"
}

.ion-compass:before {
    content: "\\f273"
}

.ion-compose:before {
    content: "\\f12c"
}

.ion-connection-bars:before {
    content: "\\f274"
}

.ion-contrast:before {
    content: "\\f275"
}

.ion-crop:before {
    content: "\\f3c1"
}

.ion-cube:before {
    content: "\\f318"
}

.ion-disc:before {
    content: "\\f12d"
}

.ion-document:before {
    content: "\\f12f"
}

.ion-document-text:before {
    content: "\\f12e"
}

.ion-drag:before {
    content: "\\f130"
}

.ion-earth:before {
    content: "\\f276"
}

.ion-easel:before {
    content: "\\f3c2"
}

.ion-edit:before {
    content: "\\f2bf"
}

.ion-egg:before {
    content: "\\f277"
}

.ion-eject:before {
    content: "\\f131"
}

.ion-email:before {
    content: "\\f132"
}

.ion-email-unread:before {
    content: "\\f3c3"
}

.ion-erlenmeyer-flask:before {
    content: "\\f3c5"
}

.ion-erlenmeyer-flask-bubbles:before {
    content: "\\f3c4"
}

.ion-eye:before {
    content: "\\f133"
}

.ion-eye-disabled:before {
    content: "\\f306"
}

.ion-female:before {
    content: "\\f278"
}

.ion-filing:before {
    content: "\\f134"
}

.ion-film-marker:before {
    content: "\\f135"
}

.ion-fireball:before {
    content: "\\f319"
}

.ion-flag:before {
    content: "\\f279"
}

.ion-flame:before {
    content: "\\f31a"
}

.ion-flash:before {
    content: "\\f137"
}

.ion-flash-off:before {
    content: "\\f136"
}

.ion-folder:before {
    content: "\\f139"
}

.ion-fork:before {
    content: "\\f27a"
}

.ion-fork-repo:before {
    content: "\\f2c0"
}

.ion-forward:before {
    content: "\\f13a"
}

.ion-funnel:before {
    content: "\\f31b"
}

.ion-gear-a:before {
    content: "\\f13d"
}

.ion-gear-b:before {
    content: "\\f13e"
}

.ion-grid:before {
    content: "\\f13f"
}

.ion-hammer:before {
    content: "\\f27b"
}

.ion-happy:before {
    content: "\\f31c"
}

.ion-happy-outline:before {
    content: "\\f3c6"
}

.ion-headphone:before {
    content: "\\f140"
}

.ion-heart:before {
    content: "\\f141"
}

.ion-heart-broken:before {
    content: "\\f31d"
}

.ion-help:before {
    content: "\\f143"
}

.ion-help-buoy:before {
    content: "\\f27c"
}

.ion-help-circled:before {
    content: "\\f142"
}

.ion-home:before {
    content: "\\f144"
}

.ion-icecream:before {
    content: "\\f27d"
}

.ion-image:before {
    content: "\\f147"
}

.ion-images:before {
    content: "\\f148"
}

.ion-information:before {
    content: "\\f14a"
}

.ion-information-circled:before {
    content: "\\f149"
}

.ion-ionic:before {
    content: "\\f14b"
}

.ion-ios-alarm:before {
    content: "\\f3c8"
}

.ion-ios-alarm-outline:before {
    content: "\\f3c7"
}

.ion-ios-albums:before {
    content: "\\f3ca"
}

.ion-ios-albums-outline:before {
    content: "\\f3c9"
}

.ion-ios-americanfootball:before {
    content: "\\f3cc"
}

.ion-ios-americanfootball-outline:before {
    content: "\\f3cb"
}

.ion-ios-analytics:before {
    content: "\\f3ce"
}

.ion-ios-analytics-outline:before {
    content: "\\f3cd"
}

.ion-ios-arrow-back:before {
    content: "\\f3cf"
}

.ion-ios-arrow-down:before {
    content: "\\f3d0"
}

.ion-ios-arrow-forward:before {
    content: "\\f3d1"
}

.ion-ios-arrow-left:before {
    content: "\\f3d2"
}

.ion-ios-arrow-right:before {
    content: "\\f3d3"
}

.ion-ios-arrow-thin-down:before {
    content: "\\f3d4"
}

.ion-ios-arrow-thin-left:before {
    content: "\\f3d5"
}

.ion-ios-arrow-thin-right:before {
    content: "\\f3d6"
}

.ion-ios-arrow-thin-up:before {
    content: "\\f3d7"
}

.ion-ios-arrow-up:before {
    content: "\\f3d8"
}

.ion-ios-at:before {
    content: "\\f3da"
}

.ion-ios-at-outline:before {
    content: "\\f3d9"
}

.ion-ios-barcode:before {
    content: "\\f3dc"
}

.ion-ios-barcode-outline:before {
    content: "\\f3db"
}

.ion-ios-baseball:before {
    content: "\\f3de"
}

.ion-ios-baseball-outline:before {
    content: "\\f3dd"
}

.ion-ios-basketball:before {
    content: "\\f3e0"
}

.ion-ios-basketball-outline:before {
    content: "\\f3df"
}

.ion-ios-bell:before {
    content: "\\f3e2"
}

.ion-ios-bell-outline:before {
    content: "\\f3e1"
}

.ion-ios-body:before {
    content: "\\f3e4"
}

.ion-ios-body-outline:before {
    content: "\\f3e3"
}

.ion-ios-bolt:before {
    content: "\\f3e6"
}

.ion-ios-bolt-outline:before {
    content: "\\f3e5"
}

.ion-ios-book:before {
    content: "\\f3e8"
}

.ion-ios-book-outline:before {
    content: "\\f3e7"
}

.ion-ios-bookmarks:before {
    content: "\\f3ea"
}

.ion-ios-bookmarks-outline:before {
    content: "\\f3e9"
}

.ion-ios-box:before {
    content: "\\f3ec"
}

.ion-ios-box-outline:before {
    content: "\\f3eb"
}

.ion-ios-briefcase:before {
    content: "\\f3ee"
}

.ion-ios-briefcase-outline:before {
    content: "\\f3ed"
}

.ion-ios-browsers:before {
    content: "\\f3f0"
}

.ion-ios-browsers-outline:before {
    content: "\\f3ef"
}

.ion-ios-calculator:before {
    content: "\\f3f2"
}

.ion-ios-calculator-outline:before {
    content: "\\f3f1"
}

.ion-ios-calendar:before {
    content: "\\f3f4"
}

.ion-ios-calendar-outline:before {
    content: "\\f3f3"
}

.ion-ios-camera:before {
    content: "\\f3f6"
}

.ion-ios-camera-outline:before {
    content: "\\f3f5"
}

.ion-ios-cart:before {
    content: "\\f3f8"
}

.ion-ios-cart-outline:before {
    content: "\\f3f7"
}

.ion-ios-chatboxes:before {
    content: "\\f3fa"
}

.ion-ios-chatboxes-outline:before {
    content: "\\f3f9"
}

.ion-ios-chatbubble:before {
    content: "\\f3fc"
}

.ion-ios-chatbubble-outline:before {
    content: "\\f3fb"
}

.ion-ios-checkmark:before {
    content: "\\f3ff"
}

.ion-ios-checkmark-empty:before {
    content: "\\f3fd"
}

.ion-ios-checkmark-outline:before {
    content: "\\f3fe"
}

.ion-ios-circle-filled:before {
    content: "\\f400"
}

.ion-ios-circle-outline:before {
    content: "\\f401"
}

.ion-ios-clock:before {
    content: "\\f403"
}

.ion-ios-clock-outline:before {
    content: "\\f402"
}

.ion-ios-close:before {
    content: "\\f406"
}

.ion-ios-close-empty:before {
    content: "\\f404"
}

.ion-ios-close-outline:before {
    content: "\\f405"
}

.ion-ios-cloud:before {
    content: "\\f40c"
}

.ion-ios-cloud-download:before {
    content: "\\f408"
}

.ion-ios-cloud-download-outline:before {
    content: "\\f407"
}

.ion-ios-cloud-outline:before {
    content: "\\f409"
}

.ion-ios-cloud-upload:before {
    content: "\\f40b"
}

.ion-ios-cloud-upload-outline:before {
    content: "\\f40a"
}

.ion-ios-cloudy:before {
    content: "\\f410"
}

.ion-ios-cloudy-night:before {
    content: "\\f40e"
}

.ion-ios-cloudy-night-outline:before {
    content: "\\f40d"
}

.ion-ios-cloudy-outline:before {
    content: "\\f40f"
}

.ion-ios-cog:before {
    content: "\\f412"
}

.ion-ios-cog-outline:before {
    content: "\\f411"
}

.ion-ios-color-filter:before {
    content: "\\f414"
}

.ion-ios-color-filter-outline:before {
    content: "\\f413"
}

.ion-ios-color-wand:before {
    content: "\\f416"
}

.ion-ios-color-wand-outline:before {
    content: "\\f415"
}

.ion-ios-compose:before {
    content: "\\f418"
}

.ion-ios-compose-outline:before {
    content: "\\f417"
}

.ion-ios-contact:before {
    content: "\\f41a"
}

.ion-ios-contact-outline:before {
    content: "\\f419"
}

.ion-ios-copy:before {
    content: "\\f41c"
}

.ion-ios-copy-outline:before {
    content: "\\f41b"
}

.ion-ios-crop:before {
    content: "\\f41e"
}

.ion-ios-crop-strong:before {
    content: "\\f41d"
}

.ion-ios-download:before {
    content: "\\f420"
}

.ion-ios-download-outline:before {
    content: "\\f41f"
}

.ion-ios-drag:before {
    content: "\\f421"
}

.ion-ios-email:before {
    content: "\\f423"
}

.ion-ios-email-outline:before {
    content: "\\f422"
}

.ion-ios-eye:before {
    content: "\\f425"
}

.ion-ios-eye-outline:before {
    content: "\\f424"
}

.ion-ios-fastforward:before {
    content: "\\f427"
}

.ion-ios-fastforward-outline:before {
    content: "\\f426"
}

.ion-ios-filing:before {
    content: "\\f429"
}

.ion-ios-filing-outline:before {
    content: "\\f428"
}

.ion-ios-film:before {
    content: "\\f42b"
}

.ion-ios-film-outline:before {
    content: "\\f42a"
}

.ion-ios-flag:before {
    content: "\\f42d"
}

.ion-ios-flag-outline:before {
    content: "\\f42c"
}

.ion-ios-flame:before {
    content: "\\f42f"
}

.ion-ios-flame-outline:before {
    content: "\\f42e"
}

.ion-ios-flask:before {
    content: "\\f431"
}

.ion-ios-flask-outline:before {
    content: "\\f430"
}

.ion-ios-flower:before {
    content: "\\f433"
}

.ion-ios-flower-outline:before {
    content: "\\f432"
}

.ion-ios-folder:before {
    content: "\\f435"
}

.ion-ios-folder-outline:before {
    content: "\\f434"
}

.ion-ios-football:before {
    content: "\\f437"
}

.ion-ios-football-outline:before {
    content: "\\f436"
}

.ion-ios-game-controller-a:before {
    content: "\\f439"
}

.ion-ios-game-controller-a-outline:before {
    content: "\\f438"
}

.ion-ios-game-controller-b:before {
    content: "\\f43b"
}

.ion-ios-game-controller-b-outline:before {
    content: "\\f43a"
}

.ion-ios-gear:before {
    content: "\\f43d"
}

.ion-ios-gear-outline:before {
    content: "\\f43c"
}

.ion-ios-glasses:before {
    content: "\\f43f"
}

.ion-ios-glasses-outline:before {
    content: "\\f43e"
}

.ion-ios-grid-view:before {
    content: "\\f441"
}

.ion-ios-grid-view-outline:before {
    content: "\\f440"
}

.ion-ios-heart:before {
    content: "\\f443"
}

.ion-ios-heart-outline:before {
    content: "\\f442"
}

.ion-ios-help:before {
    content: "\\f446"
}

.ion-ios-help-empty:before {
    content: "\\f444"
}

.ion-ios-help-outline:before {
    content: "\\f445"
}

.ion-ios-home:before {
    content: "\\f448"
}

.ion-ios-home-outline:before {
    content: "\\f447"
}

.ion-ios-infinite:before {
    content: "\\f44a"
}

.ion-ios-infinite-outline:before {
    content: "\\f449"
}

.ion-ios-information:before {
    content: "\\f44d"
}

.ion-ios-information-empty:before {
    content: "\\f44b"
}

.ion-ios-information-outline:before {
    content: "\\f44c"
}

.ion-ios-ionic-outline:before {
    content: "\\f44e"
}

.ion-ios-keypad:before {
    content: "\\f450"
}

.ion-ios-keypad-outline:before {
    content: "\\f44f"
}

.ion-ios-lightbulb:before {
    content: "\\f452"
}

.ion-ios-lightbulb-outline:before {
    content: "\\f451"
}

.ion-ios-list:before {
    content: "\\f454"
}

.ion-ios-list-outline:before {
    content: "\\f453"
}

.ion-ios-location:before {
    content: "\\f456"
}

.ion-ios-location-outline:before {
    content: "\\f455"
}

.ion-ios-locked:before {
    content: "\\f458"
}

.ion-ios-locked-outline:before {
    content: "\\f457"
}

.ion-ios-loop:before {
    content: "\\f45a"
}

.ion-ios-loop-strong:before {
    content: "\\f459"
}

.ion-ios-medical:before {
    content: "\\f45c"
}

.ion-ios-medical-outline:before {
    content: "\\f45b"
}

.ion-ios-medkit:before {
    content: "\\f45e"
}

.ion-ios-medkit-outline:before {
    content: "\\f45d"
}

.ion-ios-mic:before {
    content: "\\f461"
}

.ion-ios-mic-off:before {
    content: "\\f45f"
}

.ion-ios-mic-outline:before {
    content: "\\f460"
}

.ion-ios-minus:before {
    content: "\\f464"
}

.ion-ios-minus-empty:before {
    content: "\\f462"
}

.ion-ios-minus-outline:before {
    content: "\\f463"
}

.ion-ios-monitor:before {
    content: "\\f466"
}

.ion-ios-monitor-outline:before {
    content: "\\f465"
}

.ion-ios-moon:before {
    content: "\\f468"
}

.ion-ios-moon-outline:before {
    content: "\\f467"
}

.ion-ios-more:before {
    content: "\\f46a"
}

.ion-ios-more-outline:before {
    content: "\\f469"
}

.ion-ios-musical-note:before {
    content: "\\f46b"
}

.ion-ios-musical-notes:before {
    content: "\\f46c"
}

.ion-ios-navigate:before {
    content: "\\f46e"
}

.ion-ios-navigate-outline:before {
    content: "\\f46d"
}

.ion-ios-nutrition:before {
    content: "\\f470"
}

.ion-ios-nutrition-outline:before {
    content: "\\f46f"
}

.ion-ios-paper:before {
    content: "\\f472"
}

.ion-ios-paper-outline:before {
    content: "\\f471"
}

.ion-ios-paperplane:before {
    content: "\\f474"
}

.ion-ios-paperplane-outline:before {
    content: "\\f473"
}

.ion-ios-partlysunny:before {
    content: "\\f476"
}

.ion-ios-partlysunny-outline:before {
    content: "\\f475"
}

.ion-ios-pause:before {
    content: "\\f478"
}

.ion-ios-pause-outline:before {
    content: "\\f477"
}

.ion-ios-paw:before {
    content: "\\f47a"
}

.ion-ios-paw-outline:before {
    content: "\\f479"
}

.ion-ios-people:before {
    content: "\\f47c"
}

.ion-ios-people-outline:before {
    content: "\\f47b"
}

.ion-ios-person:before {
    content: "\\f47e"
}

.ion-ios-person-outline:before {
    content: "\\f47d"
}

.ion-ios-personadd:before {
    content: "\\f480"
}

.ion-ios-personadd-outline:before {
    content: "\\f47f"
}

.ion-ios-photos:before {
    content: "\\f482"
}

.ion-ios-photos-outline:before {
    content: "\\f481"
}

.ion-ios-pie:before {
    content: "\\f484"
}

.ion-ios-pie-outline:before {
    content: "\\f483"
}

.ion-ios-pint:before {
    content: "\\f486"
}

.ion-ios-pint-outline:before {
    content: "\\f485"
}

.ion-ios-play:before {
    content: "\\f488"
}

.ion-ios-play-outline:before {
    content: "\\f487"
}

.ion-ios-plus:before {
    content: "\\f48b"
}

.ion-ios-plus-empty:before {
    content: "\\f489"
}

.ion-ios-plus-outline:before {
    content: "\\f48a"
}

.ion-ios-pricetag:before {
    content: "\\f48d"
}

.ion-ios-pricetag-outline:before {
    content: "\\f48c"
}

.ion-ios-pricetags:before {
    content: "\\f48f"
}

.ion-ios-pricetags-outline:before {
    content: "\\f48e"
}

.ion-ios-printer:before {
    content: "\\f491"
}

.ion-ios-printer-outline:before {
    content: "\\f490"
}

.ion-ios-pulse:before {
    content: "\\f493"
}

.ion-ios-pulse-strong:before {
    content: "\\f492"
}

.ion-ios-rainy:before {
    content: "\\f495"
}

.ion-ios-rainy-outline:before {
    content: "\\f494"
}

.ion-ios-recording:before {
    content: "\\f497"
}

.ion-ios-recording-outline:before {
    content: "\\f496"
}

.ion-ios-redo:before {
    content: "\\f499"
}

.ion-ios-redo-outline:before {
    content: "\\f498"
}

.ion-ios-refresh:before {
    content: "\\f49c"
}

.ion-ios-refresh-empty:before {
    content: "\\f49a"
}

.ion-ios-refresh-outline:before {
    content: "\\f49b"
}

.ion-ios-reload:before {
    content: "\\f49d"
}

.ion-ios-reverse-camera:before {
    content: "\\f49f"
}

.ion-ios-reverse-camera-outline:before {
    content: "\\f49e"
}

.ion-ios-rewind:before {
    content: "\\f4a1"
}

.ion-ios-rewind-outline:before {
    content: "\\f4a0"
}

.ion-ios-rose:before {
    content: "\\f4a3"
}

.ion-ios-rose-outline:before {
    content: "\\f4a2"
}

.ion-ios-search:before {
    content: "\\f4a5"
}

.ion-ios-search-strong:before {
    content: "\\f4a4"
}

.ion-ios-settings:before {
    content: "\\f4a7"
}

.ion-ios-settings-strong:before {
    content: "\\f4a6"
}

.ion-ios-shuffle:before {
    content: "\\f4a9"
}

.ion-ios-shuffle-strong:before {
    content: "\\f4a8"
}

.ion-ios-skipbackward:before {
    content: "\\f4ab"
}

.ion-ios-skipbackward-outline:before {
    content: "\\f4aa"
}

.ion-ios-skipforward:before {
    content: "\\f4ad"
}

.ion-ios-skipforward-outline:before {
    content: "\\f4ac"
}

.ion-ios-snowy:before {
    content: "\\f4ae"
}

.ion-ios-speedometer:before {
    content: "\\f4b0"
}

.ion-ios-speedometer-outline:before {
    content: "\\f4af"
}

.ion-ios-star:before {
    content: "\\f4b3"
}

.ion-ios-star-half:before {
    content: "\\f4b1"
}

.ion-ios-star-outline:before {
    content: "\\f4b2"
}

.ion-ios-stopwatch:before {
    content: "\\f4b5"
}

.ion-ios-stopwatch-outline:before {
    content: "\\f4b4"
}

.ion-ios-sunny:before {
    content: "\\f4b7"
}

.ion-ios-sunny-outline:before {
    content: "\\f4b6"
}

.ion-ios-telephone:before {
    content: "\\f4b9"
}

.ion-ios-telephone-outline:before {
    content: "\\f4b8"
}

.ion-ios-tennisball:before {
    content: "\\f4bb"
}

.ion-ios-tennisball-outline:before {
    content: "\\f4ba"
}

.ion-ios-thunderstorm:before {
    content: "\\f4bd"
}

.ion-ios-thunderstorm-outline:before {
    content: "\\f4bc"
}

.ion-ios-time:before {
    content: "\\f4bf"
}

.ion-ios-time-outline:before {
    content: "\\f4be"
}

.ion-ios-timer:before {
    content: "\\f4c1"
}

.ion-ios-timer-outline:before {
    content: "\\f4c0"
}

.ion-ios-toggle:before {
    content: "\\f4c3"
}

.ion-ios-toggle-outline:before {
    content: "\\f4c2"
}

.ion-ios-trash:before {
    content: "\\f4c5"
}

.ion-ios-trash-outline:before {
    content: "\\f4c4"
}

.ion-ios-undo:before {
    content: "\\f4c7"
}

.ion-ios-undo-outline:before {
    content: "\\f4c6"
}

.ion-ios-unlocked:before {
    content: "\\f4c9"
}

.ion-ios-unlocked-outline:before {
    content: "\\f4c8"
}

.ion-ios-upload:before {
    content: "\\f4cb"
}

.ion-ios-upload-outline:before {
    content: "\\f4ca"
}

.ion-ios-videocam:before {
    content: "\\f4cd"
}

.ion-ios-videocam-outline:before {
    content: "\\f4cc"
}

.ion-ios-volume-high:before {
    content: "\\f4ce"
}

.ion-ios-volume-low:before {
    content: "\\f4cf"
}

.ion-ios-wineglass:before {
    content: "\\f4d1"
}

.ion-ios-wineglass-outline:before {
    content: "\\f4d0"
}

.ion-ios-world:before {
    content: "\\f4d3"
}

.ion-ios-world-outline:before {
    content: "\\f4d2"
}

.ion-ipad:before {
    content: "\\f1f9"
}

.ion-iphone:before {
    content: "\\f1fa"
}

.ion-ipod:before {
    content: "\\f1fb"
}

.ion-jet:before {
    content: "\\f295"
}

.ion-key:before {
    content: "\\f296"
}

.ion-knife:before {
    content: "\\f297"
}

.ion-laptop:before {
    content: "\\f1fc"
}

.ion-leaf:before {
    content: "\\f1fd"
}

.ion-levels:before {
    content: "\\f298"
}

.ion-lightbulb:before {
    content: "\\f299"
}

.ion-link:before {
    content: "\\f1fe"
}

.ion-load-a:before {
    content: "\\f29a"
}

.ion-load-b:before {
    content: "\\f29b"
}

.ion-load-c:before {
    content: "\\f29c"
}

.ion-load-d:before {
    content: "\\f29d"
}

.ion-location:before {
    content: "\\f1ff"
}

.ion-lock-combination:before {
    content: "\\f4d4"
}

.ion-locked:before {
    content: "\\f200"
}

.ion-log-in:before {
    content: "\\f29e"
}

.ion-log-out:before {
    content: "\\f29f"
}

.ion-loop:before {
    content: "\\f201"
}

.ion-magnet:before {
    content: "\\f2a0"
}

.ion-male:before {
    content: "\\f2a1"
}

.ion-man:before {
    content: "\\f202"
}

.ion-map:before {
    content: "\\f203"
}

.ion-medkit:before {
    content: "\\f2a2"
}

.ion-merge:before {
    content: "\\f33f"
}

.ion-mic-a:before {
    content: "\\f204"
}

.ion-mic-b:before {
    content: "\\f205"
}

.ion-mic-c:before {
    content: "\\f206"
}

.ion-minus:before {
    content: "\\f209"
}

.ion-minus-circled:before {
    content: "\\f207"
}

.ion-minus-round:before {
    content: "\\f208"
}

.ion-model-s:before {
    content: "\\f2c1"
}

.ion-monitor:before {
    content: "\\f20a"
}

.ion-more:before {
    content: "\\f20b"
}

.ion-mouse:before {
    content: "\\f340"
}

.ion-music-note:before {
    content: "\\f20c"
}

.ion-navicon:before {
    content: "\\f20e"
}

.ion-navicon-round:before {
    content: "\\f20d"
}

.ion-navigate:before {
    content: "\\f2a3"
}

.ion-network:before {
    content: "\\f341"
}

.ion-no-smoking:before {
    content: "\\f2c2"
}

.ion-nuclear:before {
    content: "\\f2a4"
}

.ion-outlet:before {
    content: "\\f342"
}

.ion-paintbrush:before {
    content: "\\f4d5"
}

.ion-paintbucket:before {
    content: "\\f4d6"
}

.ion-paper-airplane:before {
    content: "\\f2c3"
}

.ion-paperclip:before {
    content: "\\f20f"
}

.ion-pause:before {
    content: "\\f210"
}

.ion-person:before {
    content: "\\f213"
}

.ion-person-add:before {
    content: "\\f211"
}

.ion-person-stalker:before {
    content: "\\f212"
}

.ion-pie-graph:before {
    content: "\\f2a5"
}

.ion-pin:before {
    content: "\\f2a6"
}

.ion-pinpoint:before {
    content: "\\f2a7"
}

.ion-pizza:before {
    content: "\\f2a8"
}

.ion-plane:before {
    content: "\\f214"
}

.ion-planet:before {
    content: "\\f343"
}

.ion-play:before {
    content: "\\f215"
}

.ion-playstation:before {
    content: "\\f30a"
}

.ion-plus:before {
    content: "\\f218"
}

.ion-plus-circled:before {
    content: "\\f216"
}

.ion-plus-round:before {
    content: "\\f217"
}

.ion-podium:before {
    content: "\\f344"
}

.ion-pound:before {
    content: "\\f219"
}

.ion-power:before {
    content: "\\f2a9"
}

.ion-pricetag:before {
    content: "\\f2aa"
}

.ion-pricetags:before {
    content: "\\f2ab"
}

.ion-printer:before {
    content: "\\f21a"
}

.ion-pull-request:before {
    content: "\\f345"
}

.ion-qr-scanner:before {
    content: "\\f346"
}

.ion-quote:before {
    content: "\\f347"
}

.ion-radio-waves:before {
    content: "\\f2ac"
}

.ion-record:before {
    content: "\\f21b"
}

.ion-refresh:before {
    content: "\\f21c"
}

.ion-reply:before {
    content: "\\f21e"
}

.ion-reply-all:before {
    content: "\\f21d"
}

.ion-ribbon-a:before {
    content: "\\f348"
}

.ion-ribbon-b:before {
    content: "\\f349"
}

.ion-sad:before {
    content: "\\f34a"
}

.ion-sad-outline:before {
    content: "\\f4d7"
}

.ion-scissors:before {
    content: "\\f34b"
}

.ion-search:before {
    content: "\\f21f"
}

.ion-settings:before {
    content: "\\f2ad"
}

.ion-share:before {
    content: "\\f220"
}

.ion-shuffle:before {
    content: "\\f221"
}

.ion-skip-backward:before {
    content: "\\f222"
}

.ion-skip-forward:before {
    content: "\\f223"
}

.ion-social-android:before {
    content: "\\f225"
}

.ion-social-android-outline:before {
    content: "\\f224"
}

.ion-social-angular:before {
    content: "\\f4d9"
}

.ion-social-angular-outline:before {
    content: "\\f4d8"
}

.ion-social-apple:before {
    content: "\\f227"
}

.ion-social-apple-outline:before {
    content: "\\f226"
}

.ion-social-bitcoin:before {
    content: "\\f2af"
}

.ion-social-bitcoin-outline:before {
    content: "\\f2ae"
}

.ion-social-buffer:before {
    content: "\\f229"
}

.ion-social-buffer-outline:before {
    content: "\\f228"
}

.ion-social-chrome:before {
    content: "\\f4db"
}

.ion-social-chrome-outline:before {
    content: "\\f4da"
}

.ion-social-codepen:before {
    content: "\\f4dd"
}

.ion-social-codepen-outline:before {
    content: "\\f4dc"
}

.ion-social-css3:before {
    content: "\\f4df"
}

.ion-social-css3-outline:before {
    content: "\\f4de"
}

.ion-social-designernews:before {
    content: "\\f22b"
}

.ion-social-designernews-outline:before {
    content: "\\f22a"
}

.ion-social-dribbble:before {
    content: "\\f22d"
}

.ion-social-dribbble-outline:before {
    content: "\\f22c"
}

.ion-social-dropbox:before {
    content: "\\f22f"
}

.ion-social-dropbox-outline:before {
    content: "\\f22e"
}

.ion-social-euro:before {
    content: "\\f4e1"
}

.ion-social-euro-outline:before {
    content: "\\f4e0"
}

.ion-social-facebook:before {
    content: "\\f231"
}

.ion-social-facebook-outline:before {
    content: "\\f230"
}

.ion-social-foursquare:before {
    content: "\\f34d"
}

.ion-social-foursquare-outline:before {
    content: "\\f34c"
}

.ion-social-freebsd-devil:before {
    content: "\\f2c4"
}

.ion-social-github:before {
    content: "\\f233"
}

.ion-social-github-outline:before {
    content: "\\f232"
}

.ion-social-google:before {
    content: "\\f34f"
}

.ion-social-google-outline:before {
    content: "\\f34e"
}

.ion-social-googleplus:before {
    content: "\\f235"
}

.ion-social-googleplus-outline:before {
    content: "\\f234"
}

.ion-social-hackernews:before {
    content: "\\f237"
}

.ion-social-hackernews-outline:before {
    content: "\\f236"
}

.ion-social-html5:before {
    content: "\\f4e3"
}

.ion-social-html5-outline:before {
    content: "\\f4e2"
}

.ion-social-instagram:before {
    content: "\\f351"
}

.ion-social-instagram-outline:before {
    content: "\\f350"
}

.ion-social-javascript:before {
    content: "\\f4e5"
}

.ion-social-javascript-outline:before {
    content: "\\f4e4"
}

.ion-social-linkedin:before {
    content: "\\f239"
}

.ion-social-linkedin-outline:before {
    content: "\\f238"
}

.ion-social-markdown:before {
    content: "\\f4e6"
}

.ion-social-nodejs:before {
    content: "\\f4e7"
}

.ion-social-octocat:before {
    content: "\\f4e8"
}

.ion-social-pinterest:before {
    content: "\\f2b1"
}

.ion-social-pinterest-outline:before {
    content: "\\f2b0"
}

.ion-social-python:before {
    content: "\\f4e9"
}

.ion-social-reddit:before {
    content: "\\f23b"
}

.ion-social-reddit-outline:before {
    content: "\\f23a"
}

.ion-social-rss:before {
    content: "\\f23d"
}

.ion-social-rss-outline:before {
    content: "\\f23c"
}

.ion-social-sass:before {
    content: "\\f4ea"
}

.ion-social-skype:before {
    content: "\\f23f"
}

.ion-social-skype-outline:before {
    content: "\\f23e"
}

.ion-social-snapchat:before {
    content: "\\f4ec"
}

.ion-social-snapchat-outline:before {
    content: "\\f4eb"
}

.ion-social-tumblr:before {
    content: "\\f241"
}

.ion-social-tumblr-outline:before {
    content: "\\f240"
}

.ion-social-tux:before {
    content: "\\f2c5"
}

.ion-social-twitch:before {
    content: "\\f4ee"
}

.ion-social-twitch-outline:before {
    content: "\\f4ed"
}

.ion-social-twitter:before {
    content: "\\f243"
}

.ion-social-twitter-outline:before {
    content: "\\f242"
}

.ion-social-usd:before {
    content: "\\f353"
}

.ion-social-usd-outline:before {
    content: "\\f352"
}

.ion-social-vimeo:before {
    content: "\\f245"
}

.ion-social-vimeo-outline:before {
    content: "\\f244"
}

.ion-social-whatsapp:before {
    content: "\\f4f0"
}

.ion-social-whatsapp-outline:before {
    content: "\\f4ef"
}

.ion-social-windows:before {
    content: "\\f247"
}

.ion-social-windows-outline:before {
    content: "\\f246"
}

.ion-social-wordpress:before {
    content: "\\f249"
}

.ion-social-wordpress-outline:before {
    content: "\\f248"
}

.ion-social-yahoo:before {
    content: "\\f24b"
}

.ion-social-yahoo-outline:before {
    content: "\\f24a"
}

.ion-social-yen:before {
    content: "\\f4f2"
}

.ion-social-yen-outline:before {
    content: "\\f4f1"
}

.ion-social-youtube:before {
    content: "\\f24d"
}

.ion-social-youtube-outline:before {
    content: "\\f24c"
}

.ion-soup-can:before {
    content: "\\f4f4"
}

.ion-soup-can-outline:before {
    content: "\\f4f3"
}

.ion-speakerphone:before {
    content: "\\f2b2"
}

.ion-speedometer:before {
    content: "\\f2b3"
}

.ion-spoon:before {
    content: "\\f2b4"
}

.ion-star:before {
    content: "\\f24e"
}

.ion-stats-bars:before {
    content: "\\f2b5"
}

.ion-steam:before {
    content: "\\f30b"
}

.ion-stop:before {
    content: "\\f24f"
}

.ion-thermometer:before {
    content: "\\f2b6"
}

.ion-thumbsdown:before {
    content: "\\f250"
}

.ion-thumbsup:before {
    content: "\\f251"
}

.ion-toggle:before {
    content: "\\f355"
}

.ion-toggle-filled:before {
    content: "\\f354"
}

.ion-transgender:before {
    content: "\\f4f5"
}

.ion-trash-a:before {
    content: "\\f252"
}

.ion-trash-b:before {
    content: "\\f253"
}

.ion-trophy:before {
    content: "\\f356"
}

.ion-tshirt:before {
    content: "\\f4f7"
}

.ion-tshirt-outline:before {
    content: "\\f4f6"
}

.ion-umbrella:before {
    content: "\\f2b7"
}

.ion-university:before {
    content: "\\f357"
}

.ion-unlocked:before {
    content: "\\f254"
}

.ion-upload:before {
    content: "\\f255"
}

.ion-usb:before {
    content: "\\f2b8"
}

.ion-videocamera:before {
    content: "\\f256"
}

.ion-volume-high:before {
    content: "\\f257"
}

.ion-volume-low:before {
    content: "\\f258"
}

.ion-volume-medium:before {
    content: "\\f259"
}

.ion-volume-mute:before {
    content: "\\f25a"
}

.ion-wand:before {
    content: "\\f358"
}

.ion-waterdrop:before {
    content: "\\f25b"
}

.ion-wifi:before {
    content: "\\f25c"
}

.ion-wineglass:before {
    content: "\\f2b9"
}

.ion-woman:before {
    content: "\\f25d"
}

.ion-wrench:before {
    content: "\\f2ba"
}

.ion-xbox:before {
    content: "\\f30c"
}

.icon-align-center:before {
    content: "\\e900";
}

.icon-align-justify:before {
    content: "\\e901";
}

.icon-align-left:before {
    content: "\\e902";
}

.icon-align-right:before {
    content: "\\e903";
}

.icon-alt:before {
    content: "\\e904";
}

.icon-arrow-right:before {
    content: "\\e905";
}

.icon-arrow-up:before {
    content: "\\e906";
}

.icon-artboard:before {
    content: "\\e907";
}

.icon-at:before {
    content: "\\e908";
}

.icon-attachment:before {
    content: "\\e909";
}

.icon-backward:before {
    content: "\\e90a";
}

.icon-badge:before {
    content: "\\e90b";
}

.icon-bank-note:before {
    content: "\\e90c";
}

.icon-bar-chart:before {
    content: "\\e90d";
}

.icon-basket-ball:before {
    content: "\\e90e";
}

.icon-battery-high:before {
    content: "\\e90f";
}

.icon-battery-low:before {
    content: "\\e910";
}

.icon-bed:before {
    content: "\\e911";
}

.icon-bell:before {
    content: "\\e912";
}

.icon-bin:before {
    content: "\\e913";
}

.icon-block:before {
    content: "\\e914";
}

.icon-bluetooth:before {
    content: "\\e915";
}

.icon-book:before {
    content: "\\e916";
}

.icon-box:before {
    content: "\\e917";
}

.icon-brightness:before {
    content: "\\e918";
}

.icon-brush:before {
    content: "\\e919";
}

.icon-bucket:before {
    content: "\\e91a";
}

.icon-building:before {
    content: "\\e91b";
}

.icon-calendar:before {
    content: "\\e91c";
}

.icon-camera:before {
    content: "\\e91d";
}

.icon-car:before {
    content: "\\e91e";
}

.icon-card:before {
    content: "\\e91f";
}

.icon-chat:before {
    content: "\\e920";
}

.icon-circle-bottom-left:before {
    content: "\\e921";
}

.icon-circle-bottom-right:before {
    content: "\\e922";
}

.icon-circle-down:before {
    content: "\\e923";
}

.icon-circle-left:before {
    content: "\\e924";
}

.icon-circle-right:before {
    content: "\\e925";
}

.icon-circle-top-left:before {
    content: "\\e926";
}

.icon-circle-top-right:before {
    content: "\\e927";
}

.icon-circle-up:before {
    content: "\\e928";
}

.icon-clock:before {
    content: "\\e929";
}

.icon-cloud:before {
    content: "\\e92a";
}

.icon-cmd:before {
    content: "\\e92b";
}

.icon-collapse:before {
    content: "\\e92c";
}

.icon-comment:before {
    content: "\\e92d";
}

.icon-contrast:before {
    content: "\\e92e";
}

.icon-corner-arrow:before {
    content: "\\e92f";
}

.icon-cube:before {
    content: "\\e930";
}

.icon-cup:before {
    content: "\\e931";
}

.icon-cursor:before {
    content: "\\e932";
}

.icon-desktop:before {
    content: "\\e933";
}

.icon-disk:before {
    content: "\\e934";
}

.icon-dollar:before {
    content: "\\e935";
}

.icon-download:before {
    content: "\\e936";
}

.icon-drawer:before {
    content: "\\e937";
}

.icon-drop:before {
    content: "\\e938";
}

.icon-earth:before {
    content: "\\e939";
}

.icon-edit:before {
    content: "\\e93a";
}

.icon-education:before {
    content: "\\e93b";
}

.icon-eject:before {
    content: "\\e93c";
}

.icon-euro:before {
    content: "\\e93d";
}

.icon-expand:before {
    content: "\\e93e";
}

.icon-external:before {
    content: "\\e93f";
}

.icon-eye:before {
    content: "\\e940";
}

.icon-factory:before {
    content: "\\e941";
}

.icon-fast-forward:before {
    content: "\\e942";
}

.icon-file:before {
    content: "\\e943";
}

.icon-file-add:before {
    content: "\\e944";
}

.icon-file-remove:before {
    content: "\\e945";
}

.icon-files:before {
    content: "\\e946";
}

.icon-filter:before {
    content: "\\e947";
}

.icon-fire:before {
    content: "\\e948";
}

.icon-first-aid:before {
    content: "\\e949";
}

.icon-flag:before {
    content: "\\e94a";
}

.icon-floppy:before {
    content: "\\e94b";
}

.icon-folder:before {
    content: "\\e94c";
}

.icon-folder-add:before {
    content: "\\e94d";
}

.icon-folder-remove:before {
    content: "\\e94e";
}

.icon-fork-knife:before {
    content: "\\e94f";
}

.icon-form:before {
    content: "\\e950";
}

.icon-frame:before {
    content: "\\e951";
}

.icon-full-screen:before {
    content: "\\e952";
}

.icon-gift:before {
    content: "\\e953";
}

.icon-glass:before {
    content: "\\e954";
}

.icon-glasses:before {
    content: "\\e955";
}

.icon-grid:before {
    content: "\\e956";
}

.icon-group:before {
    content: "\\e957";
}

.icon-headset:before {
    content: "\\e958";
}

.icon-heart:before {
    content: "\\e959";
}

.icon-hide-sdebar-vert:before {
    content: "\\e95a";
}

.icon-hide-sidebar-horiz:before {
    content: "\\e95b";
}

.icon-home:before {
    content: "\\e95c";
}

.icon-id:before {
    content: "\\e95d";
}

.icon-image:before {
    content: "\\e95e";
}

.icon-info:before {
    content: "\\e95f";
}

.icon-invoice:before {
    content: "\\e960";
}

.icon-juice:before {
    content: "\\e961";
}

.icon-key:before {
    content: "\\e962";
}

.icon-lamp:before {
    content: "\\e963";
}

.icon-layers:before {
    content: "\\e964";
}

.icon-leaf:before {
    content: "\\e965";
}

.icon-left:before {
    content: "\\e966";
}

.icon-left-right:before {
    content: "\\e967";
}

.icon-lego-block:before {
    content: "\\e968";
}

.icon-life-buoy:before {
    content: "\\e969";
}

.icon-light-bulb:before {
    content: "\\e96a";
}

.icon-link:before {
    content: "\\e96b";
}

.icon-list:before {
    content: "\\e96c";
}

.icon-loading:before {
    content: "\\e96d";
}

.icon-logout:before {
    content: "\\e96e";
}

.icon-mail:before {
    content: "\\e96f";
}

.icon-mail-open:before {
    content: "\\e970";
}

.icon-map:before {
    content: "\\e971";
}

.icon-margin:before {
    content: "\\e972";
}

.icon-megaphone:before {
    content: "\\e973";
}

.icon-meh:before {
    content: "\\e974";
}

.icon-menu-circle:before {
    content: "\\e975";
}

.icon-menu-circle-dots:before {
    content: "\\e976";
}

.icon-menu-dots:before {
    content: "\\e977";
}

.icon-menu-lines:before {
    content: "\\e978";
}

.icon-microphone:before {
    content: "\\e979";
}

.icon-minus:before {
    content: "\\e97a";
}

.icon-mobile:before {
    content: "\\e97b";
}

.icon-mouse:before {
    content: "\\e97c";
}

.icon-move:before {
    content: "\\e97d";
}

.icon-move-diagonal:before {
    content: "\\e97e";
}

.icon-move-horizontal:before {
    content: "\\e97f";
}

.icon-move-vertical:before {
    content: "\\e980";
}

.icon-mug:before {
    content: "\\e981";
}

.icon-music:before {
    content: "\\e982";
}

.icon-network:before {
    content: "\\e983";
}

.icon-new-file:before {
    content: "\\e984";
}

.icon-newspaper:before {
    content: "\\e985";
}

.icon-next:before {
    content: "\\e986";
}

.icon-no:before {
    content: "\\e987";
}

.icon-notes:before {
    content: "\\e988";
}

.icon-objects:before {
    content: "\\e989";
}

.icon-padding:before {
    content: "\\e98a";
}

.icon-padlock:before {
    content: "\\e98b";
}

.icon-padlock-open:before {
    content: "\\e98c";
}

.icon-paint-brush:before {
    content: "\\e98d";
}

.icon-paper-plane:before {
    content: "\\e98e";
}

.icon-pause:before {
    content: "\\e98f";
}

.icon-pen:before {
    content: "\\e990";
}

.icon-pencil:before {
    content: "\\e991";
}

.icon-pencil-ruler:before {
    content: "\\e992";
}

.icon-phone:before {
    content: "\\e993";
}

.icon-pie-chart:before {
    content: "\\e994";
}

.icon-pin:before {
    content: "\\e995";
}

.icon-pin-2:before {
    content: "\\e996";
}

.icon-pin-point:before {
    content: "\\e997";
}

.icon-play:before {
    content: "\\e998";
}

.icon-plug:before {
    content: "\\e999";
}

.icon-plus:before {
    content: "\\e99a";
}

.icon-pound:before {
    content: "\\e99b";
}

.icon-power-on:before {
    content: "\\e99c";
}

.icon-previous:before {
    content: "\\e99d";
}

.icon-printer:before {
    content: "\\e99e";
}

.icon-projector:before {
    content: "\\e99f";
}

.icon-question:before {
    content: "\\e9a0";
}

.icon-quote:before {
    content: "\\e9a1";
}

.icon-record:before {
    content: "\\e9a2";
}

.icon-recycle:before {
    content: "\\e9a3";
}

.icon-redo:before {
    content: "\\e9a4";
}

.icon-refresh:before {
    content: "\\e9a5";
}

.icon-rotate-clock:before {
    content: "\\e9a6";
}

.icon-rotate-counter:before {
    content: "\\e9a7";
}

.icon-sad:before {
    content: "\\e9a8";
}

.icon-scales:before {
    content: "\\e9a9";
}

.icon-search:before {
    content: "\\e9aa";
}

.icon-selection:before {
    content: "\\e9ab";
}

.icon-settings:before {
    content: "\\e9ac";
}

.icon-shapes:before {
    content: "\\e9ad";
}

.icon-share:before {
    content: "\\e9ae";
}

.icon-shield:before {
    content: "\\e9af";
}

.icon-shopping-cart:before {
    content: "\\e9b0";
}

.icon-show-sidebar-horiz:before {
    content: "\\e9b1";
}

.icon-show-sidebar-vert:before {
    content: "\\e9b2";
}

.icon-shuffle:before {
    content: "\\e9b3";
}

.icon-sign:before {
    content: "\\e9b4";
}

.icon-signal:before {
    content: "\\e9b5";
}

.icon-skull:before {
    content: "\\e9b6";
}

.icon-sliders:before {
    content: "\\e9b7";
}

.icon-small-screen:before {
    content: "\\e9b8";
}

.icon-smile:before {
    content: "\\e9b9";
}

.icon-soap:before {
    content: "\\e9ba";
}

.icon-speed-o-meter:before {
    content: "\\e9bb";
}

.icon-star:before {
    content: "\\e9bc";
}

.icon-stop:before {
    content: "\\e9bd";
}

.icon-styling-tools:before {
    content: "\\e9be";
}

.icon-suitcase:before {
    content: "\\e9bf";
}

.icon-syringe:before {
    content: "\\e9c0";
}

.icon-table:before {
    content: "\\e9c1";
}

.icon-tag:before {
    content: "\\e9c2";
}

.icon-target:before {
    content: "\\e9c3";
}

.icon-terminal:before {
    content: "\\e9c4";
}

.icon-text:before {
    content: "\\e9c5";
}

.icon-thumbs-down:before {
    content: "\\e9c6";
}

.icon-thumbs-up:before {
    content: "\\e9c7";
}

.icon-thunderbolt:before {
    content: "\\e9c8";
}

.icon-tie:before {
    content: "\\e9c9";
}

.icon-toggles:before {
    content: "\\e9ca";
}

.icon-trophy:before {
    content: "\\e9cb";
}

.icon-truck:before {
    content: "\\e9cc";
}

.icon-tube:before {
    content: "\\e9cd";
}

.icon-tv:before {
    content: "\\e9ce";
}

.icon-umbrella:before {
    content: "\\e9cf";
}

.icon-undo:before {
    content: "\\e9d0";
}

.icon-up:before {
    content: "\\e9d1";
}

.icon-update:before {
    content: "\\e9d2";
}

.icon-up-down:before {
    content: "\\e9d3";
}

.icon-upload:before {
    content: "\\e9d4";
}

.icon-user:before {
    content: "\\e9d5";
}

.icon-user-add:before {
    content: "\\e9d6";
}

.icon-user-remove:before {
    content: "\\e9d7";
}

.icon-users:before {
    content: "\\e9d8";
}

.icon-video:before {
    content: "\\e9d9";
}

.icon-video-camera:before {
    content: "\\e9da";
}

.icon-volume-down:before {
    content: "\\e9db";
}

.icon-volume-mute:before {
    content: "\\e9dc";
}

.icon-volume-up:before {
    content: "\\e9dd";
}

.icon-wallet:before {
    content: "\\e9de";
}

.icon-wand:before {
    content: "\\e9df";
}

.icon-warning:before {
    content: "\\e9e0";
}

.icon-wi-fi:before {
    content: "\\e9e1";
}

.icon-window:before {
    content: "\\e9e2";
}

.icon-wrench:before {
    content: "\\e9e3";
}

.icon-yes:before {
    content: "\\e9e4";
}

.icon-zoom-in:before {
    content: "\\e9e5";
}

.icon-zoom-out:before {
    content: "\\e9e6";
}

/* Generated by Font Squirrel (http://www.fontsquirrel.com) */

/*
 * Montserrat
================================================================================ */

@font-face {
    font-family: 'montserrat-regular';
    src: url('./fonts/Montserrat-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'montserrat-bold';
    src: url('./fonts/Montserrat-Bold.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

/*
 * Raleway
================================================================================ */
@font-face {
    font-family: 'raleway-thin';
    src: url('./fonts/Raleway-Thin.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'raleway-extra-light';
    src: url('./fonts/Raleway-ExtraLight.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'raleway-light';
    src: url('./fonts/Raleway-Light.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'raleway-regular';
    src: url('./fonts/Raleway-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'raleway-medium';
    src: url('./fonts/Raleway-Medium.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'raleway-semibold';
    src: url('./fonts/Raleway-SemiBold.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'raleway-bold';
    src: url('./fonts/Raleway-Bold.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

/*
 * Merriweather
================================================================================ */

@font-face {
    font-family: 'merriweather-heavy';
    src: url('./fonts/Merriweather-Black.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'merriweather-bold';
    src: url('./fonts/Merriweather-Bold.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'merriweather-bold-italic';
    src: url('./fonts/Merriweather-BoldItalic.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'merriweather-italic';
    src: url('./fonts/Merriweather-Italic.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'merriweather-light';
    src: url('./fonts/Merriweather-Light.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'merriweather-light-italic';
    src: url('./fonts/Merriweather-LightItalic.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'merriweather-regular';
    src: url('./fonts/Merriweather-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

.Typewriter__wrapper::after {
    height: 24px;
    width: 13px;
    content: '';
    display: inline-block;
    margin-left: 3px;
    background-color: rgb(177, 139, 94);
    animation-name: blink;
    animation-duration: 0.5s;
    animation-iteration-count: infinite;
}

.Typewriter__cursor {
    display: none;
}

#idopontfoglalas h1 a, #idopontfoglalas h1 a:focus, #idopontfoglalas h1 a:active, #idopontfoglalas h1 a:visited {
    color: white;
}

    #idopontfoglalas h1 a:hover {
        text-decoration: underline;
    }
`;

class InfraTrainer extends React.PureComponent<InfraTrainerProps> {
  componentDidMount() {
    this.props.getInfraTrainerPage();
  }

  public render() {
    return (
      <div id="boxed-wrapper">
        <style
          type="text/css"
          dangerouslySetInnerHTML={{ __html: infratrainerCss }}
        />
        <div className="fusion-sides-frame"></div>
        <div id="wrapper" className="fusion-wrapper">
          <div id="home" style={{ position: "relative", top: "-1px" }}></div>
          <div id="sliders-container"></div>

          <NavMenu {...this.props} />

          <div
            className={`infra-main-container ${isMobileOnly ? "mobile" : ""}`}
          >
            <div>
              <div>
                {/* intro section
   ================================================== */}
                <section id="intro">
                  <div className="shadow-overlay" />
                  <div className="intro-content">
                    <div className="row">
                      <div className="col-twelve">
                        <div className="box">{/* stuff */}</div>
                      </div>
                    </div>
                  </div>
                </section>
                {/* /intro */}
                <section
                  id="infraslimx"
                  style={{
                    paddingTop: isMobileOnly ? "20px" : undefined,
                    paddingBottom: isMobileOnly ? "60px" : undefined,
                  }}
                >
                  <div className="row section-intro">
                    <div className="col-twelve with-bottom-line">
                      <h1>
                        {this.props.infraTrainerPage != null && (
                          <img
                            style={{ maxWidth: "600px" }}
                            src={`/wp-content/uploads/new/${this.props.infraTrainerPage.promoImage.name}`}
                          />
                        )}
                      </h1>
                      <p className="lead" style={{ color: "black" }}>
                        Az új wellness gép, az INFRATRAINER, egy olyan
                        fekvőkerékpár, mely PHILIPS VITAE infra vonalsugárzók és
                        egy mágnesterápiás készülék hatását egyesíti a maximális
                        hatékonyság érdekében. Edzés közben az infrasugarak
                        behatolnak a bőr alá, belülről felmelegítik, feloldják a
                        zsírszöveteket és felszabadítják a méreganyagokat.
                      </p>
                    </div>
                  </div>
                  <div className="row features-content">
                    <div
                      className="features-list block-1-3 block-s-1-2 block-tab-full group"
                      style={{ width: "100%" }}
                    >
                      <div className="bgrid feature">
                        <span className="icon">
                          <img
                            src="/wp-content/uploads/new/fogyas.png"
                            style={{ height: "55px" }}
                          />
                        </span>
                        <div className="service-content">
                          <h3 className="h05">Fogyás</h3>
                        </div>
                      </div>
                      {/* /bgrid */}
                      <div className="bgrid feature">
                        <span className="icon">
                          <img
                            src="/wp-content/uploads/new/zsiregetes.png"
                            style={{ height: "55px" }}
                          />
                        </span>
                        <div className="service-content">
                          <h3 className="h05">Zsírégetés</h3>
                        </div>
                      </div>
                      {/* /bgrid */}
                      <div className="bgrid feature">
                        <span className="icon">
                          <img
                            src="/wp-content/uploads/new/borfiatalitas.png"
                            style={{ height: "55px" }}
                          />
                        </span>
                        <div className="service-content">
                          <h3 className="h05">Bőrfiatalítás</h3>
                        </div>
                      </div>
                      {/* /bgrid */}
                      <div className="bgrid feature">
                        <span className="icon">
                          <img
                            src="/wp-content/uploads/new/vakum.png"
                            style={{ height: "55px" }}
                          />
                        </span>
                        <div className="service-content">
                          <h3 className="h05">Vákuumterápia</h3>
                        </div>
                      </div>
                      {/* /bgrid */}
                      <div className="bgrid feature">
                        <span className="icon">
                          <img
                            src="/wp-content/uploads/new/meregtelenites.png"
                            style={{ height: "55px" }}
                          />
                        </span>
                        <div className="service-content">
                          <h3 className="h05">Méregtelenítés</h3>
                        </div>
                      </div>
                      {/* /bgrid */}
                      <div className="bgrid feature">
                        <span className="icon">
                          <img
                            src="/wp-content/uploads/new/cellulit.png"
                            style={{ height: "55px" }}
                          />
                        </span>
                        <div className="service-content">
                          <h3 className="h05">Cellulit kezelés</h3>
                        </div>
                      </div>
                      {/* /bgrid */}
                      <div className="bgrid feature">
                        <span className="icon">
                          <img
                            src="/wp-content/uploads/new/anyagcsere.png"
                            style={{ height: "55px" }}
                          />
                        </span>
                        <div className="service-content">
                          <h3 className="h05">Anyagcsere fokozás</h3>
                        </div>
                      </div>
                      {/* /bgrid */}
                      <div className="bgrid feature">
                        <span className="icon">
                          <img
                            src="/wp-content/uploads/new/immun.png"
                            style={{ height: "55px" }}
                          />
                        </span>
                        <div className="service-content">
                          <h3 className="h05">Immunrendszer erősítés</h3>
                        </div>
                      </div>
                      {/* /bgrid */}
                      <div className="bgrid feature">
                        <span className="icon">
                          <img
                            src="/wp-content/uploads/new/Group-3.png"
                            style={{ height: "55px" }}
                          />
                        </span>
                        <div className="service-content">
                          <h3 className="h05">Kollagén termelés</h3>
                        </div>
                      </div>
                      {/* /bgrid */}
                      <div className="bgrid feature">
                        <span className="icon">
                          <img
                            src="/wp-content/uploads/new/Group-1.png"
                            style={{ height: "55px" }}
                          />
                        </span>
                        <div className="service-content">
                          <h3 className="h05">Sejtszintű egészség</h3>
                        </div>
                      </div>
                      {/* /bgrid */}
                    </div>
                    {/* features-list */}
                  </div>
                  {/* features-content */}
                  <div className="row section-intro">
                    <div className="col-twelve with-bottom-line">
                      <p className="lead" style={{ color: "black" }}>
                        Az InfraTrainer-ben eltöltött 30-50 perc kellemesen
                        telik, miközben szervezetünk minimum 600-800
                        kilokalóriát éget el, ami egy 13-17 km-es futótréningnek
                        felel meg.
                      </p>
                    </div>
                  </div>
                  <div
                    className="container pt-5"
                    style={{
                      height: isMobileOnly ? "10px" : "80px",
                      overflowY: "visible",
                      paddingBottom: isMobileOnly ? "110px" : "3rem",
                    }}
                  >
                    <div className="output" id="output">
                      <h1 style={{ textAlign: "center" }}>
                        <Typewriter
                          onInit={() => {}}
                          options={{
                            strings: typewriterTexts,
                            autoStart: true,
                            loop: true,
                            delay: 20,
                            deleteSpeed: 10,
                          }}
                        />
                      </h1>
                      <p />
                    </div>
                  </div>
                </section>
                {/* /features */}
                <section id="mithozz" style={{ background: "white" }}>
                  <br />
                  <br />
                  <br />
                  <div className="row section-intro">
                    <div className="col-twelve with-bottom-line">
                      <h1>Miket hozz magaddal?</h1>
                      <p className="lead">
                        Olyan edzőruhával készülj, amely neked kényelmes.
                        Alakformáló krémet és fólianadrágot mi biztosítunk
                        számodra! :)
                      </p>
                    </div>
                  </div>
                  <div className="row features-content">
                    <div
                      className="features-list block-1-3 block-s-1-2 block-tab-full group"
                      style={{ width: "100%" }}
                    >
                      <div className="bgrid feature">
                        <span className="icon">
                          <img
                            src="/wp-content/uploads/new/PinClipart.com_bikini-clipart-images_2062954.png"
                            style={{ maxWidth: "55px", maxHeight: "55px" }}
                          />
                        </span>
                        <div className="service-content">
                          <h3 className="h05">
                            sportmelltartó vagy bikini felső
                          </h3>
                        </div>
                      </div>
                      <div className="bgrid feature">
                        <span className="icon">
                          <img
                            src="/wp-content/uploads/new/PinClipart.com_swimsuit-clipart_135796.png"
                            style={{ maxWidth: "55px", maxHeight: "55px" }}
                          />
                        </span>
                        <div className="service-content">
                          <h3 className="h05">rövidnadrág vagy bikini alsó</h3>
                        </div>
                      </div>
                      <div className="bgrid feature">
                        <span className="icon">
                          <img
                            src="/wp-content/uploads/new/trail-running-shoe-2.png"
                            style={{ maxWidth: "55px", maxHeight: "55px" }}
                          />
                        </span>
                        <div className="service-content">
                          <h3 className="h05">tiszta talpú edzőcipő</h3>
                        </div>
                      </div>
                      <div className="bgrid feature">
                        <span className="icon">
                          <img
                            src="/wp-content/uploads/new/towels.png"
                            style={{ maxWidth: "55px", maxHeight: "55px" }}
                          />
                        </span>
                        <div className="service-content">
                          <h3 className="h05">Törölköző</h3>
                        </div>
                      </div>
                      <div className="bgrid feature">
                        <span className="icon">
                          <img
                            src="/wp-content/uploads/new/water-4.png"
                            style={{ maxWidth: "55px", maxHeight: "55px" }}
                          />
                        </span>
                        <div className="service-content">
                          <h3 className="h05">Víz (1,5 L)</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /bgrid */}
                  <br />
                  <br />
                  <br />
                </section>
                <section id="idopontfoglalas">
                  <div className="row cta-content">
                    <div className="col-twelve">
                      <h1 className="h01">
                        <a
                          href="https://oxy-esztetikai-studio.salonic.hu/"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#b18b5e" }}
                        >
                          <button
                            className="button round large appointment-button"
                            style={{ backgroundColor: "white" }}
                          >
                            <p
                              style={{
                                color: "#b18b5e",
                                textTransform: "uppercase",
                                fontSize: "20px",
                                margin: isMobileOnly ? "0 auto" : undefined,
                                whiteSpace: isMobileOnly ? "normal" : undefined,
                                lineHeight: isMobileOnly ? "3rem" : undefined,
                              }}
                            >
                              Online időpontfoglaláshoz kattints ide
                            </p>
                          </button>
                        </a>
                      </h1>
                      <br />
                      <p className="lead">
                        Foglalhatsz időpontot telefonon, e-mailen vagy
                        Facebook/Instagram üzenetben is!
                      </p>
                    </div>
                    <ul className="stores" style={{ width: "100%" }}>
                      <li className="app-store">
                        <a
                          href="https://www.instagram.com/oxyesztetikaistudio/"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#b18b5e" }}
                        >
                          <button className="button round large">
                            <p style={{ color: "#b18b5e" }}>
                              <img
                                src="/wp-content/uploads/new/instagram-3.png"
                                style={{
                                  display: "inline",
                                  verticalAlign: "middle",
                                  paddingBottom: "5px",
                                }}
                                width="20px"
                              />
                              &nbsp; oxydayspa.hu
                            </p>
                          </button>
                        </a>
                      </li>
                      <li className="play-store">
                        <a
                          href="https://www.facebook.com/oxyesztetika/posts/"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#b18b5e" }}
                        >
                          <button className="button round large">
                            <p style={{ color: "#b18b5e" }}>
                              <img
                                src="/wp-content/uploads/new/facebook-logo-in-circular-button-outlined-social-symbol.png"
                                style={{
                                  display: "inline",
                                  verticalAlign: "middle",
                                  paddingBottom: "5px",
                                }}
                                width="20px"
                              />
                              &nbsp; Oxy Esztétikai Stúdió
                            </p>
                          </button>
                        </a>
                      </li>
                      <li className="windows-store">
                        <a
                          href="tel:+36304642297"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#b18b5e" }}
                        >
                          <button className="button round large">
                            <p>
                              <img
                                src="/wp-content/uploads/new/smartphone-call.png"
                                style={{
                                  display: "inline",
                                  verticalAlign: "middle",
                                  paddingBottom: "5px",
                                }}
                                width="20px"
                              />{" "}
                              &nbsp;{" "}
                              <a style={{ color: "#b18b5e" }}>06 30 464 2297</a>
                            </p>
                          </button>
                        </a>
                      </li>
                    </ul>
                    <br />
                    <p className="lead">
                      <br />
                      <br />
                      <br />
                      Az InfraTrainer maximálisan biztonságos, ezért akár idősek
                      vagy magas vérnyomásban szenvedők is használhatják,
                      továbbá nem igényel különleges fizikai felkészültséget.
                    </p>
                  </div>
                  {/* /cta-content */}
                </section>
                {/* /cta */}
                {/* pricing
   ================================================== */}
                <section id="pricing">
                  <div className="row section-intro">
                    <div className="col-twelve with-bottom-line">
                      <h5 />
                      <h1>Árak</h1>
                    </div>
                  </div>
                  <div className="row pricing-content">
                    <div
                      className="pricing-tables block-1-4 group"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        flexWrap: "wrap",
                      }}
                    >
                      {/* /price-block */}
                      <div className="bgrid">
                        <div className="price-block">
                          <div className="top-part">
                            <h3 className="plan-title">50 perces edzés</h3>
                            <p className="plan-price">
                              5000 <sup>FT</sup>
                            </p>
                            <p className="price-month">&nbsp;</p>
                            <p className="price-month">&nbsp;</p>
                          </div>
                        </div>
                      </div>
                      {/* /price-block */}
                      <div className="bgrid">
                        <div className="price-block">
                          <div className="top-part">
                            <h3 className="plan-title">5 alkalmas bérlet</h3>
                            <p className="plan-price">
                              23000 <sup>FT</sup>
                            </p>
                            <p className="price-month">
                              Megtakarítás 2000 forint
                            </p>
                            <p className="price-month">&nbsp;</p>
                          </div>
                        </div>
                      </div>
                      {/* /price-block */}
                      <div className="bgrid">
                        <div className="price-block">
                          <div className="top-part">
                            <h3 className="plan-title">10 alkalmas bérlet</h3>
                            <p className="plan-price">
                              45000 <sup>FT</sup>
                            </p>
                            <p className="price-month">
                              Megtakarítás 5000 forint
                            </p>
                            <p className="price-month">&nbsp;</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* /pricing-tables */}
                    <div style={{ paddingTop: "10px" }}>
                      <p className="lead" style={{ textAlign: "center" }}>
                        Felhívjuk kedves vendégeink figyelmét, hogy az időpontok
                        lemondása vagy módosítása díjmentesen 24 órával a
                        lefoglalt időpontot megelőzően lehetséges. Lemondásnál
                        használd az időpontodat visszaigazoló emailben található
                        "Foglalás részletek" nevű gombot, vagy a Salonic
                        fiókodat, vagy telefonon értesíts minket nyitvatartási
                        időben! Ha a már lefoglalt időpontod helyett másikat
                        szeretnél, akkor kérlek, első lépésben töröld a nem
                        megfelelő időpontot, és utána keress másikat! Az időpont
                        módosítása / lemondása is a visszaigazolással érvényes.
                      </p>
                      <p className="lead" style={{ textAlign: "center" }}>
                        Ha az időpont lemondása az előre lefoglalt időpont előtt
                        legkésőbb 1 nappal nem történik meg, vagy nem érkezel
                        meg az időpontra, vagy olyan mértékű késéssel érkezel,
                        hogy nem tudunk fogadni, akkor az ajándékutalvány /
                        bérlet esetében szereplő alkalmat felhasználtnak,
                        teljesítettnek tekintjük!
                      </p>
                    </div>
                  </div>
                  {/* /pricing-content */}
                  {/* /price-block */}
                </section>
              </div>
              <div
                className="fusion-fullwidth fullwidth-box fusion-builder-row-1 fusion-parallax-none nonhundred-percent-fullwidth non-hundred-percent-height-scrolling"
                style={{
                  backgroundImage:
                    'url("/wp-content/uploads/new/hifu-img-2-test.png")',
                  backgroundPosition: "center center",
                  backgroundRepeat: "no-repeat",
                  paddingTop: "450px",
                  paddingRight: "30px",
                  paddingBottom: "100px",
                  paddingLeft: "30px",
                  marginBottom: "0px",
                  borderWidth: "0px 0px 0px 0px",
                  borderColor: "#f7f7f7",
                  borderStyle: "solid",
                  WebkitBackgroundSize: "cover",
                  MozBackgroundSize: "cover",
                  OBackgroundSize: "cover",
                  backgroundSize: "cover",
                  marginTop: "0",
                }}
              >
                <div
                  className="fusion-builder-row fusion-row"
                  style={{ marginTop: "-190px" }}
                >
                  <div
                    className="fusion-column-wrapper fusion-flex-column-wrapper-legacy"
                    style={{ padding: "0px 0px 0px 0px" }}
                  >
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <div
                        className="fusion-animated shake"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: isMobileOnly ? "column" : "row",
                          backgroundColor: "rgba(215, 188, 178, 0.47)",
                          padding: "16px",
                          animationDuration: "1.6s",
                        }}
                        data-animationoffset="100%"
                        data-animationtype="shake"
                        data-animationduration="1.6"
                      >
                        <div
                          className="fusion-button-wrapper"
                          style={{
                            marginRight: isMobileOnly ? "0" : "60px",
                            marginBottom: isMobileOnly ? "20px" : "0",
                          }}
                        >
                          <style
                            type="text/css"
                            dangerouslySetInnerHTML={{
                              __html:
                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t.fusion-button.button-1 {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tborder-radius: 25px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t.fusion-button.button-1.button-3d {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t-webkit-box-shadow: inset 0px 1px 0px #fff, 0px 3px 0px rgba(142, 94, 54, 0.68), 1px 5px 5px 3px rgba(0, 0, 0, 0.3);\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t-moz-box-shadow: inset 0px 1px 0px #fff, 0px 3px 0px rgba(142, 94, 54, 0.68), 1px 5px 5px 3px rgba(0, 0, 0, 0.3);\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tbox-shadow: inset 0px 1px 0px #fff, 0px 3px 0px rgba(142, 94, 54, 0.68), 1px 5px 5px 3px rgba(0, 0, 0, 0.3);\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t.button-1.button-3d:active {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t-webkit-box-shadow: inset 0px 1px 0px #fff, 0px 3px 0px rgba(142, 94, 54, 0.68), 1px 5px 5px 3px rgba(0, 0, 0, 0.3);\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t-moz-box-shadow: inset 0px 1px 0px #fff, 0px 3px 0px rgba(142, 94, 54, 0.68), 1px 5px 5px 3px rgba(0, 0, 0, 0.3);\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tbox-shadow: inset 0px 1px 0px #fff, 0px 3px 0px rgba(142, 94, 54, 0.68), 1px 5px 5px 3px rgba(0, 0, 0, 0.3);\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t\t",
                            }}
                          />
                          <a
                            className="fusion-button button-3d fusion-button-default-size button-default button-1 fusion-button-span-no "
                            target="_blank"
                            rel="noopener noreferrer"
                            href="/shop"
                            style={{ width: isMobileOnly ? "100%" : "unset" }}
                          >
                            <span className="fusion-button-text">
                              Vásárláshoz kattints ide!
                            </span>
                          </a>
                        </div>
                        <div className="fusion-button-wrapper">
                          <style
                            type="text/css"
                            dangerouslySetInnerHTML={{
                              __html:
                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t.fusion-button.button-1 {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tborder-radius: 25px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t.fusion-button.button-1.button-3d {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t-webkit-box-shadow: inset 0px 1px 0px #fff, 0px 3px 0px rgba(142, 94, 54, 0.68), 1px 5px 5px 3px rgba(0, 0, 0, 0.3);\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t-moz-box-shadow: inset 0px 1px 0px #fff, 0px 3px 0px rgba(142, 94, 54, 0.68), 1px 5px 5px 3px rgba(0, 0, 0, 0.3);\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tbox-shadow: inset 0px 1px 0px #fff, 0px 3px 0px rgba(142, 94, 54, 0.68), 1px 5px 5px 3px rgba(0, 0, 0, 0.3);\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t.button-1.button-3d:active {\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t-webkit-box-shadow: inset 0px 1px 0px #fff, 0px 3px 0px rgba(142, 94, 54, 0.68), 1px 5px 5px 3px rgba(0, 0, 0, 0.3);\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t-moz-box-shadow: inset 0px 1px 0px #fff, 0px 3px 0px rgba(142, 94, 54, 0.68), 1px 5px 5px 3px rgba(0, 0, 0, 0.3);\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tbox-shadow: inset 0px 1px 0px #fff, 0px 3px 0px rgba(142, 94, 54, 0.68), 1px 5px 5px 3px rgba(0, 0, 0, 0.3);\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\t\t\t\t",
                            }}
                          />
                          <a
                            className="fusion-button button-3d fusion-button-default-size button-default button-1 fusion-button-span-no "
                            href="/arak/alakformalas"
                          >
                            <span className="fusion-button-text">
                              Árak megtekintéséhez kattints ide!
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state: ApplicationState) => state.oxy,
  OxyStore.actionCreators
)(InfraTrainer as any);
